var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Divider, FormHelperText, Grid, IconButton, TextField, Typography, styled, useMediaQuery } from "@mui/material";
import { GridAddIcon, GridRemoveIcon } from "@mui/x-data-grid-premium";
import { t } from "i18next";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Get } from "../../../api/api";
import { AutoFillPaidLabourUrl, CheckRepeatUrl, DeclinedJobConfigurationSettingURL, DeclinedJobReasonListUrl, PerodicPartsUrl, RepairTypeList, checkModelWisePeriodicPartURL, deleteAutoFetchPartURL, deleteRepeatChildsURL, estimateUpsertCustomerVoiceToJobItemUrl, estimateUpsertPeriodicPartsUrl, estimateUpsertPreJobCardAdditionalJobUrl, estimateUpsertStandardPartsUrl, getAdditionalJobsUrl, getCustomerComplaintPriceUrl, getCustomerDeclinedJobswithPriceUrl, getDeclinedCustomerComplaintsUrl, getDeclinedStandardJobs, getEstimatePeriodicPartUrl, getSavedJobItemsUrl, getStandardJobsUrl, getUnitOfMeasurementListUrl, getValidateQuantityAndGetTaxesUrl, saveDeclinedCustomerComplaintsUrl, saveDeclinedPmPartsURl } from "../../../api/url";
import { ChevronDownIcon, ChevronRightIcon, ChevronUpIcon, ReverseActionIcon, RoundClearIcon } from "../../../assets/customIcons";
import { CloseCircleBlackNew, CrossCircleRed } from "../../../assets/images";
import { MuiButton, MuiForm, MuiStack } from "../../../components";
import { MuiIconButton } from "../../../components/atoms/iconButtonComponent";
import { MuiLoaderButton } from "../../../components/atoms/loaderButton";
import { MuiSelectComponent } from "../../../components/atoms/muiSelectComponent";
import SkeletonLoader from "../../../components/atoms/sketeton";
import { EJobItemType, EModuleSection, ESectionAttributeValue, ESystemName, LOCAL_STORAGE_KEYS, Module, StatusEnum, isModuleConfig } from "../../../constants";
import { setPrecheckSectionDetails, setUpdatedModuleSectionByChannel, showLoader, showNotification } from "../../../redux/commonSlice";
import { createAPI, getByIdAPI, getListAPI, setState } from "../../../redux/crudSlice";
import { useAppSelector } from "../../../store/hooks";
import Colors from "../../../theme/colors";
import { gray, mobilenoblack, white } from "../../../theme/palette";
import { systemColor } from "../../../theme/systemColor";
import { getLocalStorageItem, setLocalStorageItem } from "../../../utils/storageHelper";
import useAnalyticsEventTracker from "../../../utils/useAnalyticsEventTracker";
import { GoogleAnlyticsErrorLog } from "../../../utils/utils";
import { REG } from "../../../utils/validationHelper";
import PartLabourDetailsDrawer from "../../commonViews/taskDetails/taskDetailsCommonComponent/partLabourDetailsDrawer";
import StandardJobsPartLabourDetailsDrawer from "../../commonViews/taskDetails/taskDetailsCommonComponent/standardJobsPartLabourDetailsDrawer";
import { debounce } from '@mui/material';
import { getInstallbaseDetailsAPICall } from "../../jobCardDetails/services/utils";
import { calculateEstimateCost } from "./serviceEstimateUtils";
var InputBox = styled(TextField)(function (_ref) {
    var theme = _ref.theme;
    return {
        "& fieldset": {
            border: '1px solid #DEE4EB',
            boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)'
        },
        "& .MuiInputBase-root.Mui-disabled": {
            "& > fieldset": {
                border: '1px solid #DEE4EB',
                boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)'
            },
            backgroundColor: "#F4F7FA",
            borderRadius: '8px'
        }
    };
});
var EditableData = {
    periodicMaintenance: false,
    customerComplaint: false,
    standardsJob: false,
    additionalJob: false
};
export default function MultipleAccordianCard(props) {
    var _this = this;
    var _documentDetailsGetBy, _updatedModuleSection, _updatedModuleSection2, _documentDetailsGetBy5;
    var trackButtonClick = useAnalyticsEventTracker("MultipleAccordianCard");
    var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
    var setCostValue = props.setCostValue, setAdditionalJobsByAPI = props.setAdditionalJobsByAPI, isDisabled = props.isDisabled, periodicPartDataCallBack = props.periodicPartDataCallBack, standardJobDataCallback = props.standardJobDataCallback, additionalJobDataCallback = props.additionalJobDataCallback, roadTestDataCallBack = props.roadTestDataCallBack, documentId = props.documentId, setAllJobs = props.setAllJobs, allJobs = props.allJobs, setIsPrintLoading = props.setIsPrintLoading, setAllSavedJobs = props.setAllSavedJobs, setHasUnsavedChanges = props.setHasUnsavedChanges;
    var dispatch = useDispatch();
    // const { documentId } = useParams()
    var _a = useState([]), periodicPartData = _a[0], setPeriodicPartData = _a[1];
    var _b = useState([]), standardJobData = _b[0], setStandardJobData = _b[1];
    var _c = useState([]), roadTestData = _c[0], setRoadTestData = _c[1];
    var _d = useState([]), additionalJobData = _d[0], setAdditionalJobData = _d[1];
    var _e = useState([]), customerComplaintData = _e[0], setCustomerComplaintData = _e[1];
    var _f = useState("Save"), periodicPartText = _f[0], setPeriodicPartText = _f[1];
    var _g = useState("Save"), standardJobText = _g[0], setStandardJobText = _g[1];
    var _h = useState("Save"), roadTestText = _h[0], setRoadTestText = _h[1];
    var _j = useState("Save"), customerComplainText = _j[0], setCustomerComplainText = _j[1];
    var _k = useState("Save"), additionalJobText = _k[0], setAdditionalJobText = _k[1];
    var _l = useState({
        AdditionalJob: false,
        PeriodicPart: false,
        CustomerComplaint: false,
        StandardJob: false,
        RoadTest: false
    }), disabledSave = _l[0], setDisabledSave = _l[1];
    var _m = useState(true), periodicSkeleton = _m[0], setPeriodicSkeleton = _m[1];
    var _o = useState(true), additionalSkeleton = _o[0], setAdditionalSkeleton = _o[1];
    var _p = useState(true), complaintSkeleton = _p[0], setComplaintSkeleton = _p[1];
    var _q = useState(true), standardJobSkeleton = _q[0], setStandardJobSkeleton = _q[1];
    var _r = useState(true), roadTestSkeleton = _r[0], setRoadTestSkeleton = _r[1];
    var _s = useState({}), openSections = _s[0], setOpenSections = _s[1];
    var _t = useState(EJobItemType.PeriodicMaintenance), jobType = _t[0], setJobType = _t[1];
    var _u = useAppSelector(function (state) { return state.crud; }), documentDetailsGetById = _u.documentDetailsGetById, installbaseDetailsById = _u.installbaseDetailsById;
    var _v = useSelector(function (state) { return state.common; }), updatedModuleSectionByChannel = _v.updatedModuleSectionByChannel, isMenuOpen = _v.isMenuOpen;
    var RevisedEstimate = useParams().RevisedEstimate;
    var regex = REG.validateDecimalAndNonNumeric;
    var _w = useState([]), rejectReasonRemarkList = _w[0], setRejectReasonRemarkList = _w[1];
    var _x = useState(false), isOpenRoadTest = _x[0], setIsOpenRoadTest = _x[1];
    var _y = useState(false), isOpenCustomerComplaint = _y[0], setIsOpenCustomerComplaint = _y[1];
    var _z = useState([]), removedOilParts = _z[0], setRemovedOilParts = _z[1];
    var _0 = useState([]), additionalJobsOilParts = _0[0], setAdditonalJobsOilParts = _0[1];
    var _1 = useState(false), isOpenJobItemDetailsDrawer = _1[0], setIsOpenJobItemDetailsDrawer = _1[1];
    var _2 = useState(false), isOpenStandardJobDetailsDrawer = _2[0], setIsOpenStandardJobDetailsDrawer = _2[1];
    var _3 = useState(-1), drawerGroupIndex = _3[0], setDrawerGroupIndex = _3[1];
    var _4 = useState(null), selectedJobItemDetails = _4[0], setSelectedJobItemDetails = _4[1];
    var _5 = useState(''), selectedJobItemType = _5[0], setSelectedJobItemType = _5[1];
    var _6 = useState(), selectedStandardJobItemDetails = _6[0], setSelectedStandardJobItemDetails = _6[1];
    var _7 = useState(), moduleSection = _7[0], setModuleSection = _7[1];
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var disableRejectItem = [StatusEnum.Approved, StatusEnum.Cancelled, StatusEnum.Closed, StatusEnum.Converted].includes((documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy = documentDetailsGetById.data) === null || _documentDetailsGetBy === void 0 ? void 0 : _documentDetailsGetBy.Key) || "");
    var IS_DESKTOP_BREAKPOINT = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var IS_DESKTOP = isMenuOpen ? false : IS_DESKTOP_BREAKPOINT;
    // const IS_DESKTOP = useMediaQuery((theme: any) => theme.breakpoints.up("md"));
    var isXsBreakPoint = useMediaQuery('(max-width:600px)');
    var isXs = isMenuOpen ? true : isXsBreakPoint;
    var IsShowGroupItem = (_updatedModuleSection = updatedModuleSectionByChannel === null || updatedModuleSectionByChannel === void 0 || (_updatedModuleSection2 = updatedModuleSectionByChannel.find(function (it) { return (it === null || it === void 0 ? void 0 : it.Key) === EModuleSection.StandardJobs; })) === null || _updatedModuleSection2 === void 0 || (_updatedModuleSection2 = _updatedModuleSection2.Section) === null || _updatedModuleSection2 === void 0 ? void 0 : _updatedModuleSection2.IsShowGroupItem) !== null && _updatedModuleSection !== void 0 ? _updatedModuleSection : true;
    var declinedJobsConfiguration = getLocalStorageItem(LOCAL_STORAGE_KEYS.REVISED_ESTIMATE_DECLINED_JOB_CONFIGURATION);
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    useEffect(function () {
        getInitialData();
        getRejectRemarkList();
        getDeclineJobConfig();
    }, []);
    useEffect(function () {
        var _documentDetailsGetBy2, _documentDetailsGetBy3, _documentDetailsGetBy4;
        if (documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy2 = documentDetailsGetById.data) !== null && _documentDetailsGetBy2 !== void 0 && _documentDetailsGetBy2.InstallBaseId)
            getInstallbaseDetailsAPICall((_documentDetailsGetBy3 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy4 = documentDetailsGetById.data) === null || _documentDetailsGetBy4 === void 0 ? void 0 : _documentDetailsGetBy4.InstallBaseId) !== null && _documentDetailsGetBy3 !== void 0 ? _documentDetailsGetBy3 : '');
    }, [documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy5 = documentDetailsGetById.data) === null || _documentDetailsGetBy5 === void 0 ? void 0 : _documentDetailsGetBy5.InstallBaseId]);
    useEffect(function () {
        if (documentDetailsGetById !== null && documentDetailsGetById !== void 0 && documentDetailsGetById.data && (updatedModuleSectionByChannel === null || updatedModuleSectionByChannel === void 0 ? void 0 : updatedModuleSectionByChannel.length) > 0) {
            getEstimateSummary();
            getServiceTypesList();
            getUOMList();
        }
    }, [(documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data) && updatedModuleSectionByChannel.length > 0]);
    useEffect(function () {
        var activeLoaders = [];
        if ((updatedModuleSectionByChannel === null || updatedModuleSectionByChannel === void 0 ? void 0 : updatedModuleSectionByChannel.length) > 0) {
            updatedModuleSectionByChannel.forEach(function (item) {
                var _item$SectionAttribut, _item$SectionAttribut2, _item$SectionAttribut3, _item$SectionAttribut4, _item$SectionAttribut5;
                if ((item === null || item === void 0 ? void 0 : item.Key) === EModuleSection.PeriodicMaintenance && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut = item.SectionAttributes[0]) !== null && _item$SectionAttribut !== void 0 && _item$SectionAttribut.HIDE)) {
                    activeLoaders.push(periodicSkeleton);
                }
                else if ((item === null || item === void 0 ? void 0 : item.Key) === EModuleSection.StandardJobs && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut2 = item.SectionAttributes[0]) !== null && _item$SectionAttribut2 !== void 0 && _item$SectionAttribut2.HIDE)) {
                    activeLoaders.push(standardJobSkeleton);
                }
                else if ((item === null || item === void 0 ? void 0 : item.Key) === EModuleSection.RoadTest && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut3 = item.SectionAttributes[0]) !== null && _item$SectionAttribut3 !== void 0 && _item$SectionAttribut3.HIDE) && Module === isModuleConfig.Product) {
                    activeLoaders.push(roadTestSkeleton);
                }
                else if ((item === null || item === void 0 ? void 0 : item.Key) === EModuleSection.AdditionalJobs && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut4 = item.SectionAttributes[0]) !== null && _item$SectionAttribut4 !== void 0 && _item$SectionAttribut4.HIDE)) {
                    activeLoaders.push(additionalSkeleton);
                }
                else if ((item === null || item === void 0 ? void 0 : item.Key) === EModuleSection.RoadTestAndCustomerComplaint && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut5 = item.SectionAttributes[0]) !== null && _item$SectionAttribut5 !== void 0 && _item$SectionAttribut5.HIDE) && Module === isModuleConfig.Bajaj) {
                    activeLoaders.push(roadTestSkeleton);
                }
            });
        }
        var isAnyActiveLoaderLoading = activeLoaders.some(function (loader) { return loader === true; });
        setIsPrintLoading(isAnyActiveLoaderLoading);
    }, [periodicSkeleton, additionalSkeleton, standardJobSkeleton, roadTestSkeleton, updatedModuleSectionByChannel, Module]);
    var updateAdditionalJobs = function (updatedList) {
        setAdditionalJobData(updatedList);
        setAllJobs(function (allJobs) {
            return _objectSpread(_objectSpread({}, allJobs), {}, {
                additionalJobs: updatedList.filter(function (item) { return !item.isExpanded; })
            });
        });
        calculateJobCost(_objectSpread(_objectSpread({}, allJobs), {}, {
            additionalJobs: updatedList.filter(function (item) { return !item.isExpanded; })
        }), roadTestData);
    };
    var updatePeriodicPartData = function (updatedList) {
        setPeriodicPartData(updatedList);
        setAllJobs(function (allJobs) {
            return _objectSpread(_objectSpread({}, allJobs), {}, {
                periodicJobs: updatedList.filter(function (item) { return !item.isExpanded; })
            });
        });
        calculateJobCost(_objectSpread(_objectSpread({}, allJobs), {}, {
            periodicJobs: updatedList.filter(function (item) { return !item.isExpanded; })
        }), roadTestData);
    };
    var updateStandardJobData = function (updatedList) {
        var allParts = updatedList === null || updatedList === void 0 ? void 0 : updatedList.flatMap(function (flatMapitem) {
            var _flatMapitem$Standard;
            if (flatMapitem !== null && flatMapitem !== void 0 && flatMapitem.isExpanded)
                return [];
            return (flatMapitem === null || flatMapitem === void 0 || (_flatMapitem$Standard = flatMapitem.StandardParts) === null || _flatMapitem$Standard === void 0 || (_flatMapitem$Standard = _flatMapitem$Standard.Part) === null || _flatMapitem$Standard === void 0 ? void 0 : _flatMapitem$Standard.filter(function (item) { return !(item !== null && item !== void 0 && item.isExpanded); })) || [];
        });
        var allLabour = updatedList === null || updatedList === void 0 ? void 0 : updatedList.flatMap(function (flatMapitem) {
            var _flatMapitem$Standard2;
            if (flatMapitem !== null && flatMapitem !== void 0 && flatMapitem.isExpanded)
                return [];
            return (flatMapitem === null || flatMapitem === void 0 || (_flatMapitem$Standard2 = flatMapitem.StandardParts) === null || _flatMapitem$Standard2 === void 0 || (_flatMapitem$Standard2 = _flatMapitem$Standard2.Labour) === null || _flatMapitem$Standard2 === void 0 ? void 0 : _flatMapitem$Standard2.filter(function (item) { return !(item !== null && item !== void 0 && item.isExpanded); })) || [];
        });
        setStandardJobData(updatedList);
        setAllJobs(function (allJobs) {
            return _objectSpread(_objectSpread({}, allJobs), {}, {
                standardJobs: __spreadArray(__spreadArray([], allParts, true), allLabour, true)
            });
        });
        calculateJobCost(_objectSpread(_objectSpread({}, allJobs), {}, {
            standardJobs: __spreadArray(__spreadArray([], allParts, true), allLabour, true)
        }), roadTestData);
    };
    var getEstimateSummary = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, AutoFillLabourAPICall()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, getAllFeatureData()];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var getServiceTypesList = function () { return __awaiter(_this, void 0, void 0, function () {
        var _documentDetailsGetBy6, _repairType$payload, _repairType$payload2, request, _documentDetailsGetBy7, repairType, _repairType$payload3, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    request = {
                        ModuleEntityId: ESystemName.Estimate,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    if (documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy6 = documentDetailsGetById.data) !== null && _documentDetailsGetBy6 !== void 0 && _documentDetailsGetBy6.ProductId) {
                        request.ProductId = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy7 = documentDetailsGetById.data) === null || _documentDetailsGetBy7 === void 0 ? void 0 : _documentDetailsGetBy7.ProductId;
                    }
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "serviceTypeList",
                            url: RepairTypeList,
                            request: request
                        }))];
                case 1:
                    repairType = _a.sent();
                    if ((repairType === null || repairType === void 0 || (_repairType$payload = repairType.payload) === null || _repairType$payload === void 0 || (_repairType$payload = _repairType$payload.value) === null || _repairType$payload === void 0 ? void 0 : _repairType$payload.statusCode) == 200 || repairType !== null && repairType !== void 0 && (_repairType$payload2 = repairType.payload) !== null && _repairType$payload2 !== void 0 && (_repairType$payload2 = _repairType$payload2.value) !== null && _repairType$payload2 !== void 0 && _repairType$payload2.success) {
                        return [2 /*return*/, repairType === null || repairType === void 0 || (_repairType$payload3 = repairType.payload) === null || _repairType$payload3 === void 0 || (_repairType$payload3 = _repairType$payload3.value) === null || _repairType$payload3 === void 0 ? void 0 : _repairType$payload3.data];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    console.error("Error fetching repair types:", e_1);
                    return [2 /*return*/, []];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getUOMList = function () { return __awaiter(_this, void 0, void 0, function () {
        var _documentDetailsGetBy8, request, _documentDetailsGetBy9, UOMList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        ModuleEntityId: ESystemName.Estimate,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    if (documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy8 = documentDetailsGetById.data) !== null && _documentDetailsGetBy8 !== void 0 && _documentDetailsGetBy8.ProductId) {
                        request.ProductId = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy9 = documentDetailsGetById.data) === null || _documentDetailsGetBy9 === void 0 ? void 0 : _documentDetailsGetBy9.ProductId;
                    }
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "UOMList",
                            url: getUnitOfMeasurementListUrl
                        }))];
                case 1:
                    UOMList = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var getDeclineJobConfig = function () { return __awaiter(_this, void 0, void 0, function () {
        var _result$payload, _result$payload2, request, result, _result$payload3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        OrganizationId: selectedBranch.OrganizationId,
                        SystemName: RevisedEstimate ? ESystemName.RevisedEstimate : ESystemName.Estimate
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "declinedJobConfiguration",
                            url: DeclinedJobConfigurationSettingURL,
                            request: request
                        }))];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload = result.payload) !== null && _result$payload !== void 0 && (_result$payload = _result$payload.value) !== null && _result$payload !== void 0 && _result$payload.success && result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && (_result$payload2 = _result$payload2.value) !== null && _result$payload2 !== void 0 && _result$payload2.data) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS === null || LOCAL_STORAGE_KEYS === void 0 ? void 0 : LOCAL_STORAGE_KEYS.REVISED_ESTIMATE_DECLINED_JOB_CONFIGURATION, result === null || result === void 0 || (_result$payload3 = result.payload) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.value) === null || _result$payload3 === void 0 ? void 0 : _result$payload3.data);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var AutoFillLabourAPICall = function () { return __awaiter(_this, void 0, void 0, function () {
        var _documentDetailsGetBy10, _documentDetailsGetBy11, _documentDetailsGetBy12, url, requestBody, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!RevisedEstimate) return [3 /*break*/, 2];
                    url = AutoFillPaidLabourUrl;
                    requestBody = {
                        "PreJobCardDocumentId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy10 = documentDetailsGetById.data) === null || _documentDetailsGetBy10 === void 0 ? void 0 : _documentDetailsGetBy10.EstimateId,
                        "ProductId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy11 = documentDetailsGetById.data) === null || _documentDetailsGetBy11 === void 0 ? void 0 : _documentDetailsGetBy11.ProductId,
                        "RepairTypeId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy12 = documentDetailsGetById.data) === null || _documentDetailsGetBy12 === void 0 ? void 0 : _documentDetailsGetBy12.RepairTypeId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: url,
                            request: requestBody
                        }))];
                case 1:
                    response = _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var formatData = function (precheckChildSections) {
        var updatedList = [];
        precheckChildSections.map(function (item) {
            var newObj = Object.assign({}, item, item === null || item === void 0 ? void 0 : item.Section);
            delete newObj.Section;
            updatedList.push(_objectSpread(_objectSpread({}, newObj), {}, {
                isAccordianOpen: false
            }));
        });
        var obj = {};
        var newArray = [];
        var finalModuleSectionArray = [];
        var res = updatedList.map(function (elem) {
            var newSectionAttribute = elem.SectionAttributes;
            var mergedObj = null;
            var newAttribute = newSectionAttribute && newSectionAttribute.map(function (el) {
                if (el !== null && el !== void 0 && el.Key && !el.IsDeleted) {
                    obj[el.Key] = el.Value === ESectionAttributeValue.ON ? true : false;
                    obj[el.Key + "DefaultValue"] = el.DefaultValue === ESectionAttributeValue.ON ? true : false;
                    mergedObj = _objectSpread(_objectSpread({}, el), obj);
                }
            });
            if (mergedObj) {
                newArray.push(mergedObj);
            }
            obj = {};
            delete elem.SectionAttributes;
            elem['SectionAttributes'] = [];
            newArray.forEach(function (value) {
                newSectionAttribute.forEach(function (value1) {
                    if (value.id == value1.id) {
                        elem.SectionAttributes.push(value);
                    }
                });
            });
            finalModuleSectionArray.push(elem);
        });
        return finalModuleSectionArray;
    };
    var setPrecheckChildSectionDetails = function (precheckSection) {
        var _precheckSection$Chil;
        var precheckChildSections = (_precheckSection$Chil = precheckSection === null || precheckSection === void 0 ? void 0 : precheckSection.ChildSections) !== null && _precheckSection$Chil !== void 0 ? _precheckSection$Chil : [];
        var updatedList = [];
        precheckChildSections.map(function (item) {
            var newObj = Object.assign({}, item, item.Section);
            delete newObj.Section;
            updatedList.push(_objectSpread(_objectSpread({}, newObj), {}, {
                isAccordianOpen: false
            }));
        });
        var obj = {};
        var newArray = [];
        var finalModuleSectionArray = [];
        var res = updatedList.map(function (elem) {
            var newSectionAttribute = elem.SectionAttributes;
            var mergedObj = null;
            var newAttribute = newSectionAttribute.map(function (el) {
                if (el !== null && el !== void 0 && el.Key && !el.IsDeleted) {
                    obj[el.Key] = el.Value === ESectionAttributeValue.ON ? true : false;
                    obj[el.Key + "DefaultValue"] = el.DefaultValue === ESectionAttributeValue.ON ? true : false;
                    mergedObj = _objectSpread(_objectSpread({}, el), obj);
                }
            });
            if (mergedObj) {
                newArray.push(mergedObj);
            }
            obj = {};
            delete elem.SectionAttributes;
            elem['SectionAttributes'] = [];
            newArray.forEach(function (value) {
                newSectionAttribute.forEach(function (value1) {
                    if (value.id == value1.id) {
                        elem.SectionAttributes.push(value);
                    }
                });
            });
            finalModuleSectionArray.push(elem);
        });
        var sortedArray = finalModuleSectionArray === null || finalModuleSectionArray === void 0 ? void 0 : finalModuleSectionArray.sort(function (a, b) { return a.Sequence - b.Sequence; });
        var precheckSectionFormated = formatData([precheckSection]);
        dispatch(setPrecheckSectionDetails(_objectSpread(_objectSpread({}, precheckSectionFormated[0]), {}, {
            ChildSections: sortedArray
        })));
    };
    var getInitialData = function () { return __awaiter(_this, void 0, void 0, function () {
        var data, updatedList_1, obj_1, newArray_1, finalModuleSectionArray_1, res, sortedArray, finalSortedArray, precheckSection;
        return __generator(this, function (_a) {
            try {
                data = RevisedEstimate ? getLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_REVISEDESTIMATE) : getLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_ESTIMATE);
                if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
                    updatedList_1 = [];
                    data === null || data === void 0 || data.map(function (item) {
                        var newObj = Object.assign({}, item, item.Section);
                        delete newObj.Section;
                        updatedList_1.push(_objectSpread(_objectSpread({}, newObj), {}, {
                            isAccordianOpen: false
                        }));
                    });
                    obj_1 = {};
                    newArray_1 = [];
                    finalModuleSectionArray_1 = [];
                    res = updatedList_1.map(function (elem) {
                        var newSectionAttribute = elem.SectionAttributes;
                        var mergedObj = null;
                        var newAttribute = newSectionAttribute.map(function (el) {
                            if (el !== null && el !== void 0 && el.Key && !el.IsDeleted) {
                                obj_1[el.Key] = el.Value === ESectionAttributeValue.ON ? true : false;
                                obj_1[el.Key + "DefaultValue"] = el.DefaultValue === ESectionAttributeValue.ON ? true : false;
                                mergedObj = _objectSpread(_objectSpread({}, el), obj_1);
                            }
                        });
                        if (mergedObj) {
                            newArray_1.push(mergedObj);
                        }
                        obj_1 = {};
                        delete elem.SectionAttributes;
                        elem['SectionAttributes'] = [];
                        newArray_1.forEach(function (value) {
                            newSectionAttribute.forEach(function (value1) {
                                if (value.id == value1.id) {
                                    elem.SectionAttributes.push(value);
                                }
                            });
                        });
                        finalModuleSectionArray_1.push(elem);
                    });
                    sortedArray = finalModuleSectionArray_1 === null || finalModuleSectionArray_1 === void 0 ? void 0 : finalModuleSectionArray_1.sort(function (a, b) { return a.Sequence - b.Sequence; });
                    finalSortedArray = sortedArray === null || sortedArray === void 0 ? void 0 : sortedArray.filter(function (a, b) {
                        var _a$SectionAttributes$;
                        return !(a !== null && a !== void 0 && (_a$SectionAttributes$ = a.SectionAttributes[0]) !== null && _a$SectionAttributes$ !== void 0 && _a$SectionAttributes$.HIDE);
                    });
                    dispatch(setUpdatedModuleSectionByChannel(finalSortedArray));
                    precheckSection = data === null || data === void 0 ? void 0 : data.find(function (item) {
                        var _item$Section;
                        return (item === null || item === void 0 || (_item$Section = item.Section) === null || _item$Section === void 0 ? void 0 : _item$Section.Key) === EModuleSection.Precheck;
                    });
                    setPrecheckChildSectionDetails(precheckSection);
                }
                // }
            }
            catch (e) {
                console.error("Error-", e);
            }
            return [2 /*return*/];
        });
    }); };
    var getAllFeatureData = function () {
        dispatch(showLoader({
            isLoaderOpen: true
        }));
        if ((updatedModuleSectionByChannel === null || updatedModuleSectionByChannel === void 0 ? void 0 : updatedModuleSectionByChannel.length) > 0) {
            updatedModuleSectionByChannel === null || updatedModuleSectionByChannel === void 0 || updatedModuleSectionByChannel.forEach(function (item) {
                var _item$SectionAttribut6, _item$SectionAttribut7, _item$SectionAttribut8, _item$SectionAttribut9, _item$SectionAttribut10, _item$SectionAttribut11;
                if ((item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.PeriodicMaintenance && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut6 = item.SectionAttributes[0]) !== null && _item$SectionAttribut6 !== void 0 && _item$SectionAttribut6.HIDE)) {
                    getEstimatePeriodicPart();
                }
                else if ((item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.CustomerVoice && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut7 = item.SectionAttributes[0]) !== null && _item$SectionAttribut7 !== void 0 && _item$SectionAttribut7.HIDE) && Module === isModuleConfig.Product) {
                    getCustomerComplaint();
                }
                else if ((item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.StandardJobs && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut8 = item.SectionAttributes[0]) !== null && _item$SectionAttribut8 !== void 0 && _item$SectionAttribut8.HIDE)) {
                    getStandardJob();
                }
                else if ((item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.RoadTest && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut9 = item.SectionAttributes[0]) !== null && _item$SectionAttribut9 !== void 0 && _item$SectionAttribut9.HIDE) && Module === isModuleConfig.Product) {
                    getRoadTest();
                }
                else if ((item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.AdditionalJobs && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut10 = item.SectionAttributes[0]) !== null && _item$SectionAttribut10 !== void 0 && _item$SectionAttribut10.HIDE)) {
                    getAdditionalJob();
                }
                else if ((item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.RoadTestAndCustomerComplaint && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut11 = item.SectionAttributes[0]) !== null && _item$SectionAttribut11 !== void 0 && _item$SectionAttribut11.HIDE) && Module === isModuleConfig.Bajaj) {
                    getRoadTest();
                }
            });
        }
        dispatch(showLoader({
            isLoaderOpen: false
        }));
    };
    var isObjectEmpty = function (objectName) {
        return Object.keys(objectName).length === 0;
    };
    useEffect(function () {
        calculateJobCost(allJobs, roadTestData);
    }, [roadTestData, allJobs]);
    // useEffect(() => setEstimateCost(totalEstimateCost), [totalEstimateCost]);
    // const calculateJobCost = () => {
    //   let cost = 0;
    //   let labourCost = 0;
    //   let partCost = 0;
    //   let autoPopulateLabourCost = 0
    //   let autoPopulatePartCost = 0
    //   let declinedAdditionalJobs: any[] = [];
    //   periodicPartData?.forEach((element: any) => {
    //     if (!element.isExpanded) {
    //       if (element?.jobType == "Labour" && element?.SelectedPriceDetails?.Amount) {
    //         labourCost += Number(element?.SelectedPriceDetails?.Amount);
    //       } else if (element?.SelectedPriceDetails?.Amount) {
    //         partCost += Number(element?.SelectedPriceDetails?.Amount);
    //       }
    //     }
    //   });
    //   roadTestData?.forEach((element: any) => {
    //     if (!element.isExpanded) {
    //       if (element?.LabourPrice) {
    //         labourCost += Number(element?.LabourPrice);
    //       }
    //       if (element?.PartPrice) {
    //         partCost += Number(element?.PartPrice);
    //       }
    //     }
    //   });
    //   standardJobData?.forEach((element: any) => {
    //     if (!element.isExpanded) {
    //       let partPrice = 0;
    //       let labourPrice = 0;
    //       // Sum up the part prices
    //       if (element.StandardParts && element.StandardParts.Part) {
    //         partPrice = element.StandardParts.Part.reduce((sum: any, part: any) =>
    //           sum + (part.SelectedPriceDetails?.Amount || 0), 0);
    //       }
    //       // Sum up the labour prices
    //       if (element.StandardParts && element.StandardParts.Labour) {
    //         labourPrice = element.StandardParts.Labour.reduce((sum: any, labour: any) =>
    //           sum + (labour.SelectedPriceDetails?.Amount || 0), 0);
    //       }
    //       console.log("labourPrice", labourPrice);
    //       console.log("partPrice", partPrice);
    //       // if (element?.LabourPrice) {
    //       labourCost += Number(labourPrice);
    //       // }
    //       // if (element?.PartPrice) {
    //       partCost += Number(partPrice);
    //       // }
    //     }
    //   });
    //   additionalJobData.forEach((element: any) => {
    //     if (!element.isExpanded) {
    //       if (element.AutofillType !== 2) {
    //         if (element?.jobType == "Labour" && element?.SelectedPriceDetails?.Amount) {
    //           labourCost += Number(element?.SelectedPriceDetails?.Amount);
    //         } else if (element?.SelectedPriceDetails?.Amount) {
    //           partCost += Number(element?.SelectedPriceDetails?.Amount);
    //         }
    //       } else {
    //         if (element?.jobType == "Labour" && element?.SelectedPriceDetails?.Amount) {
    //           autoPopulateLabourCost += Number(element?.SelectedPriceDetails?.Amount);
    //         } else if (element?.SelectedPriceDetails?.Amount) {
    //           autoPopulatePartCost += Number(element?.SelectedPriceDetails?.Amount);
    //         }
    //       }
    //     }
    //     declinedAdditionalJobs.push(element);
    //   });
    //   cost += labourCost + partCost;
    //   seEstimateCostToShowOnUI(cost);
    //   setCostValue(labourCost, partCost, cost, autoPopulateLabourCost, autoPopulatePartCost, declinedAdditionalJobs);
    // };
    var calculateJobCost = function (allJobs, roadTestData) {
        var _a = calculateEstimateCost(allJobs, roadTestData), cost = _a.cost, labourCost = _a.labourCost, partCost = _a.partCost, autoPopulateLabourCost = _a.autoPopulateLabourCost, autoPopulatePartCost = _a.autoPopulatePartCost, declinedAdditionalJobs = _a.declinedAdditionalJobs;
        setCostValue(labourCost, partCost, cost, autoPopulateLabourCost, autoPopulatePartCost, declinedAdditionalJobs);
        return {
            cost: cost
        };
    };
    var getEstimatePeriodicPart = function () { return __awaiter(_this, void 0, void 0, function () {
        var _documentDetailsGetBy13, _documentDetailsGetBy14, _documentDetailsGetBy15, _documentDetailsGetBy16, _documentDetailsGetBy17, _documentDetailsGetBy18, _documentDetailsGetBy19, _documentDetailsGetBy20, _savedPmPartsResponse, _savedPmPartsResponse2, masterRequestBody, savedRequestBody, declineJobRequestBody, _a, masterResponse, savedPmPartsResponsed, declinedPmPartsResponse, savedPmPartsList, _savedPmPartsResponse3, periodicParts, _periodicParts$Labour, _periodicParts$Part, _masterResponse$paylo, _masterResponse$paylo2, _declinedPmPartsRespo, _declinedPmPartsRespo2, masterPmPartsList_1, _declinedPmPartsRespo3, _declinedPmPartsRespo4, _declinedPmPartsRespo5, _declinedPmPartsRespo6, declinedParts, declinedLabours, declinesPmParts_1, finalList_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    masterRequestBody = {
                        "Usage": Number(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy13 = documentDetailsGetById.data) === null || _documentDetailsGetBy13 === void 0 ? void 0 : _documentDetailsGetBy13.ODOMeterReading),
                        "VinNo": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy14 = documentDetailsGetById.data) === null || _documentDetailsGetBy14 === void 0 ? void 0 : _documentDetailsGetBy14.VinNo,
                        "RepairTypeId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy15 = documentDetailsGetById.data) === null || _documentDetailsGetBy15 === void 0 ? void 0 : _documentDetailsGetBy15.RepairTypeId,
                        "OrganizationId": selectedBranch.OrganizationId,
                        "InstallBaseId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy16 = documentDetailsGetById.data) === null || _documentDetailsGetBy16 === void 0 ? void 0 : _documentDetailsGetBy16.InstallBaseId,
                        "PreJobCardDocumentId": documentId,
                        "Entity": ESystemName.Estimate
                    };
                    savedRequestBody = {
                        EstimateId: documentId,
                        OrganizationId: selectedBranch.OrganizationId,
                        VinNo: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy17 = documentDetailsGetById.data) === null || _documentDetailsGetBy17 === void 0 ? void 0 : _documentDetailsGetBy17.VinNo,
                        RepairTypeId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy18 = documentDetailsGetById.data) === null || _documentDetailsGetBy18 === void 0 ? void 0 : _documentDetailsGetBy18.RepairTypeId
                    };
                    declineJobRequestBody = {
                        "ParentId": documentId,
                        "InstallBaseId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy19 = documentDetailsGetById.data) === null || _documentDetailsGetBy19 === void 0 ? void 0 : _documentDetailsGetBy19.InstallBaseId,
                        "ServiceDetailType": 3,
                        OrganizationId: selectedBranch.OrganizationId,
                        VinNo: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy20 = documentDetailsGetById.data) === null || _documentDetailsGetBy20 === void 0 ? void 0 : _documentDetailsGetBy20.VinNo,
                        Entity: ESystemName.Estimate
                    };
                    return [4 /*yield*/, Promise.all([dispatch(getListAPI({
                                key: "",
                                url: PerodicPartsUrl,
                                request: masterRequestBody
                            })), dispatch(getByIdAPI({
                                key: "",
                                url: "".concat(getEstimatePeriodicPartUrl),
                                request: savedRequestBody
                            })), dispatch(getListAPI({
                                key: "",
                                url: getCustomerDeclinedJobswithPriceUrl,
                                request: declineJobRequestBody
                            }))])];
                case 1:
                    _a = _b.sent(), masterResponse = _a[0], savedPmPartsResponsed = _a[1], declinedPmPartsResponse = _a[2];
                    savedPmPartsList = [];
                    if (savedPmPartsResponsed !== null && savedPmPartsResponsed !== void 0 && (_savedPmPartsResponse = savedPmPartsResponsed.payload) !== null && _savedPmPartsResponse !== void 0 && _savedPmPartsResponse.success && (savedPmPartsResponsed === null || savedPmPartsResponsed === void 0 || (_savedPmPartsResponse2 = savedPmPartsResponsed.payload) === null || _savedPmPartsResponse2 === void 0 ? void 0 : _savedPmPartsResponse2.statusCode) === 200) {
                        periodicParts = savedPmPartsResponsed === null || savedPmPartsResponsed === void 0 || (_savedPmPartsResponse3 = savedPmPartsResponsed.payload) === null || _savedPmPartsResponse3 === void 0 || (_savedPmPartsResponse3 = _savedPmPartsResponse3.data) === null || _savedPmPartsResponse3 === void 0 ? void 0 : _savedPmPartsResponse3.PeriodicParts;
                        if (periodicParts !== null && periodicParts !== void 0 && periodicParts.Labour) {
                            periodicParts === null || periodicParts === void 0 || (_periodicParts$Labour = periodicParts.Labour) === null || _periodicParts$Labour === void 0 || _periodicParts$Labour.forEach(function (element) { return savedPmPartsList.push(_objectSpread(_objectSpread({}, element), {}, {
                                jobType: "Labour"
                            })); });
                        }
                        if (periodicParts !== null && periodicParts !== void 0 && periodicParts.Part) {
                            periodicParts === null || periodicParts === void 0 || (_periodicParts$Part = periodicParts.Part) === null || _periodicParts$Part === void 0 || _periodicParts$Part.forEach(function (element) { return savedPmPartsList.push(_objectSpread(_objectSpread({}, element), {}, {
                                jobType: "Part"
                            })); });
                        }
                    }
                    if (masterResponse.payload.value.success && masterResponse.payload.value.data) {
                        masterPmPartsList_1 = [];
                        (_masterResponse$paylo = masterResponse.payload.value.data) === null || _masterResponse$paylo === void 0 || (_masterResponse$paylo = _masterResponse$paylo.Labour) === null || _masterResponse$paylo === void 0 || _masterResponse$paylo.map(function (item) {
                            var updatedItem = _objectSpread({}, item);
                            updatedItem.jobType = "Labour";
                            updatedItem.isExpanded = false;
                            masterPmPartsList_1.push(updatedItem);
                        });
                        (_masterResponse$paylo2 = masterResponse.payload.value.data) === null || _masterResponse$paylo2 === void 0 || (_masterResponse$paylo2 = _masterResponse$paylo2.Part) === null || _masterResponse$paylo2 === void 0 || _masterResponse$paylo2.map(function (item) {
                            var updatedItem = _objectSpread({}, item);
                            updatedItem.jobType = "Part";
                            updatedItem.isExpanded = false;
                            masterPmPartsList_1.push(updatedItem);
                        });
                        // setPmPartsMasterList(masterPmPartsList)
                        if ((_declinedPmPartsRespo = declinedPmPartsResponse.payload) !== null && _declinedPmPartsRespo !== void 0 && (_declinedPmPartsRespo = _declinedPmPartsRespo.value) !== null && _declinedPmPartsRespo !== void 0 && _declinedPmPartsRespo.success && (_declinedPmPartsRespo2 = declinedPmPartsResponse.payload) !== null && _declinedPmPartsRespo2 !== void 0 && (_declinedPmPartsRespo2 = _declinedPmPartsRespo2.value) !== null && _declinedPmPartsRespo2 !== void 0 && _declinedPmPartsRespo2.data) {
                            declinedParts = (_declinedPmPartsRespo3 = declinedPmPartsResponse.payload) !== null && _declinedPmPartsRespo3 !== void 0 && (_declinedPmPartsRespo3 = _declinedPmPartsRespo3.value) !== null && _declinedPmPartsRespo3 !== void 0 && (_declinedPmPartsRespo3 = _declinedPmPartsRespo3.data) !== null && _declinedPmPartsRespo3 !== void 0 && _declinedPmPartsRespo3.Part ? (_declinedPmPartsRespo4 = declinedPmPartsResponse.payload) === null || _declinedPmPartsRespo4 === void 0 || (_declinedPmPartsRespo4 = _declinedPmPartsRespo4.value) === null || _declinedPmPartsRespo4 === void 0 || (_declinedPmPartsRespo4 = _declinedPmPartsRespo4.data) === null || _declinedPmPartsRespo4 === void 0 ? void 0 : _declinedPmPartsRespo4.Part : [];
                            declinedLabours = (_declinedPmPartsRespo5 = declinedPmPartsResponse.payload) !== null && _declinedPmPartsRespo5 !== void 0 && (_declinedPmPartsRespo5 = _declinedPmPartsRespo5.value) !== null && _declinedPmPartsRespo5 !== void 0 && (_declinedPmPartsRespo5 = _declinedPmPartsRespo5.data) !== null && _declinedPmPartsRespo5 !== void 0 && _declinedPmPartsRespo5.Labour ? (_declinedPmPartsRespo6 = declinedPmPartsResponse.payload) === null || _declinedPmPartsRespo6 === void 0 || (_declinedPmPartsRespo6 = _declinedPmPartsRespo6.value) === null || _declinedPmPartsRespo6 === void 0 || (_declinedPmPartsRespo6 = _declinedPmPartsRespo6.data) === null || _declinedPmPartsRespo6 === void 0 ? void 0 : _declinedPmPartsRespo6.Labour : [];
                            declinesPmParts_1 = __spreadArray(__spreadArray([], declinedParts, true), declinedLabours, true);
                            finalList_1 = [];
                            masterPmPartsList_1.map(function (masterItem) {
                                var isSaved = savedPmPartsList.find(function (savedItem) { return savedItem.ChildId === masterItem.ChildId; });
                                var isDeclined = declinesPmParts_1.find(function (declinedItem) { return declinedItem.ChildId === masterItem.ChildId; });
                                // console.log("isDeclined", isDeclined);
                                if (isSaved) {
                                    var _isSaved$Price;
                                    var findMRPObject = masterItem.Price.find(function (item) { return item.MRP === isSaved.Price.MRP; });
                                    var updatedItem = _objectSpread({}, isSaved);
                                    updatedItem.isExpanded = false;
                                    updatedItem.Quantity = (_isSaved$Price = isSaved.Price) === null || _isSaved$Price === void 0 ? void 0 : _isSaved$Price.Quantity;
                                    updatedItem.jobType = masterItem.jobType;
                                    updatedItem.PartName = masterItem.jobType === "Part" ? masterItem.PartName : "";
                                    updatedItem.LabourName = masterItem.jobType === "Labour" ? masterItem.LabourName : "";
                                    updatedItem.Price = masterItem.Price;
                                    updatedItem.LabourCode = masterItem.jobType === "Labour" ? masterItem.LabourCode : "";
                                    updatedItem.PartCode = masterItem.jobType === "Part" ? masterItem.PartCode : "";
                                    updatedItem.SelectedPriceDetails = _objectSpread(_objectSpread({}, isSaved.Price), {}, {
                                        MaxPrice: findMRPObject === null || findMRPObject === void 0 ? void 0 : findMRPObject.MaxPrice,
                                        MinPrice: findMRPObject === null || findMRPObject === void 0 ? void 0 : findMRPObject.MinPrice,
                                        PriceGroupCategoryId: findMRPObject === null || findMRPObject === void 0 ? void 0 : findMRPObject.PriceGroupCategoryId,
                                        PriceGroupCategoryKey: findMRPObject === null || findMRPObject === void 0 ? void 0 : findMRPObject.PriceGroupCategoryKey,
                                        EffectiveFromDate: findMRPObject === null || findMRPObject === void 0 ? void 0 : findMRPObject.EffectiveFromDate,
                                        EffectiveToDate: findMRPObject === null || findMRPObject === void 0 ? void 0 : findMRPObject.EffectiveToDate
                                    });
                                    finalList_1.push(_objectSpread(_objectSpread({}, masterItem), updatedItem));
                                }
                                else if (isDeclined) {
                                    var findMRPObject = masterItem.Price.find(function (item) {
                                        var _isDeclined$SavedPric;
                                        return item.MRP === ((_isDeclined$SavedPric = isDeclined.SavedPriceWithTaxDeclined) === null || _isDeclined$SavedPric === void 0 ? void 0 : _isDeclined$SavedPric.MRP);
                                    });
                                    var updatedItem = _objectSpread({}, isDeclined);
                                    updatedItem.isExpanded = true;
                                    updatedItem.DeclinedRemarks = updatedItem.Remarks ? updatedItem.Remarks : "";
                                    updatedItem.RejectReasonRemark = updatedItem.DeclinedJobReasonId ? updatedItem.DeclinedJobReasonId : "";
                                    updatedItem.jobType = masterItem.jobType;
                                    updatedItem.PartName = masterItem.jobType === "Part" ? masterItem.PartName : "";
                                    updatedItem.LabourName = masterItem.jobType === "Labour" ? masterItem.LabourName : "";
                                    updatedItem.Quantity = masterItem.Quantity;
                                    updatedItem.Price = masterItem.Price;
                                    updatedItem.LabourCode = masterItem.jobType === "Labour" ? masterItem.LabourCode : "";
                                    updatedItem.PartCode = masterItem.jobType === "Part" ? masterItem.PartCode : "";
                                    updatedItem.SelectedPriceDetails = _objectSpread(_objectSpread({}, isDeclined.SavedPriceWithTaxDeclined), {}, {
                                        MaxPrice: findMRPObject === null || findMRPObject === void 0 ? void 0 : findMRPObject.MaxPrice,
                                        MinPrice: findMRPObject === null || findMRPObject === void 0 ? void 0 : findMRPObject.MinPrice
                                    });
                                    finalList_1.push(updatedItem);
                                }
                                // else {
                                //   let updatedItem = { ...masterItem }
                                //   updatedItem.isExpanded = false
                                //   finalList.push(updatedItem)
                                // }
                            });
                            updatePeriodicPartData(finalList_1);
                            setPeriodicSkeleton(false);
                            periodicPartDataCallBack(finalList_1, true);
                        }
                        else {
                            setPeriodicSkeleton(false);
                            periodicPartDataCallBack(periodicPartData, true);
                        }
                    }
                    else {
                        setPeriodicSkeleton(false);
                        periodicPartDataCallBack(periodicPartData, true);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getJobItems = function (preJobCardId, SystemName) { return __awaiter(_this, void 0, void 0, function () {
        var _result$payload4, _result$payload5, requestBody, result, _result$payload6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        PreJobCardDocumentId: preJobCardId,
                        SystemName: Module == isModuleConfig.Bajaj ? null : SystemName
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'customerDetailsTrnalsteToJob',
                            url: getSavedJobItemsUrl,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    if ((_result$payload4 = result.payload) !== null && _result$payload4 !== void 0 && (_result$payload4 = _result$payload4.value) !== null && _result$payload4 !== void 0 && _result$payload4.success && (_result$payload5 = result.payload) !== null && _result$payload5 !== void 0 && (_result$payload5 = _result$payload5.value) !== null && _result$payload5 !== void 0 && _result$payload5.data) {
                        return [2 /*return*/, (_result$payload6 = result.payload) === null || _result$payload6 === void 0 || (_result$payload6 = _result$payload6.value) === null || _result$payload6 === void 0 ? void 0 : _result$payload6.data];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getCustomerComplaint = function () { return __awaiter(_this, void 0, void 0, function () {
        var _customerResponse$pay, customerRequest, _a, customerResponse, getCustResp, custResp, finalArray_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    customerRequest = {
                        EstimateId: documentId,
                        SystemName: "CustomerVoiceToJobItem"
                    };
                    return [4 /*yield*/, Promise.all([dispatch(getByIdAPI({
                                key: "",
                                url: getCustomerComplaintPriceUrl,
                                request: customerRequest
                            })), getJobItems(documentId !== null && documentId !== void 0 ? documentId : "", "CustomerVoiceToJobItem")])];
                case 1:
                    _a = _b.sent(), customerResponse = _a[0], getCustResp = _a[1];
                    // let customerResponse = await dispatch(getByIdAPI({ key: "", url: getCustomerComplaintPriceUrl, request: customerRequest }));
                    // let estimateRequest = {
                    //   EstimateId: documentId,
                    //   SystemName: "CustomerVoiceToJobItem",
                    // };
                    // let getCustResp = await getJobItems(documentId ?? "", "CustomerVoiceToJobItem")
                    setComplaintSkeleton(false);
                    custResp = customerResponse === null || customerResponse === void 0 || (_customerResponse$pay = customerResponse.payload) === null || _customerResponse$pay === void 0 ? void 0 : _customerResponse$pay.data;
                    if (custResp && (custResp === null || custResp === void 0 ? void 0 : custResp.length) > 0) {
                        setComplaintSkeleton(false);
                        finalArray_1 = [];
                        getCustResp.map(function (custItem) {
                            var matchedItem = custResp.find(function (item) { return item.ComplaintId === custItem.ComplaintId; });
                            if (matchedItem) {
                                finalArray_1.push(_objectSpread(_objectSpread({}, custItem), {}, {
                                    PartPrice: matchedItem.PartPrice,
                                    LabourPrice: matchedItem.LabourPrice
                                }));
                            }
                            else {
                                finalArray_1.push(custItem);
                            }
                        });
                        if (finalArray_1.length > 0) {
                            setCustomerComplaintData(finalArray_1);
                        }
                        else {
                            setCustomerComplaintData(getCustResp);
                        }
                    }
                    else {
                        setComplaintSkeleton(false);
                        setCustomerComplaintData(getCustResp);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getStandardJob = function () { return __awaiter(_this, void 0, void 0, function () {
        var _documentDetailsGetBy21, _documentDetailsGetBy22, _documentDetailsGetBy23, _documentDetailsGetBy24, _declinedJobsResponse, _declinedJobsResponse2, _response$payload, _response$payload2, estimateRequest, declineStandardJobRequestBody, _a, response, declinedJobsResponse, declinedJobs, _declinedJobsResponse3, _declinedJobsResponse4, _response$payload3, savedStandardJobs, finalStandardJob_1, allParts, allLabour, allParts, allLabour, allParts, allLabour;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    estimateRequest = {
                        EstimateId: documentId,
                        OrganizationId: selectedBranch.OrganizationId,
                        VinNo: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy21 = documentDetailsGetById.data) === null || _documentDetailsGetBy21 === void 0 ? void 0 : _documentDetailsGetBy21.VinNo
                    };
                    declineStandardJobRequestBody = {
                        "ParentId": documentId,
                        "InstallBaseId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy22 = documentDetailsGetById.data) === null || _documentDetailsGetBy22 === void 0 ? void 0 : _documentDetailsGetBy22.InstallBaseId,
                        "OrganizationId": selectedBranch.OrganizationId,
                        "VinNo": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy23 = documentDetailsGetById.data) === null || _documentDetailsGetBy23 === void 0 ? void 0 : _documentDetailsGetBy23.VinNo,
                        "Entity": ESystemName.Estimate,
                        "ServiceDetailType": 2,
                        "ServiceTypeId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy24 = documentDetailsGetById.data) === null || _documentDetailsGetBy24 === void 0 ? void 0 : _documentDetailsGetBy24.RepairTypeId
                    };
                    return [4 /*yield*/, Promise.all([dispatch(getByIdAPI({
                                key: "",
                                url: getStandardJobsUrl,
                                request: estimateRequest
                            })), dispatch(getListAPI({
                                key: "",
                                url: getDeclinedStandardJobs,
                                request: declineStandardJobRequestBody
                            }))])];
                case 1:
                    _a = _b.sent(), response = _a[0], declinedJobsResponse = _a[1];
                    declinedJobs = [];
                    if ((_declinedJobsResponse = declinedJobsResponse.payload) !== null && _declinedJobsResponse !== void 0 && (_declinedJobsResponse = _declinedJobsResponse.value) !== null && _declinedJobsResponse !== void 0 && _declinedJobsResponse.success && (_declinedJobsResponse2 = declinedJobsResponse.payload) !== null && _declinedJobsResponse2 !== void 0 && (_declinedJobsResponse2 = _declinedJobsResponse2.value) !== null && _declinedJobsResponse2 !== void 0 && _declinedJobsResponse2.data) {
                        declinedJobs = (_declinedJobsResponse3 = declinedJobsResponse.payload) !== null && _declinedJobsResponse3 !== void 0 && (_declinedJobsResponse3 = _declinedJobsResponse3.value) !== null && _declinedJobsResponse3 !== void 0 && _declinedJobsResponse3.data ? (_declinedJobsResponse4 = declinedJobsResponse.payload) === null || _declinedJobsResponse4 === void 0 || (_declinedJobsResponse4 = _declinedJobsResponse4.value) === null || _declinedJobsResponse4 === void 0 ? void 0 : _declinedJobsResponse4.data : null;
                    }
                    if (response !== null && response !== void 0 && (_response$payload = response.payload) !== null && _response$payload !== void 0 && _response$payload.success && (response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.statusCode) == 200) {
                        setStandardJobSkeleton(false);
                        savedStandardJobs = response === null || response === void 0 || (_response$payload3 = response.payload) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.data) === null || _response$payload3 === void 0 ? void 0 : _response$payload3.StandardJob;
                        if (savedStandardJobs && savedStandardJobs.length > 0) {
                            finalStandardJob_1 = [];
                            savedStandardJobs.map(function (element) {
                                var _element$StandardPart, _element$StandardPart2;
                                var labourPrice = 0;
                                var partPrice = 0;
                                element.StandardParts = {
                                    Part: (_element$StandardPart = element.StandardParts) === null || _element$StandardPart === void 0 ? void 0 : _element$StandardPart.Part.map(function (part) {
                                        var partClone = _objectSpread({}, part);
                                        partClone.SelectedPriceDetails = part.Price;
                                        partClone.Price = Array.isArray(part.Price) ? part.Price : [part.Price];
                                        return partClone;
                                    }),
                                    Labour: (_element$StandardPart2 = element.StandardParts) === null || _element$StandardPart2 === void 0 ? void 0 : _element$StandardPart2.Labour.map(function (labour) {
                                        var labourClone = _objectSpread({}, labour);
                                        labourClone.SelectedPriceDetails = labour.Price;
                                        labourClone.Price = Array.isArray(labour.Price) ? labour.Price : [labour.Price];
                                        return labourClone;
                                    })
                                };
                                if (element !== null && element !== void 0 && element.LabourPrice) {
                                    var _element$LabourPrice;
                                    labourPrice = Number(labourPrice) + Number((_element$LabourPrice = element === null || element === void 0 ? void 0 : element.LabourPrice) !== null && _element$LabourPrice !== void 0 ? _element$LabourPrice : 0);
                                }
                                else {
                                    var _element$StandardPart3, _element$StandardPart4;
                                    if (element !== null && element !== void 0 && (_element$StandardPart3 = element.StandardParts) !== null && _element$StandardPart3 !== void 0 && _element$StandardPart3.Labour && (element === null || element === void 0 || (_element$StandardPart4 = element.StandardParts) === null || _element$StandardPart4 === void 0 || (_element$StandardPart4 = _element$StandardPart4.Labour) === null || _element$StandardPart4 === void 0 ? void 0 : _element$StandardPart4.length) > 0) {
                                        var _element$StandardPart5;
                                        element === null || element === void 0 || (_element$StandardPart5 = element.StandardParts) === null || _element$StandardPart5 === void 0 || (_element$StandardPart5 = _element$StandardPart5.Labour) === null || _element$StandardPart5 === void 0 || _element$StandardPart5.map(function (labourElement) {
                                            var _labourElement$Price;
                                            labourPrice = Number(labourPrice) + Number((_labourElement$Price = labourElement === null || labourElement === void 0 ? void 0 : labourElement.Price) !== null && _labourElement$Price !== void 0 ? _labourElement$Price : 0) * Number(labourElement === null || labourElement === void 0 ? void 0 : labourElement.Quantity);
                                        });
                                    }
                                }
                                if (element !== null && element !== void 0 && element.PartPrice) {
                                    var _element$PartPrice;
                                    partPrice = Number(partPrice) + Number((_element$PartPrice = element === null || element === void 0 ? void 0 : element.PartPrice) !== null && _element$PartPrice !== void 0 ? _element$PartPrice : 0);
                                }
                                else {
                                    var _element$StandardPart6, _element$StandardPart7;
                                    if (element !== null && element !== void 0 && (_element$StandardPart6 = element.StandardParts) !== null && _element$StandardPart6 !== void 0 && _element$StandardPart6.Part && (element === null || element === void 0 || (_element$StandardPart7 = element.StandardParts) === null || _element$StandardPart7 === void 0 ? void 0 : _element$StandardPart7.Part.length) > 0) {
                                        var _element$StandardPart8;
                                        element === null || element === void 0 || (_element$StandardPart8 = element.StandardParts) === null || _element$StandardPart8 === void 0 || _element$StandardPart8.Part.map(function (partElement) {
                                            var _partElement$Price;
                                            partPrice = Number(partPrice) + Number((_partElement$Price = partElement === null || partElement === void 0 ? void 0 : partElement.Price) !== null && _partElement$Price !== void 0 ? _partElement$Price : 0) * Number(partElement === null || partElement === void 0 ? void 0 : partElement.Quantity);
                                        });
                                    }
                                }
                                finalStandardJob_1.push(_objectSpread(_objectSpread({}, element), {}, {
                                    isExpanded: false,
                                    PartPrice: Number(partPrice),
                                    LabourPrice: Number(labourPrice)
                                }));
                            });
                            declinedJobs.map(function (element) {
                                var _element$StandardPart15, _element$StandardPart16, _element$StandardPart17, _element$StandardPart18, _element$StandardPart21, _element$StandardPart22;
                                var labourPrice = 0;
                                var partPrice = 0;
                                if (element !== null && element !== void 0 && element.LabourPrice) {
                                    var _element$LabourPrice2;
                                    labourPrice = Number(labourPrice) + Number((_element$LabourPrice2 = element === null || element === void 0 ? void 0 : element.LabourPrice) !== null && _element$LabourPrice2 !== void 0 ? _element$LabourPrice2 : 0);
                                }
                                else {
                                    var _element$StandardPart9, _element$StandardPart10;
                                    if (element !== null && element !== void 0 && (_element$StandardPart9 = element.StandardParts) !== null && _element$StandardPart9 !== void 0 && _element$StandardPart9.Labour && (element === null || element === void 0 || (_element$StandardPart10 = element.StandardParts) === null || _element$StandardPart10 === void 0 || (_element$StandardPart10 = _element$StandardPart10.Labour) === null || _element$StandardPart10 === void 0 ? void 0 : _element$StandardPart10.length) > 0) {
                                        var _element$StandardPart11;
                                        element === null || element === void 0 || (_element$StandardPart11 = element.StandardParts) === null || _element$StandardPart11 === void 0 || (_element$StandardPart11 = _element$StandardPart11.Labour) === null || _element$StandardPart11 === void 0 || _element$StandardPart11.map(function (labourElement) {
                                            var _labourElement$Price2;
                                            labourPrice = Number(labourPrice) + Number((_labourElement$Price2 = labourElement === null || labourElement === void 0 ? void 0 : labourElement.Price) !== null && _labourElement$Price2 !== void 0 ? _labourElement$Price2 : 0) * Number(labourElement === null || labourElement === void 0 ? void 0 : labourElement.Quantity);
                                        });
                                    }
                                }
                                if (element !== null && element !== void 0 && element.PartPrice) {
                                    var _element$PartPrice2;
                                    partPrice = Number(partPrice) + Number((_element$PartPrice2 = element === null || element === void 0 ? void 0 : element.PartPrice) !== null && _element$PartPrice2 !== void 0 ? _element$PartPrice2 : 0);
                                }
                                else {
                                    var _element$StandardPart12, _element$StandardPart13;
                                    if (element !== null && element !== void 0 && (_element$StandardPart12 = element.StandardParts) !== null && _element$StandardPart12 !== void 0 && _element$StandardPart12.Part && (element === null || element === void 0 || (_element$StandardPart13 = element.StandardParts) === null || _element$StandardPart13 === void 0 ? void 0 : _element$StandardPart13.Part.length) > 0) {
                                        var _element$StandardPart14;
                                        element === null || element === void 0 || (_element$StandardPart14 = element.StandardParts) === null || _element$StandardPart14 === void 0 || _element$StandardPart14.Part.map(function (partElement) {
                                            var _partElement$Price2;
                                            partPrice = Number(partPrice) + Number((_partElement$Price2 = partElement === null || partElement === void 0 ? void 0 : partElement.Price) !== null && _partElement$Price2 !== void 0 ? _partElement$Price2 : 0) * Number(partElement === null || partElement === void 0 ? void 0 : partElement.Quantity);
                                        });
                                    }
                                }
                                var updatedStandardParts = {
                                    Part: (_element$StandardPart15 = element.StandardParts) === null || _element$StandardPart15 === void 0 ? void 0 : _element$StandardPart15.Part.map(function (part) {
                                        var partClone = _objectSpread({}, part);
                                        partClone.SelectedPriceDetails = part.SavedPriceWithTaxDeclined;
                                        partClone.Price = Array.isArray(part.Price) ? part.Price : [part.Price];
                                        return partClone;
                                    }),
                                    Labour: (_element$StandardPart16 = element.StandardParts) === null || _element$StandardPart16 === void 0 ? void 0 : _element$StandardPart16.Labour.map(function (labour) {
                                        var labourClone = _objectSpread({}, labour);
                                        labourClone.SelectedPriceDetails = labour.SavedPriceWithTaxDeclined;
                                        labourClone.Price = Array.isArray(labour.Price) ? labour.Price : [labour.Price];
                                        return labourClone;
                                    })
                                };
                                var declinedJobReasonId = "";
                                var declinedJobRemark = "";
                                if (element !== null && element !== void 0 && (_element$StandardPart17 = element.StandardParts) !== null && _element$StandardPart17 !== void 0 && _element$StandardPart17.Part && (element === null || element === void 0 || (_element$StandardPart18 = element.StandardParts) === null || _element$StandardPart18 === void 0 ? void 0 : _element$StandardPart18.Part.length) > 0) {
                                    var _element$StandardPart19, _element$StandardPart20;
                                    declinedJobReasonId = element === null || element === void 0 || (_element$StandardPart19 = element.StandardParts) === null || _element$StandardPart19 === void 0 ? void 0 : _element$StandardPart19.Part[0].DeclinedJobReasonId;
                                    declinedJobRemark = element === null || element === void 0 || (_element$StandardPart20 = element.StandardParts) === null || _element$StandardPart20 === void 0 ? void 0 : _element$StandardPart20.Part[0].Remarks;
                                }
                                else if (element !== null && element !== void 0 && (_element$StandardPart21 = element.StandardParts) !== null && _element$StandardPart21 !== void 0 && _element$StandardPart21.Labour && (element === null || element === void 0 || (_element$StandardPart22 = element.StandardParts) === null || _element$StandardPart22 === void 0 || (_element$StandardPart22 = _element$StandardPart22.Labour) === null || _element$StandardPart22 === void 0 ? void 0 : _element$StandardPart22.length) > 0) {
                                    var _element$StandardPart23, _element$StandardPart24;
                                    declinedJobReasonId = element === null || element === void 0 || (_element$StandardPart23 = element.StandardParts) === null || _element$StandardPart23 === void 0 ? void 0 : _element$StandardPart23.Labour[0].DeclinedJobReasonId;
                                    declinedJobRemark = element === null || element === void 0 || (_element$StandardPart24 = element.StandardParts) === null || _element$StandardPart24 === void 0 ? void 0 : _element$StandardPart24.Labour[0].Remarks;
                                }
                                finalStandardJob_1.push(_objectSpread(_objectSpread({}, element), {}, {
                                    RejectReasonRemark: declinedJobReasonId,
                                    DeclinedRemarks: declinedJobRemark,
                                    StandardParts: updatedStandardParts,
                                    isExpanded: true,
                                    PartPrice: Number(partPrice),
                                    LabourPrice: Number(labourPrice)
                                }));
                            });
                            updateStandardJobData(finalStandardJob_1);
                            allParts = finalStandardJob_1 === null || finalStandardJob_1 === void 0 ? void 0 : finalStandardJob_1.flatMap(function (flatMapitem) {
                                var _flatMapitem$Standard3;
                                if (flatMapitem !== null && flatMapitem !== void 0 && flatMapitem.isExpanded)
                                    return [];
                                return (flatMapitem === null || flatMapitem === void 0 || (_flatMapitem$Standard3 = flatMapitem.StandardParts) === null || _flatMapitem$Standard3 === void 0 || (_flatMapitem$Standard3 = _flatMapitem$Standard3.Part) === null || _flatMapitem$Standard3 === void 0 ? void 0 : _flatMapitem$Standard3.filter(function (item) { return !(item !== null && item !== void 0 && item.isExpanded); })) || [];
                            });
                            allLabour = finalStandardJob_1 === null || finalStandardJob_1 === void 0 ? void 0 : finalStandardJob_1.flatMap(function (flatMapitem) {
                                var _flatMapitem$Standard4;
                                if (flatMapitem !== null && flatMapitem !== void 0 && flatMapitem.isExpanded)
                                    return [];
                                return (flatMapitem === null || flatMapitem === void 0 || (_flatMapitem$Standard4 = flatMapitem.StandardParts) === null || _flatMapitem$Standard4 === void 0 || (_flatMapitem$Standard4 = _flatMapitem$Standard4.Labour) === null || _flatMapitem$Standard4 === void 0 ? void 0 : _flatMapitem$Standard4.filter(function (item) { return !(item !== null && item !== void 0 && item.isExpanded); })) || [];
                            });
                            standardJobDataCallback === null || standardJobDataCallback === void 0 || standardJobDataCallback(__spreadArray(__spreadArray([], allParts, true), allLabour, true), true);
                        }
                        else {
                            allParts = standardJobData === null || standardJobData === void 0 ? void 0 : standardJobData.flatMap(function (flatMapitem) {
                                var _flatMapitem$Standard5;
                                if (flatMapitem !== null && flatMapitem !== void 0 && flatMapitem.isExpanded)
                                    return [];
                                return (flatMapitem === null || flatMapitem === void 0 || (_flatMapitem$Standard5 = flatMapitem.StandardParts) === null || _flatMapitem$Standard5 === void 0 || (_flatMapitem$Standard5 = _flatMapitem$Standard5.Part) === null || _flatMapitem$Standard5 === void 0 ? void 0 : _flatMapitem$Standard5.filter(function (item) { return !(item !== null && item !== void 0 && item.isExpanded); })) || [];
                            });
                            allLabour = standardJobData === null || standardJobData === void 0 ? void 0 : standardJobData.flatMap(function (flatMapitem) {
                                var _flatMapitem$Standard6;
                                if (flatMapitem !== null && flatMapitem !== void 0 && flatMapitem.isExpanded)
                                    return [];
                                return (flatMapitem === null || flatMapitem === void 0 || (_flatMapitem$Standard6 = flatMapitem.StandardParts) === null || _flatMapitem$Standard6 === void 0 || (_flatMapitem$Standard6 = _flatMapitem$Standard6.Labour) === null || _flatMapitem$Standard6 === void 0 ? void 0 : _flatMapitem$Standard6.filter(function (item) { return !(item !== null && item !== void 0 && item.isExpanded); })) || [];
                            });
                            standardJobDataCallback === null || standardJobDataCallback === void 0 || standardJobDataCallback(__spreadArray(__spreadArray([], allParts, true), allLabour, true), true);
                        }
                    }
                    else {
                        setStandardJobSkeleton(false);
                        allParts = standardJobData === null || standardJobData === void 0 ? void 0 : standardJobData.flatMap(function (flatMapitem) {
                            var _flatMapitem$Standard7;
                            if (flatMapitem !== null && flatMapitem !== void 0 && flatMapitem.isExpanded)
                                return [];
                            return (flatMapitem === null || flatMapitem === void 0 || (_flatMapitem$Standard7 = flatMapitem.StandardParts) === null || _flatMapitem$Standard7 === void 0 || (_flatMapitem$Standard7 = _flatMapitem$Standard7.Part) === null || _flatMapitem$Standard7 === void 0 ? void 0 : _flatMapitem$Standard7.filter(function (item) { return !(item !== null && item !== void 0 && item.isExpanded); })) || [];
                        });
                        allLabour = standardJobData === null || standardJobData === void 0 ? void 0 : standardJobData.flatMap(function (flatMapitem) {
                            var _flatMapitem$Standard8;
                            if (flatMapitem !== null && flatMapitem !== void 0 && flatMapitem.isExpanded)
                                return [];
                            return (flatMapitem === null || flatMapitem === void 0 || (_flatMapitem$Standard8 = flatMapitem.StandardParts) === null || _flatMapitem$Standard8 === void 0 || (_flatMapitem$Standard8 = _flatMapitem$Standard8.Labour) === null || _flatMapitem$Standard8 === void 0 ? void 0 : _flatMapitem$Standard8.filter(function (item) { return !(item !== null && item !== void 0 && item.isExpanded); })) || [];
                        });
                        standardJobDataCallback === null || standardJobDataCallback === void 0 || standardJobDataCallback(__spreadArray(__spreadArray([], allParts, true), allLabour, true), true);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getRoadTest = function () { return __awaiter(_this, void 0, void 0, function () {
        var _documentDetailsGetBy25, _customerComplaintsPr, customerRequest, declinedRequestBody, _a, customerComplaintsPriceResponse, getDeclinedCustomerResponse, savedCustomerComplaintsResponse, custResp, finalArray;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    customerRequest = {
                        EstimateId: documentId
                        // SystemName: "RoadTest",
                    };
                    declinedRequestBody = {
                        ParentId: documentId,
                        OrganizationId: selectedBranch.OrganizationId,
                        VinNo: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy25 = documentDetailsGetById.data) === null || _documentDetailsGetBy25 === void 0 ? void 0 : _documentDetailsGetBy25.VinNo
                    };
                    return [4 /*yield*/, Promise.all([dispatch(getByIdAPI({
                                key: "",
                                url: getCustomerComplaintPriceUrl,
                                request: customerRequest
                            })), dispatch(getByIdAPI({
                                key: "",
                                url: getDeclinedCustomerComplaintsUrl,
                                request: declinedRequestBody
                            })), getJobItems(documentId !== null && documentId !== void 0 ? documentId : "", "RoadTest")])];
                case 1:
                    _a = _b.sent(), customerComplaintsPriceResponse = _a[0], getDeclinedCustomerResponse = _a[1], savedCustomerComplaintsResponse = _a[2];
                    custResp = customerComplaintsPriceResponse === null || customerComplaintsPriceResponse === void 0 || (_customerComplaintsPr = customerComplaintsPriceResponse.payload) === null || _customerComplaintsPr === void 0 ? void 0 : _customerComplaintsPr.data;
                    setRoadTestSkeleton(false);
                    // if (custResp && custResp?.length > 0) {
                    setRoadTestSkeleton(false);
                    finalArray = [];
                    savedCustomerComplaintsResponse.map(function (savedItem) {
                        var matchedItem = custResp === null || custResp === void 0 ? void 0 : custResp.find(function (item) { return item.ComplaintId === savedItem.ComplaintId; });
                        if (matchedItem) {
                            finalArray.push(_objectSpread(_objectSpread({}, savedItem), {}, {
                                PartPrice: matchedItem.PartPrice,
                                LabourPrice: matchedItem.LabourPrice,
                                isExpanded: false,
                                DeclinedRemarks: "",
                                RejectReasonRemark: ""
                            }));
                        }
                        else {
                            finalArray.push(_objectSpread(_objectSpread({}, savedItem), {}, {
                                isExpanded: false,
                                DeclinedRemarks: "",
                                RejectReasonRemark: ""
                            }));
                        }
                    });
                    if (getDeclinedCustomerResponse && getDeclinedCustomerResponse.payload.success && getDeclinedCustomerResponse.payload.data) {
                        getDeclinedCustomerResponse.payload.data.map(function (declinedItem) {
                            var matchedItem = custResp.find(function (item) { return item.ComplaintId === declinedItem.ComplaintId; });
                            if (matchedItem) {
                                finalArray.push(_objectSpread(_objectSpread({}, declinedItem), {}, {
                                    PartPrice: matchedItem.PartPrice,
                                    LabourPrice: matchedItem.LabourPrice,
                                    isExpanded: true,
                                    DeclinedRemarks: declinedItem.Remarks ? declinedItem.Remarks : "",
                                    RejectReasonRemark: declinedItem.DeclinedJobReasonId ? declinedItem.DeclinedJobReasonId : "",
                                    isAlreadyDeclined: true
                                }));
                            }
                            else {
                                finalArray.push(_objectSpread(_objectSpread({}, declinedItem), {}, {
                                    isExpanded: true,
                                    DeclinedRemarks: declinedItem.Remarks ? declinedItem.Remarks : "",
                                    RejectReasonRemark: declinedItem.DeclinedJobReasonId ? declinedItem.DeclinedJobReasonId : "",
                                    isAlreadyDeclined: true
                                }));
                            }
                        });
                    }
                    if (finalArray.length > 0) {
                        setRoadTestData(finalArray);
                        setAllJobs(function (allJobs) {
                            return _objectSpread(_objectSpread({}, allJobs), {}, {
                                roadTestData: finalArray
                            });
                        });
                        roadTestDataCallBack(finalArray, true);
                    }
                    else {
                        setRoadTestData(savedCustomerComplaintsResponse);
                        setAllJobs(function (allJobs) {
                            return _objectSpread(_objectSpread({}, allJobs), {}, {
                                roadTestData: savedCustomerComplaintsResponse
                            });
                        });
                        roadTestDataCallBack(savedCustomerComplaintsResponse, true);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getAdditionalJob = function () { return __awaiter(_this, void 0, void 0, function () {
        var _documentDetailsGetBy26, _documentDetailsGetBy27, _documentDetailsGetBy28, _documentDetailsGetBy29, _declinedJobsResponse5, _declinedJobsResponse6, _savedAdditionalJobsR, _savedAdditionalJobsR2, estimateRequest, declineJobRequestBody, _a, savedAdditionalJobsResponse, declinedJobsResponse, declinedJobs, _declinedJobsResponse7, _declinedJobsResponse8, _savedAdditionalJobsR3, _declinedJobs, _declinedJobs3, additionalJobList_1, additionalJobs, _additionalJobs$Labou, _additionalJobs$Part, freeServiceOilParts_1, updatedDeclinedJobs_1, _declinedJobs2, _declinedJobs4, updatedList;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    estimateRequest = {
                        EstimateId: documentId,
                        OrganizationId: selectedBranch.OrganizationId,
                        VinNo: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy26 = documentDetailsGetById.data) === null || _documentDetailsGetBy26 === void 0 ? void 0 : _documentDetailsGetBy26.VinNo,
                        RegistrationNo: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy27 = documentDetailsGetById.data) === null || _documentDetailsGetBy27 === void 0 ? void 0 : _documentDetailsGetBy27.RegistrationNo
                    };
                    declineJobRequestBody = {
                        "ParentId": documentId,
                        "InstallBaseId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy28 = documentDetailsGetById.data) === null || _documentDetailsGetBy28 === void 0 ? void 0 : _documentDetailsGetBy28.InstallBaseId,
                        "ServiceDetailType": 1,
                        OrganizationId: selectedBranch.OrganizationId,
                        VinNo: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy29 = documentDetailsGetById.data) === null || _documentDetailsGetBy29 === void 0 ? void 0 : _documentDetailsGetBy29.VinNo,
                        Entity: ESystemName.Estimate
                    };
                    return [4 /*yield*/, Promise.all([dispatch(getByIdAPI({
                                key: "",
                                url: getAdditionalJobsUrl,
                                request: estimateRequest
                            })), dispatch(getListAPI({
                                key: "",
                                url: getCustomerDeclinedJobswithPriceUrl,
                                request: declineJobRequestBody
                            }))])];
                case 1:
                    _a = _b.sent(), savedAdditionalJobsResponse = _a[0], declinedJobsResponse = _a[1];
                    declinedJobs = null;
                    if ((_declinedJobsResponse5 = declinedJobsResponse.payload) !== null && _declinedJobsResponse5 !== void 0 && (_declinedJobsResponse5 = _declinedJobsResponse5.value) !== null && _declinedJobsResponse5 !== void 0 && _declinedJobsResponse5.success && (_declinedJobsResponse6 = declinedJobsResponse.payload) !== null && _declinedJobsResponse6 !== void 0 && (_declinedJobsResponse6 = _declinedJobsResponse6.value) !== null && _declinedJobsResponse6 !== void 0 && _declinedJobsResponse6.data) {
                        declinedJobs = (_declinedJobsResponse7 = declinedJobsResponse.payload) !== null && _declinedJobsResponse7 !== void 0 && (_declinedJobsResponse7 = _declinedJobsResponse7.value) !== null && _declinedJobsResponse7 !== void 0 && _declinedJobsResponse7.data ? (_declinedJobsResponse8 = declinedJobsResponse.payload) === null || _declinedJobsResponse8 === void 0 || (_declinedJobsResponse8 = _declinedJobsResponse8.value) === null || _declinedJobsResponse8 === void 0 ? void 0 : _declinedJobsResponse8.data : null;
                    }
                    setAdditionalSkeleton(false);
                    if (savedAdditionalJobsResponse !== null && savedAdditionalJobsResponse !== void 0 && (_savedAdditionalJobsR = savedAdditionalJobsResponse.payload) !== null && _savedAdditionalJobsR !== void 0 && _savedAdditionalJobsR.success && (savedAdditionalJobsResponse === null || savedAdditionalJobsResponse === void 0 || (_savedAdditionalJobsR2 = savedAdditionalJobsResponse.payload) === null || _savedAdditionalJobsR2 === void 0 ? void 0 : _savedAdditionalJobsR2.statusCode) == 200) {
                        setAdditionalSkeleton(false);
                        additionalJobList_1 = [];
                        additionalJobs = savedAdditionalJobsResponse === null || savedAdditionalJobsResponse === void 0 || (_savedAdditionalJobsR3 = savedAdditionalJobsResponse.payload) === null || _savedAdditionalJobsR3 === void 0 || (_savedAdditionalJobsR3 = _savedAdditionalJobsR3.data) === null || _savedAdditionalJobsR3 === void 0 ? void 0 : _savedAdditionalJobsR3.AdditionalJobs;
                        if (additionalJobs !== null && additionalJobs !== void 0 && additionalJobs.Labour) {
                            additionalJobs === null || additionalJobs === void 0 || (_additionalJobs$Labou = additionalJobs.Labour) === null || _additionalJobs$Labou === void 0 || _additionalJobs$Labou.map(function (element) {
                                var _element$Price, _element$Price2, _element$PriceDetails5, _element$Price3, _element$PriceDetails6, _element$Price4, _element$Price5, _element$PriceDetails7;
                                var UpdatedMaxLimit = Infinity;
                                if ((_element$Price = element.Price) !== null && _element$Price !== void 0 && _element$Price.PriceGroupCategoryId) {
                                    if (element.MaxLimit) {
                                        UpdatedMaxLimit = element.MaxLimit;
                                    }
                                    else {
                                        if (element.MaxPrice) {
                                            UpdatedMaxLimit = Number(element.MaxPrice);
                                        }
                                        else {
                                            if (element.OriginalPrice && element.OriginalPrice > 0) {
                                                UpdatedMaxLimit = Number(Number(element.OriginalPrice));
                                            }
                                            else {
                                                UpdatedMaxLimit = Infinity;
                                            }
                                        }
                                    }
                                }
                                else {
                                    if (element.MaxLimit) {
                                        UpdatedMaxLimit = Number(element.MaxLimit.toFixed(2));
                                    }
                                    else {
                                        if (element.MaxPrice) {
                                            var _element$PriceDetails;
                                            UpdatedMaxLimit = Number(Number(element === null || element === void 0 || (_element$PriceDetails = element.PriceDetails) === null || _element$PriceDetails === void 0 || (_element$PriceDetails = _element$PriceDetails[0]) === null || _element$PriceDetails === void 0 ? void 0 : _element$PriceDetails.MaxPrice));
                                        }
                                        else {
                                            var _element$PriceDetails2, _element$PriceDetails3;
                                            if (element !== null && element !== void 0 && (_element$PriceDetails2 = element.PriceDetails) !== null && _element$PriceDetails2 !== void 0 && (_element$PriceDetails2 = _element$PriceDetails2[0]) !== null && _element$PriceDetails2 !== void 0 && _element$PriceDetails2.Rate && (element === null || element === void 0 || (_element$PriceDetails3 = element.PriceDetails) === null || _element$PriceDetails3 === void 0 || (_element$PriceDetails3 = _element$PriceDetails3[0]) === null || _element$PriceDetails3 === void 0 ? void 0 : _element$PriceDetails3.Rate) > 0) {
                                                var _element$PriceDetails4;
                                                UpdatedMaxLimit = Number(Number(element === null || element === void 0 || (_element$PriceDetails4 = element.PriceDetails) === null || _element$PriceDetails4 === void 0 || (_element$PriceDetails4 = _element$PriceDetails4[0]) === null || _element$PriceDetails4 === void 0 ? void 0 : _element$PriceDetails4.Rate));
                                            }
                                            else {
                                                UpdatedMaxLimit = Infinity;
                                            }
                                        }
                                    }
                                }
                                additionalJobList_1.push(_objectSpread(_objectSpread({}, element), {}, {
                                    jobType: "Labour",
                                    OriginalQuantity: element.Quantity,
                                    Price: element.PriceDetails,
                                    SelectedPriceDetails: (_element$Price2 = element.Price) !== null && _element$Price2 !== void 0 && _element$Price2.PriceGroupCategoryId ? element.Price : element === null || element === void 0 || (_element$PriceDetails5 = element.PriceDetails) === null || _element$PriceDetails5 === void 0 ? void 0 : _element$PriceDetails5[0],
                                    IsAllowForEdit: (_element$Price3 = element.Price) !== null && _element$Price3 !== void 0 && _element$Price3.PriceGroupCategoryId ? element.IsAllowForEdit : element === null || element === void 0 || (_element$PriceDetails6 = element.PriceDetails) === null || _element$PriceDetails6 === void 0 || (_element$PriceDetails6 = _element$PriceDetails6[0]) === null || _element$PriceDetails6 === void 0 ? void 0 : _element$PriceDetails6.IsAllowForEdit,
                                    OldPrice: (_element$Price4 = element.Price) !== null && _element$Price4 !== void 0 && _element$Price4.PriceGroupCategoryId ? (_element$Price5 = element.Price) === null || _element$Price5 === void 0 ? void 0 : _element$Price5.Rate : element === null || element === void 0 || (_element$PriceDetails7 = element.PriceDetails) === null || _element$PriceDetails7 === void 0 || (_element$PriceDetails7 = _element$PriceDetails7[0]) === null || _element$PriceDetails7 === void 0 ? void 0 : _element$PriceDetails7.Rate,
                                    MaxLimit: UpdatedMaxLimit,
                                    isExpanded: false,
                                    DeclinedRemarks: "",
                                    RejectReasonRemark: ""
                                    // EditableRange: 0,
                                    // MinLimit: 0
                                }));
                            });
                        }
                        if (additionalJobs !== null && additionalJobs !== void 0 && additionalJobs.Part) {
                            additionalJobs === null || additionalJobs === void 0 || (_additionalJobs$Part = additionalJobs.Part) === null || _additionalJobs$Part === void 0 || _additionalJobs$Part.map(function (element) {
                                var _element$Price6, _element$Price7, _element$PriceDetails13, _element$Price8, _element$PriceDetails14, _element$Price9, _element$Price10, _element$PriceDetails15;
                                var UpdatedMaxLimit = Infinity;
                                if ((_element$Price6 = element.Price) !== null && _element$Price6 !== void 0 && _element$Price6.PriceGroupCategoryId) {
                                    if (element.MaxLimit) {
                                        UpdatedMaxLimit = Number(Number(element.MaxLimit).toFixed(2));
                                    }
                                    else {
                                        if (element.MaxPrice) {
                                            UpdatedMaxLimit = Number(Number(element.MaxPrice));
                                        }
                                        else {
                                            if (element.OriginalPrice && element.OriginalPrice > 0) {
                                                UpdatedMaxLimit = Number(Number(element.OriginalPrice));
                                            }
                                            else {
                                                UpdatedMaxLimit = Infinity;
                                            }
                                        }
                                    }
                                }
                                else {
                                    if (element.MaxLimit) {
                                        var _element$PriceDetails8;
                                        UpdatedMaxLimit = Number(Number(element === null || element === void 0 || (_element$PriceDetails8 = element.PriceDetails) === null || _element$PriceDetails8 === void 0 || (_element$PriceDetails8 = _element$PriceDetails8[0]) === null || _element$PriceDetails8 === void 0 ? void 0 : _element$PriceDetails8.MaxLimit).toFixed(2));
                                    }
                                    else {
                                        if (element.MaxPrice) {
                                            var _element$PriceDetails9;
                                            UpdatedMaxLimit = Number(Number(element === null || element === void 0 || (_element$PriceDetails9 = element.PriceDetails) === null || _element$PriceDetails9 === void 0 || (_element$PriceDetails9 = _element$PriceDetails9[0]) === null || _element$PriceDetails9 === void 0 ? void 0 : _element$PriceDetails9.MaxPrice));
                                        }
                                        else {
                                            var _element$PriceDetails10, _element$PriceDetails11;
                                            if (element !== null && element !== void 0 && (_element$PriceDetails10 = element.PriceDetails) !== null && _element$PriceDetails10 !== void 0 && (_element$PriceDetails10 = _element$PriceDetails10[0]) !== null && _element$PriceDetails10 !== void 0 && _element$PriceDetails10.Rate && (element === null || element === void 0 || (_element$PriceDetails11 = element.PriceDetails) === null || _element$PriceDetails11 === void 0 || (_element$PriceDetails11 = _element$PriceDetails11[0]) === null || _element$PriceDetails11 === void 0 ? void 0 : _element$PriceDetails11.Rate) > 0) {
                                                var _element$PriceDetails12;
                                                UpdatedMaxLimit = Number(Number(element === null || element === void 0 || (_element$PriceDetails12 = element.PriceDetails) === null || _element$PriceDetails12 === void 0 || (_element$PriceDetails12 = _element$PriceDetails12[0]) === null || _element$PriceDetails12 === void 0 ? void 0 : _element$PriceDetails12.Rate));
                                            }
                                            else {
                                                UpdatedMaxLimit = Infinity;
                                            }
                                        }
                                    }
                                }
                                additionalJobList_1.push(_objectSpread(_objectSpread({}, element), {}, {
                                    jobType: "Part",
                                    Price: element.PriceDetails,
                                    OriginalQuantity: element.Quantity,
                                    SelectedPriceDetails: (_element$Price7 = element.Price) !== null && _element$Price7 !== void 0 && _element$Price7.PriceGroupCategoryId ? element.Price : element === null || element === void 0 || (_element$PriceDetails13 = element.PriceDetails) === null || _element$PriceDetails13 === void 0 ? void 0 : _element$PriceDetails13[0],
                                    IsAllowForEdit: (_element$Price8 = element.Price) !== null && _element$Price8 !== void 0 && _element$Price8.PriceGroupCategoryId ? element.IsAllowForEdit : element === null || element === void 0 || (_element$PriceDetails14 = element.PriceDetails) === null || _element$PriceDetails14 === void 0 || (_element$PriceDetails14 = _element$PriceDetails14[0]) === null || _element$PriceDetails14 === void 0 ? void 0 : _element$PriceDetails14.IsAllowForEdit,
                                    OldPrice: (_element$Price9 = element.Price) !== null && _element$Price9 !== void 0 && _element$Price9.PriceGroupCategoryId ? (_element$Price10 = element.Price) === null || _element$Price10 === void 0 ? void 0 : _element$Price10.Rate : element === null || element === void 0 || (_element$PriceDetails15 = element.PriceDetails) === null || _element$PriceDetails15 === void 0 || (_element$PriceDetails15 = _element$PriceDetails15[0]) === null || _element$PriceDetails15 === void 0 ? void 0 : _element$PriceDetails15.Rate,
                                    DecimalPrecision: (element === null || element === void 0 ? void 0 : element.DecimalPrecision) || 0,
                                    MaxLimit: UpdatedMaxLimit,
                                    isExpanded: false,
                                    DeclinedRemarks: "",
                                    RejectReasonRemark: ""
                                    // EditableRange: 0,
                                    // MinLimit: 0
                                }));
                            });
                        }
                        freeServiceOilParts_1 = [];
                        additionalJobList_1.map(function (item) {
                            if (item.IsAutoFill && item.AutofillType && item.AutofillType === 2 && item.PartType && item.PartType === "OilPart") {
                                freeServiceOilParts_1.push(item);
                            }
                        });
                        setAdditonalJobsOilParts(freeServiceOilParts_1);
                        updatedDeclinedJobs_1 = [];
                        if ((_declinedJobs = declinedJobs) !== null && _declinedJobs !== void 0 && _declinedJobs.Labour) {
                            (_declinedJobs2 = declinedJobs) === null || _declinedJobs2 === void 0 || (_declinedJobs2 = _declinedJobs2.Labour) === null || _declinedJobs2 === void 0 || _declinedJobs2.map(function (declinedItem) {
                                updatedDeclinedJobs_1.push(_objectSpread(_objectSpread({}, declinedItem), {}, {
                                    jobType: "Labour",
                                    Price: Array.isArray(declinedItem.Price) ? declinedItem.Price : [declinedItem.Price],
                                    OriginalQuantity: declinedItem.Quantity,
                                    SelectedPriceDetails: declinedItem.SavedPriceWithTaxDeclined,
                                    isExpanded: true,
                                    DeclinedRemarks: declinedItem !== null && declinedItem !== void 0 && declinedItem.Remarks ? declinedItem === null || declinedItem === void 0 ? void 0 : declinedItem.Remarks : "",
                                    RejectReasonRemark: declinedItem !== null && declinedItem !== void 0 && declinedItem.DeclinedJobReasonId ? declinedItem === null || declinedItem === void 0 ? void 0 : declinedItem.DeclinedJobReasonId : ""
                                }));
                            });
                        }
                        if ((_declinedJobs3 = declinedJobs) !== null && _declinedJobs3 !== void 0 && _declinedJobs3.Part) {
                            (_declinedJobs4 = declinedJobs) === null || _declinedJobs4 === void 0 || (_declinedJobs4 = _declinedJobs4.Part) === null || _declinedJobs4 === void 0 || _declinedJobs4.map(function (declinedItem) {
                                updatedDeclinedJobs_1.push(_objectSpread(_objectSpread({}, declinedItem), {}, {
                                    jobType: "Part",
                                    Price: Array.isArray(declinedItem.Price) ? declinedItem.Price : [declinedItem.Price],
                                    SelectedPriceDetails: declinedItem.SavedPriceWithTaxDeclined,
                                    OriginalQuantity: declinedItem.Quantity,
                                    isExpanded: true,
                                    DeclinedRemarks: declinedItem !== null && declinedItem !== void 0 && declinedItem.Remarks ? declinedItem === null || declinedItem === void 0 ? void 0 : declinedItem.Remarks : "",
                                    RejectReasonRemark: declinedItem !== null && declinedItem !== void 0 && declinedItem.DeclinedJobReasonId ? declinedItem === null || declinedItem === void 0 ? void 0 : declinedItem.DeclinedJobReasonId : ""
                                }));
                            });
                        }
                        updatedList = __spreadArray(__spreadArray([], additionalJobList_1, true), updatedDeclinedJobs_1, true);
                        updatedList.sort(function (a, b) {
                            if (a.jobType !== b.jobType) {
                                return a.jobType === "Part" ? -1 : 1;
                            }
                            var nameA = a.LabourName || a.PartName || "";
                            var nameB = b.LabourName || b.PartName || "";
                            return nameA.localeCompare(nameB);
                        });
                        updateAdditionalJobs(updatedList);
                        setAdditionalJobsByAPI(updatedList);
                        additionalJobDataCallback(updatedList, true);
                        dispatch(setState({
                            key: "additionalEstimateDetail",
                            value: {
                                additionalJobList: updatedList,
                                SkeletonView: true
                            }
                        }));
                    }
                    else {
                        setAdditionalSkeleton(false);
                        additionalJobDataCallback(additionalJobData, true);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleInputPartPriceChange = function (event, index, item, key) {
        var value = event.target.value;
        value = value.replace(/^0+(?!\.)/, '');
        if (regex.test(value) || value == '') {
            if ((item === null || item === void 0 ? void 0 : item.EditableRange) == 0) {
                if ((item === null || item === void 0 ? void 0 : item.MinLimit) == null && (item === null || item === void 0 ? void 0 : item.MaxLimit) == null) {
                    var data = __spreadArray([], customerComplaintData, true);
                    var updateItem = _objectSpread({}, data[index]);
                    updateItem[key] = event.target.value;
                    data[index] = updateItem;
                    setCustomerComplaintData(data);
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        CustomerComplaint: true
                    }));
                    // customerComplaintData[index].PartPrice = event.target.value;
                    calculateJobCost(allJobs, roadTestData);
                    return;
                }
                if (value <= (item === null || item === void 0 ? void 0 : item.MaxLimit) && value >= (item === null || item === void 0 ? void 0 : item.MinLimit) || value == "") {
                    var data = __spreadArray([], customerComplaintData, true);
                    var updateItem = _objectSpread({}, data[index]);
                    updateItem[key] = value;
                    data[index] = updateItem;
                    setCustomerComplaintData(data);
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        CustomerComplaint: true
                    }));
                    // customerComplaintData[index].PartPrice = value;
                    calculateJobCost(allJobs, roadTestData);
                }
            }
            else if ((item === null || item === void 0 ? void 0 : item.EditableRange) == 1) {
                if (value <= (item === null || item === void 0 ? void 0 : item.MaxLimit) || value == "") {
                    var data = __spreadArray([], customerComplaintData, true);
                    var updateItem = _objectSpread({}, data[index]);
                    updateItem[key] = value;
                    data[index] = updateItem;
                    setCustomerComplaintData(data);
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        CustomerComplaint: true
                    }));
                    // customerComplaintData[index].PartPrice = value;
                    calculateJobCost(allJobs, roadTestData);
                }
            }
            else if ((item === null || item === void 0 ? void 0 : item.EditableRange) == 2) {
                if (value >= (item === null || item === void 0 ? void 0 : item.MinLimit) || value == "") {
                    var data = __spreadArray([], customerComplaintData, true);
                    var updateItem = _objectSpread({}, data[index]);
                    updateItem[key] = value;
                    data[index] = updateItem;
                    setCustomerComplaintData(data);
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        CustomerComplaint: true
                    }));
                    // customerComplaintData[index].PartPrice = value;
                    calculateJobCost(allJobs, roadTestData);
                }
            }
        }
    };
    var handleInputPeriodicMaintenanceAmountChange = function (event, index, item) {
        var value = event.target.value;
        value = value.replace(/^0+(?!\.)/, '');
        if (regex.test(value) || value == '') {
            if ((item === null || item === void 0 ? void 0 : item.EditableRange) == 0) {
                if ((item === null || item === void 0 ? void 0 : item.MinLimit) == null && (item === null || item === void 0 ? void 0 : item.MaxLimit) == null) {
                    var data = __spreadArray([], periodicPartData, true);
                    data[index].Price = value;
                    updatePeriodicPartData(data);
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        PeriodicPart: true
                    }));
                    return;
                }
                if (value <= (item === null || item === void 0 ? void 0 : item.MaxLimit) && value >= (item === null || item === void 0 ? void 0 : item.MinLimit) || value == "") {
                    var data = __spreadArray([], periodicPartData, true);
                    data[index].Price = value;
                    updatePeriodicPartData(data);
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        PeriodicPart: true
                    }));
                }
            }
            else if ((item === null || item === void 0 ? void 0 : item.EditableRange) == 1) {
                if (value <= (item === null || item === void 0 ? void 0 : item.MaxLimit) || value == "") {
                    var data = __spreadArray([], periodicPartData, true);
                    data[index].Price = value;
                    updatePeriodicPartData(data);
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        PeriodicPart: true
                    }));
                }
            }
            else if ((item === null || item === void 0 ? void 0 : item.EditableRange) == 2) {
                if (value >= (item === null || item === void 0 ? void 0 : item.MinLimit) || value == "") {
                    var data = __spreadArray([], periodicPartData, true);
                    data[index].Price = value;
                    updatePeriodicPartData(data);
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        PeriodicPart: true
                    }));
                }
            }
        }
    };
    var handleInputStandardJobPartPriceChange = function (event, index, item, key) {
        var value = event.target.value;
        value = value.replace(/^0+(?!\.)/, '');
        if (regex.test(value) || value == '') {
            if ((item === null || item === void 0 ? void 0 : item.EditableRange) == 0) {
                if ((item === null || item === void 0 ? void 0 : item.MinLimit) == null && (item === null || item === void 0 ? void 0 : item.MaxLimit) == null) {
                    var data = __spreadArray([], standardJobData, true);
                    var updateItem = _objectSpread({}, data[index]);
                    updateItem[key] = value;
                    data[index] = updateItem;
                    updateStandardJobData(data);
                    // standardJobData[index].PartPrice = event.target.value;
                    return;
                }
                if (value <= (item === null || item === void 0 ? void 0 : item.MaxLimit) && value >= (item === null || item === void 0 ? void 0 : item.MinLimit) || value == "") {
                    var data = __spreadArray([], standardJobData, true);
                    var updateItem = _objectSpread({}, data[index]);
                    updateItem[key] = value;
                    data[index] = updateItem;
                    updateStandardJobData(data);
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        StandardJob: true
                    }));
                    // standardJobData[index].PartPrice = value;
                }
            }
            else if ((item === null || item === void 0 ? void 0 : item.EditableRange) == 1) {
                if (value <= (item === null || item === void 0 ? void 0 : item.MaxLimit) || value == "") {
                    var data = __spreadArray([], standardJobData, true);
                    var updateItem = _objectSpread({}, data[index]);
                    updateItem[key] = value;
                    data[index] = updateItem;
                    updateStandardJobData(data);
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        StandardJob: true
                    }));
                    // standardJobData[index].PartPrice = event.target.value;
                }
            }
            else if ((item === null || item === void 0 ? void 0 : item.EditableRange) == 2) {
                if (value >= (item === null || item === void 0 ? void 0 : item.MinLimit) || value == "") {
                    var data = __spreadArray([], standardJobData, true);
                    var updateItem = _objectSpread({}, data[index]);
                    updateItem[key] = value;
                    data[index] = updateItem;
                    updateStandardJobData(data);
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        StandardJob: true
                    }));
                    // standardJobData[index].PartPrice = value;
                }
            }
        }
    };
    var handleInputRoadTestPartPriceChange = function (event, index, item, key) {
        var value = event.target.value;
        value = value.replace(/^0+(?!\.)/, '');
        if (regex.test(value) || value == '') {
            if ((item === null || item === void 0 ? void 0 : item.EditableRange) == 0) {
                if ((item === null || item === void 0 ? void 0 : item.MinLimit) == null && (item === null || item === void 0 ? void 0 : item.MaxLimit) == null) {
                    var data_1 = __spreadArray([], roadTestData, true);
                    var updateItem = _objectSpread({}, data_1[index]);
                    updateItem[key] = value;
                    data_1[index] = updateItem;
                    setRoadTestData(data_1);
                    setAllJobs(function (allJobs) {
                        return _objectSpread(_objectSpread({}, allJobs), {}, {
                            roadTestData: data_1
                        });
                    });
                    calculateJobCost(allJobs, roadTestData);
                    return;
                }
                if (value <= (item === null || item === void 0 ? void 0 : item.MaxLimit) && value >= (item === null || item === void 0 ? void 0 : item.MinLimit) || value == "") {
                    var data_2 = __spreadArray([], roadTestData, true);
                    var updateItem = _objectSpread({}, data_2[index]);
                    updateItem[key] = value;
                    data_2[index] = updateItem;
                    setRoadTestData(data_2);
                    setAllJobs(function (allJobs) {
                        return _objectSpread(_objectSpread({}, allJobs), {}, {
                            roadTestData: data_2
                        });
                    });
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        RoadTest: true
                    }));
                    // roadTestData[index].PartPrice = value;
                    calculateJobCost(allJobs, roadTestData);
                }
            }
            else if ((item === null || item === void 0 ? void 0 : item.EditableRange) == 1) {
                if (value <= (item === null || item === void 0 ? void 0 : item.MaxLimit) || value == "") {
                    var data_3 = __spreadArray([], roadTestData, true);
                    var updateItem = _objectSpread({}, data_3[index]);
                    updateItem[key] = value;
                    data_3[index] = updateItem;
                    setRoadTestData(data_3);
                    setAllJobs(function (allJobs) {
                        return _objectSpread(_objectSpread({}, allJobs), {}, {
                            roadTestData: data_3
                        });
                    });
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        RoadTest: true
                    }));
                    // roadTestData[index].PartPrice = value;
                    calculateJobCost(allJobs, roadTestData);
                }
            }
            else if ((item === null || item === void 0 ? void 0 : item.EditableRange) == 2) {
                if (value >= (item === null || item === void 0 ? void 0 : item.MinLimit) || value == "") {
                    var data_4 = __spreadArray([], roadTestData, true);
                    var updateItem = _objectSpread({}, data_4[index]);
                    updateItem[key] = value;
                    data_4[index] = updateItem;
                    setRoadTestData(data_4);
                    setAllJobs(function (allJobs) {
                        return _objectSpread(_objectSpread({}, allJobs), {}, {
                            roadTestData: data_4
                        });
                    });
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        RoadTest: true
                    }));
                    // roadTestData[index].PartPrice = value;
                    calculateJobCost(allJobs, roadTestData);
                }
            }
        }
    };
    var handleInputAdditionalJobAmountChange = function (event, index, item) {
        var value = event.target.value;
        // value = value.replace(/^0+(?!\.)/, '');
        // console.log("valuesdsdsd", value);
        if (regex.test(value) || value == '') {
            // console.log("value", value);
            if ((item === null || item === void 0 ? void 0 : item.EditableRange) == 0) {
                if ((item === null || item === void 0 ? void 0 : item.MinLimit) == null && (item === null || item === void 0 ? void 0 : item.MaxLimit) == null) {
                    var data = __spreadArray([], additionalJobData, true);
                    var updateItem = _objectSpread({}, data[index]);
                    updateItem.Price = value;
                    if (!updateItem.IsPriceUpdate) {
                        updateItem.IsPriceUpdateUI = true;
                    }
                    data[index] = updateItem;
                    updateAdditionalJobs(data);
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        AdditionalJob: true
                    }));
                    // additionalJobData[index].Price = value;
                    return;
                }
                if (value <= (item === null || item === void 0 ? void 0 : item.MaxLimit) && value >= (item === null || item === void 0 ? void 0 : item.MinLimit) || value == "") {
                    var data = __spreadArray([], additionalJobData, true);
                    var updateItem = _objectSpread({}, data[index]);
                    updateItem.Price = value;
                    if (!updateItem.IsPriceUpdate) {
                        updateItem.IsPriceUpdateUI = true;
                    }
                    updateItem.error = false;
                    updateItem.errorMessage = "";
                    data[index] = updateItem;
                    // console.log("data", data);
                    updateAdditionalJobs(data);
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        AdditionalJob: true
                    }));
                    // additionalJobData[index].Price = value;
                }
                else {
                    var data = __spreadArray([], additionalJobData, true);
                    var updateItem = _objectSpread({}, data[index]);
                    updateItem.error = true;
                    updateItem.errorMessage = "Max limit \u20B9".concat(Number(updateItem.MaxLimit).toFixed(2));
                    data[index] = updateItem;
                    updateAdditionalJobs(data);
                }
            }
            else if ((item === null || item === void 0 ? void 0 : item.EditableRange) == 1) {
                if (value <= (item === null || item === void 0 ? void 0 : item.MaxLimit) || value == "") {
                    var data = __spreadArray([], additionalJobData, true);
                    var updateItem = _objectSpread({}, data[index]);
                    updateItem.Price = value;
                    if (!updateItem.IsPriceUpdate) {
                        updateItem.IsPriceUpdateUI = true;
                    }
                    data[index] = updateItem;
                    updateAdditionalJobs(data);
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        AdditionalJob: true
                    }));
                    // additionalJobData[index].Price = value;
                }
            }
            else if ((item === null || item === void 0 ? void 0 : item.EditableRange) == 2) {
                if (value >= (item === null || item === void 0 ? void 0 : item.MinLimit) || value == "") {
                    // console.log("2323343434");
                    var data = __spreadArray([], additionalJobData, true);
                    var updateItem = _objectSpread({}, data[index]);
                    updateItem.Price = value;
                    data[index] = updateItem;
                    if (!updateItem.IsPriceUpdate) {
                        updateItem.IsPriceUpdateUI = true;
                    }
                    updateAdditionalJobs(data);
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        AdditionalJob: true
                    }));
                    // additionalJobData[index].Price = value;
                }
            }
        }
    };
    var savePeriodicMaintaince = function () { return __awaiter(_this, void 0, void 0, function () {
        var _documentDetailsGetBy31, _documentDetailsGetBy32, _documentDetailsGetBy33, _documentDetailsGetBy34, _documentDetailsGetBy35, _documentDetailsGetBy36, _documentDetailsGetBy37, _documentDetailsGetBy38, _checkModelWiseRespon, _saveDeclinedPmPartsR, _result$payload7, _result$payload8, savedPMParts, requestBody, declinedPMParts, saveDeclinedJobsPayload, repeatBody, partList, checkModelWisePayload, checkModelWiseResponse, saveDeclinedPmPartsResponse, checkRepeatResponse, deleteRepeatPartsBody, deleteRepeatResponse, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    savedPMParts = [];
                    periodicPartData.map(function (item) {
                        if (!item.isExpanded) {
                            var _documentDetailsGetBy30;
                            savedPMParts.push({
                                Quantity: Number(item.Quantity),
                                SystemName: item.jobType === "Labour" ? "Labour" : "Product",
                                ChildId: item.ChildId,
                                OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                                VinNo: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy30 = documentDetailsGetById.data) === null || _documentDetailsGetBy30 === void 0 ? void 0 : _documentDetailsGetBy30.VinNo,
                                ChildName: (item === null || item === void 0 ? void 0 : item.PartName) || item.LabourName,
                                ChildCode: (item === null || item === void 0 ? void 0 : item.SkuCode) || (item === null || item === void 0 ? void 0 : item.PartCode) || (item === null || item === void 0 ? void 0 : item.LabourCode) || "",
                                UnitOfMeasurementId: item.UnitOfMeasurementId,
                                Price: item.SelectedPriceDetails
                            });
                        }
                    });
                    requestBody = {
                        RepairTypeId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy31 = documentDetailsGetById.data) === null || _documentDetailsGetBy31 === void 0 ? void 0 : _documentDetailsGetBy31.RepairTypeId,
                        EstimateId: documentId,
                        PeriodicParts: savedPMParts,
                        OrganizationId: selectedBranch.OrganizationId,
                        VinNo: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy32 = documentDetailsGetById.data) === null || _documentDetailsGetBy32 === void 0 ? void 0 : _documentDetailsGetBy32.VinNo
                    };
                    declinedPMParts = [];
                    periodicPartData.map(function (item) {
                        if (item.isExpanded) {
                            var _item$DeclinedRemarks;
                            declinedPMParts.push({
                                DeclineDateTime: new Date(),
                                Remarks: (_item$DeclinedRemarks = item.DeclinedRemarks) !== null && _item$DeclinedRemarks !== void 0 ? _item$DeclinedRemarks : "",
                                ServiceTypeId: item.ServiceTypeId,
                                DeclinedJobReasonId: item.RejectReasonRemark,
                                ParentSystemName: ESystemName.Estimate,
                                Quantity: item.Quantity,
                                SystemName: item.jobType === "Labour" ? "Labour" : "Product",
                                ChildId: item.ChildId,
                                ChildName: (item === null || item === void 0 ? void 0 : item.jobType) === "Part" ? item === null || item === void 0 ? void 0 : item.PartName : item === null || item === void 0 ? void 0 : item.LabourName,
                                ChildCode: (item === null || item === void 0 ? void 0 : item.jobType) === "Part" ? item === null || item === void 0 ? void 0 : item.PartCode : item === null || item === void 0 ? void 0 : item.LabourCode,
                                ServiceDetailType: 3,
                                Price: item === null || item === void 0 ? void 0 : item.SelectedPriceDetails
                            });
                        }
                    });
                    saveDeclinedJobsPayload = {
                        "InstallBaseId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy33 = documentDetailsGetById.data) === null || _documentDetailsGetBy33 === void 0 ? void 0 : _documentDetailsGetBy33.InstallBaseId,
                        "DeclinedJobs": declinedPMParts,
                        "ParentId": documentId,
                        ServiceDetailType: 3
                    };
                    repeatBody = {
                        ParentId: documentId,
                        "InstallBaseId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy34 = documentDetailsGetById.data) === null || _documentDetailsGetBy34 === void 0 ? void 0 : _documentDetailsGetBy34.InstallBaseId,
                        "CurrentODOMeterReading": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy35 = documentDetailsGetById.data) === null || _documentDetailsGetBy35 === void 0 ? void 0 : _documentDetailsGetBy35.ODOMeterReading,
                        "CurrentJobCardDate": moment().startOf('day'),
                        "CurrentJobCardParentOrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                        "CurrentJobCardOrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        "CurrentJobCardRepairTypeId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy36 = documentDetailsGetById.data) === null || _documentDetailsGetBy36 === void 0 ? void 0 : _documentDetailsGetBy36.RepairTypeId,
                        "CurrentComplaints": [],
                        "CurrentParts": savedPMParts.filter(function (item) { return item.SystemName === "Product"; }).map(function (item) { return item.ChildId; }),
                        "CurrentLabours": savedPMParts.filter(function (item) { return item.SystemName === "Labour"; }).map(function (item) { return item.ChildId; })
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    partList = periodicPartData.filter(function (item) { return !item.isExpanded && item.jobType === "Part"; }).map(function (item) { return item; });
                    checkModelWisePayload = {
                        SourceAssociationId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy37 = documentDetailsGetById.data) === null || _documentDetailsGetBy37 === void 0 ? void 0 : _documentDetailsGetBy37.ProductId,
                        PartList: partList,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        InstallBaseId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy38 = documentDetailsGetById.data) === null || _documentDetailsGetBy38 === void 0 ? void 0 : _documentDetailsGetBy38.InstallBaseId
                    };
                    return [4 /*yield*/, dispatch(createAPI({
                            key: '',
                            url: checkModelWisePeriodicPartURL,
                            request: checkModelWisePayload
                        }))];
                case 1:
                    checkModelWiseResponse = _a.sent();
                    if (!(checkModelWiseResponse !== null && checkModelWiseResponse !== void 0 && (_checkModelWiseRespon = checkModelWiseResponse.payload) !== null && _checkModelWiseRespon !== void 0 && _checkModelWiseRespon.success)) {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "declinedPmParts",
                            url: saveDeclinedPmPartsURl,
                            request: saveDeclinedJobsPayload
                        }))];
                case 2:
                    saveDeclinedPmPartsResponse = _a.sent();
                    return [4 /*yield*/, dispatch(createAPI({
                            url: CheckRepeatUrl,
                            request: repeatBody
                        }))];
                case 3:
                    checkRepeatResponse = _a.sent();
                    deleteRepeatPartsBody = {
                        ParentId: documentId,
                        Childs: declinedPMParts.map(function (item) {
                            return item.ChildId ? item.ChildId : item.id;
                        })
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            url: deleteRepeatChildsURL,
                            request: deleteRepeatPartsBody
                        }))];
                case 4:
                    deleteRepeatResponse = _a.sent();
                    if (saveDeclinedPmPartsResponse && (_saveDeclinedPmPartsR = saveDeclinedPmPartsResponse.payload) !== null && _saveDeclinedPmPartsR !== void 0 && _saveDeclinedPmPartsR.value) {
                        // setDeclinedPmPartsList(declinedPMParts)
                    }
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: estimateUpsertPeriodicPartsUrl,
                            request: requestBody
                        }))];
                case 5:
                    result = _a.sent();
                    if (!((result === null || result === void 0 || (_result$payload7 = result.payload) === null || _result$payload7 === void 0 || (_result$payload7 = _result$payload7.value) === null || _result$payload7 === void 0 ? void 0 : _result$payload7.statusCode) !== 200 || !(result !== null && result !== void 0 && (_result$payload8 = result.payload) !== null && _result$payload8 !== void 0 && (_result$payload8 = _result$payload8.value) !== null && _result$payload8 !== void 0 && _result$payload8.success))) return [3 /*break*/, 6];
                    setPeriodicPartText("Retry");
                    return [3 /*break*/, 9];
                case 6:
                    periodicPartDataCallBack(periodicPartData, true);
                    dispatch(showNotification({
                        isOpen: true,
                        message: "Periodic maintenance saved successfully",
                        type: "success"
                    }));
                    setAllSavedJobs(function (allJobs) {
                        return _objectSpread(_objectSpread({}, allJobs), {}, {
                            periodicJobs: periodicPartData
                        });
                    });
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        PeriodicPart: false
                    }));
                    setHasUnsavedChanges(false);
                    return [4 /*yield*/, AutoFillLabourAPICall()];
                case 7:
                    _a.sent();
                    return [4 /*yield*/, getAdditionalJob()];
                case 8:
                    _a.sent();
                    _a.label = 9;
                case 9:
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
    var saveCustomerComplaint = function () { return __awaiter(_this, void 0, void 0, function () {
        var _documentDetailsGetBy39, _result$payload9, jobItems, rejectedJobItems, declinedRequestBody, requestBody, result, declinedResult;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    jobItems = [];
                    rejectedJobItems = [];
                    customerComplaintData.forEach(function (value) {
                        var _value$ComplaintAssoc, _value$ComplaintAssoc3;
                        var _complaintAssociations = [];
                        if ((value === null || value === void 0 || (_value$ComplaintAssoc = value.ComplaintAssociations) === null || _value$ComplaintAssoc === void 0 || (_value$ComplaintAssoc = _value$ComplaintAssoc.Labour) === null || _value$ComplaintAssoc === void 0 ? void 0 : _value$ComplaintAssoc.length) > 0) {
                            var _value$ComplaintAssoc2;
                            _complaintAssociations = __spreadArray(__spreadArray([], (_complaintAssociations || []), true), (value === null || value === void 0 || (_value$ComplaintAssoc2 = value.ComplaintAssociations) === null || _value$ComplaintAssoc2 === void 0 ? void 0 : _value$ComplaintAssoc2.Labour), true);
                        }
                        if ((value === null || value === void 0 || (_value$ComplaintAssoc3 = value.ComplaintAssociations) === null || _value$ComplaintAssoc3 === void 0 || (_value$ComplaintAssoc3 = _value$ComplaintAssoc3.Part) === null || _value$ComplaintAssoc3 === void 0 ? void 0 : _value$ComplaintAssoc3.length) > 0) {
                            var _value$ComplaintAssoc4;
                            _complaintAssociations = __spreadArray(__spreadArray([], (_complaintAssociations || []), true), (value === null || value === void 0 || (_value$ComplaintAssoc4 = value.ComplaintAssociations) === null || _value$ComplaintAssoc4 === void 0 ? void 0 : _value$ComplaintAssoc4.Part), true);
                        }
                        var createdObj = _objectSpread(_objectSpread({}, value), {}, {
                            SystemName: ESystemName.CustomerVoiceToJobItem,
                            PartPrice: value.PartPrice ? Number(value === null || value === void 0 ? void 0 : value.PartPrice) : 0,
                            LabourPrice: value.LabourPrice ? Number(value === null || value === void 0 ? void 0 : value.LabourPrice) : 0,
                            ComplaintAssociations: _complaintAssociations || []
                        });
                        if (!value.isExpanded) {
                            jobItems.push(createdObj);
                        }
                        else {
                            rejectedJobItems.push(createdObj);
                        }
                    });
                    declinedRequestBody = {
                        PreJobCardDocumentId: documentId,
                        InstallBaseId: (_documentDetailsGetBy39 = documentDetailsGetById.data) === null || _documentDetailsGetBy39 === void 0 ? void 0 : _documentDetailsGetBy39.InstallBaseId,
                        DeclinedJobItems: rejectedJobItems
                    };
                    requestBody = {
                        JobItems: jobItems,
                        EstimateId: documentId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: estimateUpsertCustomerVoiceToJobItemUrl,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    if (!((result === null || result === void 0 || (_result$payload9 = result.payload) === null || _result$payload9 === void 0 || (_result$payload9 = _result$payload9.value) === null || _result$payload9 === void 0 ? void 0 : _result$payload9.statusCode) == 200)) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: saveDeclinedCustomerComplaintsUrl,
                            request: declinedRequestBody
                        }))];
                case 2:
                    declinedResult = _a.sent();
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        CustomerComplaint: false
                    }));
                    dispatch(showNotification({
                        isOpen: true,
                        message: t('CUSTOMER_VOICE_SAVE_MSG'),
                        type: "success"
                    }));
                    return [3 /*break*/, 4];
                case 3:
                    setCustomerComplainText("Retry");
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var saveStandardJobs = function () { return __awaiter(_this, void 0, void 0, function () {
        var _documentDetailsGetBy42, _documentDetailsGetBy43, _documentDetailsGetBy44, _documentDetailsGetBy45, _documentDetailsGetBy46, _standardJobData$filt, _documentDetailsGetBy47, _documentDetailsGetBy48, _checkModelWiseRespon2, _result$payload10, standardPartArray, standardLabourArray, rejectedStandardJobs, finalStandardArray, requestBody, saveDeclinedStandardJobsPayload, repeatBody, checkRepeatResponse, deleteRepeatPartsBody, deleteRepeatResponse, saveDeclinedStandardJobsResponse, partList, checkModelWisePayload, checkModelWiseResponse, result, allParts, allLabour;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    standardPartArray = [];
                    standardLabourArray = [];
                    rejectedStandardJobs = [];
                    standardJobData === null || standardJobData === void 0 || standardJobData.forEach(function (value) {
                        if (!value.isExpanded) {
                            var _value$StandardParts, _value$StandardParts2;
                            var labour = (_value$StandardParts = value.StandardParts) === null || _value$StandardParts === void 0 ? void 0 : _value$StandardParts.Labour;
                            var part = (_value$StandardParts2 = value.StandardParts) === null || _value$StandardParts2 === void 0 ? void 0 : _value$StandardParts2.Part;
                            var objLabour_1 = {};
                            var objPart_1 = {};
                            labour === null || labour === void 0 || labour.forEach(function (elem) {
                                var _documentDetailsGetBy40;
                                objLabour_1["Quantity"] = elem.Quantity;
                                objLabour_1["SystemName"] = "Labour";
                                objLabour_1["ChildId"] = elem.ChildId;
                                // objLabour["PartPrice"] = value.PartPrice ? Number(value.PartPrice) : 0;
                                // objLabour["LabourPrice"] = value.LabourPrice ? Number(value.LabourPrice) : 0;
                                objLabour_1["StandardServiceId"] = value.StandardServiceId;
                                objLabour_1.OrganizationId = selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId;
                                objLabour_1.VinNo = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy40 = documentDetailsGetById.data) === null || _documentDetailsGetBy40 === void 0 ? void 0 : _documentDetailsGetBy40.VinNo;
                                objLabour_1['ChildName'] = elem === null || elem === void 0 ? void 0 : elem.LabourName;
                                objLabour_1['ChildCode'] = elem === null || elem === void 0 ? void 0 : elem.LabourCode;
                                objLabour_1.UnitOfMeasurementId = elem === null || elem === void 0 ? void 0 : elem.UnitOfMeasurementId;
                                objLabour_1.Price = elem === null || elem === void 0 ? void 0 : elem.SelectedPriceDetails;
                                objLabour_1.ServiceTypeId = elem === null || elem === void 0 ? void 0 : elem.ServiceTypeId;
                                standardLabourArray.push(_objectSpread({}, objLabour_1));
                            });
                            if (part && (part === null || part === void 0 ? void 0 : part.length) > 0) {
                                part.forEach(function (item) {
                                    var _documentDetailsGetBy41;
                                    objPart_1["Quantity"] = item.Quantity;
                                    objPart_1["SystemName"] = "Product";
                                    objPart_1["ChildId"] = item.ChildId;
                                    // objPart["PartPrice"] = value.PartPrice ? Number(value.PartPrice) : 0;
                                    // objPart["LabourPrice"] = value.LabourPrice ? Number(value.LabourPrice) : 0;
                                    objPart_1.OrganizationId = selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId;
                                    objPart_1.VinNo = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy41 = documentDetailsGetById.data) === null || _documentDetailsGetBy41 === void 0 ? void 0 : _documentDetailsGetBy41.VinNo;
                                    objPart_1["StandardServiceId"] = value.StandardServiceId;
                                    objPart_1['ChildName'] = item === null || item === void 0 ? void 0 : item.PartName;
                                    objPart_1['ChildCode'] = item === null || item === void 0 ? void 0 : item.PartCode;
                                    objPart_1.UnitOfMeasurementId = item === null || item === void 0 ? void 0 : item.UnitOfMeasurementId;
                                    objPart_1.Price = item === null || item === void 0 ? void 0 : item.SelectedPriceDetails;
                                    objPart_1.ServiceTypeId = item === null || item === void 0 ? void 0 : item.ServiceTypeId;
                                    standardPartArray.push(_objectSpread({}, objPart_1));
                                });
                            }
                        }
                    });
                    finalStandardArray = __spreadArray(__spreadArray([], standardLabourArray, true), standardPartArray, true);
                    requestBody = {
                        StandardParts: finalStandardArray,
                        EstimateId: documentId,
                        RepairTypeId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy42 = documentDetailsGetById.data) === null || _documentDetailsGetBy42 === void 0 ? void 0 : _documentDetailsGetBy42.RepairTypeId
                    };
                    standardJobData.map(function (item) {
                        if (item.isExpanded) {
                            var _item$StandardParts, _item$StandardParts2;
                            var labour = (item === null || item === void 0 || (_item$StandardParts = item.StandardParts) === null || _item$StandardParts === void 0 ? void 0 : _item$StandardParts.Labour) || [];
                            var part = (item === null || item === void 0 || (_item$StandardParts2 = item.StandardParts) === null || _item$StandardParts2 === void 0 ? void 0 : _item$StandardParts2.Part) || [];
                            labour === null || labour === void 0 || labour.forEach(function (elem) {
                                rejectedStandardJobs.push({
                                    SystemName: "Labour",
                                    ChildId: elem.ChildId,
                                    ChildName: elem.LabourName,
                                    ChildCode: (elem === null || elem === void 0 ? void 0 : elem.PartCode) || (elem === null || elem === void 0 ? void 0 : elem.LabourCode) || (elem === null || elem === void 0 ? void 0 : elem.Code) || "",
                                    UnitOfMeasurementId: elem.UnitOfMeasurementId,
                                    DeclineDateTime: new Date(),
                                    Remarks: item.DeclinedRemarks ? item.DeclinedRemarks : "",
                                    ServiceTypeId: elem.ServiceTypeId,
                                    DeclinedJobReasonId: item.RejectReasonRemark ? item.RejectReasonRemark : null,
                                    ServiceDetailType: 2,
                                    ParentSystemName: ESystemName.Estimate,
                                    Price: elem.SelectedPriceDetails,
                                    Quantity: elem.Quantity,
                                    ServiceGroupId: elem.StandardServiceId
                                });
                            });
                            if (part && part.length > 0) {
                                part.forEach(function (elem) {
                                    rejectedStandardJobs.push({
                                        SystemName: "Product",
                                        ChildId: elem.ChildId,
                                        ChildName: elem.PartName,
                                        ChildCode: (elem === null || elem === void 0 ? void 0 : elem.PartCode) || (elem === null || elem === void 0 ? void 0 : elem.LabourCode) || (elem === null || elem === void 0 ? void 0 : elem.Code) || "",
                                        UnitOfMeasurementId: elem.UnitOfMeasurementId,
                                        DeclineDateTime: new Date(),
                                        Remarks: item.DeclinedRemarks ? item.DeclinedRemarks : "",
                                        ServiceTypeId: elem.ServiceTypeId,
                                        DeclinedJobReasonId: item.RejectReasonRemark ? item.RejectReasonRemark : null,
                                        ServiceDetailType: 2,
                                        ParentSystemName: ESystemName.Estimate,
                                        Price: elem.SelectedPriceDetails,
                                        Quantity: elem.Quantity,
                                        ServiceGroupId: item.StandardServiceId
                                    });
                                });
                            }
                        }
                    });
                    saveDeclinedStandardJobsPayload = {
                        "InstallBaseId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy43 = documentDetailsGetById.data) === null || _documentDetailsGetBy43 === void 0 ? void 0 : _documentDetailsGetBy43.InstallBaseId,
                        "DeclinedJobs": rejectedStandardJobs,
                        "ParentId": documentId,
                        ServiceDetailType: 2
                    };
                    console.log("saveDeclinedStandardJobsPayload", saveDeclinedStandardJobsPayload);
                    repeatBody = {
                        ParentId: documentId,
                        "InstallBaseId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy44 = documentDetailsGetById.data) === null || _documentDetailsGetBy44 === void 0 ? void 0 : _documentDetailsGetBy44.InstallBaseId,
                        "CurrentODOMeterReading": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy45 = documentDetailsGetById.data) === null || _documentDetailsGetBy45 === void 0 ? void 0 : _documentDetailsGetBy45.ODOMeterReading,
                        "CurrentJobCardDate": moment().startOf('day'),
                        "CurrentJobCardParentOrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                        "CurrentJobCardOrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        "CurrentJobCardRepairTypeId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy46 = documentDetailsGetById.data) === null || _documentDetailsGetBy46 === void 0 ? void 0 : _documentDetailsGetBy46.RepairTypeId,
                        "CurrentComplaints": [],
                        "CurrentParts": finalStandardArray.filter(function (item) { return item.SystemName === "Product"; }).map(function (item) { return item.ChildId; }),
                        "CurrentLabours": finalStandardArray.filter(function (item) { return item.SystemName === "Labour"; }).map(function (item) { return item.ChildId; })
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(createAPI({
                            url: CheckRepeatUrl,
                            request: repeatBody
                        }))];
                case 1:
                    checkRepeatResponse = _a.sent();
                    deleteRepeatPartsBody = {
                        ParentId: documentId,
                        Childs: rejectedStandardJobs.map(function (item) {
                            return item.ChildId ? item.ChildId : item.id;
                        })
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            url: deleteRepeatChildsURL,
                            request: deleteRepeatPartsBody
                        }))];
                case 2:
                    deleteRepeatResponse = _a.sent();
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "declinedPmParts",
                            url: saveDeclinedPmPartsURl,
                            request: saveDeclinedStandardJobsPayload
                        }))];
                case 3:
                    saveDeclinedStandardJobsResponse = _a.sent();
                    partList = standardJobData === null || standardJobData === void 0 || (_standardJobData$filt = standardJobData.filter(function (item) { return !item.isExpanded && item.jobType === "Part"; })) === null || _standardJobData$filt === void 0 ? void 0 : _standardJobData$filt.map(function (item) { return item; });
                    checkModelWisePayload = {
                        SourceAssociationId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy47 = documentDetailsGetById.data) === null || _documentDetailsGetBy47 === void 0 ? void 0 : _documentDetailsGetBy47.ProductId,
                        PartList: finalStandardArray,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        InstallBaseId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy48 = documentDetailsGetById.data) === null || _documentDetailsGetBy48 === void 0 ? void 0 : _documentDetailsGetBy48.InstallBaseId
                    };
                    return [4 /*yield*/, dispatch(createAPI({
                            key: '',
                            url: checkModelWisePeriodicPartURL,
                            request: checkModelWisePayload
                        }))];
                case 4:
                    checkModelWiseResponse = _a.sent();
                    if (!(checkModelWiseResponse !== null && checkModelWiseResponse !== void 0 && (_checkModelWiseRespon2 = checkModelWiseResponse.payload) !== null && _checkModelWiseRespon2 !== void 0 && _checkModelWiseRespon2.success)) {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: estimateUpsertStandardPartsUrl,
                            request: requestBody
                        }))];
                case 5:
                    result = _a.sent();
                    if (!((result === null || result === void 0 || (_result$payload10 = result.payload) === null || _result$payload10 === void 0 || (_result$payload10 = _result$payload10.value) === null || _result$payload10 === void 0 ? void 0 : _result$payload10.statusCode) == 200)) return [3 /*break*/, 8];
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        StandardJob: false
                    }));
                    //Reset the unsaved changes flag after successful save
                    setHasUnsavedChanges(false);
                    allParts = standardJobData === null || standardJobData === void 0 ? void 0 : standardJobData.flatMap(function (flatMapitem) {
                        var _flatMapitem$Standard9;
                        if (flatMapitem !== null && flatMapitem !== void 0 && flatMapitem.isExpanded)
                            return [];
                        return (flatMapitem === null || flatMapitem === void 0 || (_flatMapitem$Standard9 = flatMapitem.StandardParts) === null || _flatMapitem$Standard9 === void 0 || (_flatMapitem$Standard9 = _flatMapitem$Standard9.Part) === null || _flatMapitem$Standard9 === void 0 ? void 0 : _flatMapitem$Standard9.filter(function (item) { return !(item !== null && item !== void 0 && item.isExpanded); })) || [];
                    });
                    allLabour = standardJobData === null || standardJobData === void 0 ? void 0 : standardJobData.flatMap(function (flatMapitem) {
                        var _flatMapitem$Standard10;
                        if (flatMapitem !== null && flatMapitem !== void 0 && flatMapitem.isExpanded)
                            return [];
                        return (flatMapitem === null || flatMapitem === void 0 || (_flatMapitem$Standard10 = flatMapitem.StandardParts) === null || _flatMapitem$Standard10 === void 0 || (_flatMapitem$Standard10 = _flatMapitem$Standard10.Labour) === null || _flatMapitem$Standard10 === void 0 ? void 0 : _flatMapitem$Standard10.filter(function (item) { return !(item !== null && item !== void 0 && item.isExpanded); })) || [];
                    });
                    standardJobDataCallback === null || standardJobDataCallback === void 0 || standardJobDataCallback(__spreadArray(__spreadArray([], allParts, true), allLabour, true), true);
                    dispatch(showNotification({
                        isOpen: true,
                        message: "Standard jobs saved successfully",
                        type: "success"
                    }));
                    setAllSavedJobs(function (allJobs) {
                        return _objectSpread(_objectSpread({}, allJobs), {}, {
                            standardJobs: standardJobData
                        });
                    });
                    return [4 /*yield*/, AutoFillLabourAPICall()];
                case 6:
                    _a.sent();
                    return [4 /*yield*/, getAdditionalJob()];
                case 7:
                    _a.sent();
                    return [3 /*break*/, 9];
                case 8:
                    setStandardJobText("Retry");
                    _a.label = 9;
                case 9:
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
    var saveRoadTest = function () { return __awaiter(_this, void 0, void 0, function () {
        var _documentDetailsGetBy49, _result$payload11, savedJobItems, rejectedJobItems, requestBody, declinedRequestBody, result, declinedResult;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trackButtonClick("ButtonClickEvent", "SaveRoadTest_Click", undefined);
                    savedJobItems = [];
                    rejectedJobItems = [];
                    roadTestData.forEach(function (value) {
                        if (!value.isExpanded) {
                            var createdObj = _objectSpread(_objectSpread({}, value), {}, {
                                SystemName: null,
                                //ESystemName.RoadTest,
                                PartPrice: value.PartPrice ? Number(value === null || value === void 0 ? void 0 : value.PartPrice) : 0,
                                LabourPrice: value.LabourPrice ? Number(value === null || value === void 0 ? void 0 : value.LabourPrice) : 0,
                                ComplaintAssociations: []
                            });
                            savedJobItems.push(createdObj);
                        }
                    });
                    requestBody = {
                        JobItems: savedJobItems,
                        EstimateId: documentId
                    };
                    roadTestData.forEach(function (value) {
                        if (value.isExpanded) {
                            var imageAttachmentBody_1 = [];
                            if (value.ImageAttachments && value.ImageAttachments.length > 0) {
                                value.ImageAttachments.map(function (imageItem) {
                                    imageAttachmentBody_1.push({
                                        AttachmentId: imageItem.AttachmentId,
                                        MediaType: imageItem.MediaType,
                                        SystemName: "CustomerVoiceToJobItem"
                                    });
                                });
                            }
                            var createdObj = {
                                SystemName: 'CustomerVoiceToJobItem',
                                ComplaintGroupAssociationId: value.ComplaintGroupAssociationId,
                                ComplaintGroupChildAssociationId: value.ComplaintGroupChildAssociationId,
                                ComplaintAssociations: [],
                                Comments: value.Comments,
                                PartPrice: value.PartPrice ? Number(value === null || value === void 0 ? void 0 : value.PartPrice) : 0,
                                LabourPrice: value.LabourPrice ? Number(value === null || value === void 0 ? void 0 : value.LabourPrice) : 0,
                                ComplaintId: value.ComplaintId,
                                DeclinedJobReasonId: value.RejectReasonRemark,
                                Remarks: value.DeclinedRemarks,
                                "Value": "1",
                                ImageAttachments: imageAttachmentBody_1
                            };
                            rejectedJobItems.push(createdObj);
                        }
                    });
                    declinedRequestBody = {
                        PreJobCardDocumentId: documentId,
                        InstallBaseId: (_documentDetailsGetBy49 = documentDetailsGetById.data) === null || _documentDetailsGetBy49 === void 0 ? void 0 : _documentDetailsGetBy49.InstallBaseId,
                        DeclinedJobItems: rejectedJobItems
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: estimateUpsertCustomerVoiceToJobItemUrl,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: saveDeclinedCustomerComplaintsUrl,
                            request: declinedRequestBody
                        }))];
                case 2:
                    declinedResult = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if ((result === null || result === void 0 || (_result$payload11 = result.payload) === null || _result$payload11 === void 0 || (_result$payload11 = _result$payload11.value) === null || _result$payload11 === void 0 ? void 0 : _result$payload11.statusCode) == 200) {
                        setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                            RoadTest: false
                        }));
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Job items saved successfully",
                            type: "success"
                        }));
                        setAllSavedJobs(function (allJobs) {
                            return _objectSpread(_objectSpread({}, allJobs), {}, {
                                roadTestData: roadTestData
                            });
                        });
                        // buttonClickSpan.end();
                        // pageLoadSpan.end();
                        // transaction.end();
                    }
                    else {
                        setRoadTestText("Retry");
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var saveAdditionalJob = function () { return __awaiter(_this, void 0, void 0, function () {
        var _documentDetailsGetBy51, _documentDetailsGetBy52, _documentDetailsGetBy54, _documentDetailsGetBy55, _documentDetailsGetBy56, _documentDetailsGetBy57, _result$payload12, _result$payload13, _result$payload14, checkAllQuantityShouldbePositive, savedAdditionalJob, cancelledAdditionalJobs, autoFillType2RemovedJobs, requestBody, saveDeclinedJobsPayload, deleteRemovedAutoFetchPartBody, repeatBody, saveDeclinedAdditionalResponse, saveRemovedAdditionalResponse, checkRepeatResponse, deleteRepeatPartsBody, deleteRepeatResponse, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    checkAllQuantityShouldbePositive = additionalJobData === null || additionalJobData === void 0 ? void 0 : additionalJobData.every(function (item) { return item.Quantity > 0; });
                    if (!checkAllQuantityShouldbePositive) {
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Quantity should be greater than 0",
                            type: "error"
                        }));
                        return [2 /*return*/];
                    }
                    savedAdditionalJob = [];
                    cancelledAdditionalJobs = [];
                    autoFillType2RemovedJobs = [];
                    additionalJobData.map(function (item) {
                        var UpdatedMaxPrice = null;
                        if (item.OriginalPrice && item.OriginalPrice > 0) {
                            if (item.OldPrice && item.OldPrice > 0) {
                                if (item.MaxPrice && item.MaxPrice !== Infinity) {
                                    UpdatedMaxPrice = item.MaxPrice;
                                }
                                else {
                                    if (!item.IsPriceUpdate) {
                                        UpdatedMaxPrice = Number(Number(item.OldPrice).toFixed(2));
                                    }
                                    else {
                                        if (item.IsPriceUpdateUI) {
                                            if (item.OldPrice && item.OldPrice > 0) {
                                                UpdatedMaxPrice = Number(Number(item.OldPrice).toFixed(2));
                                            }
                                            else {
                                                UpdatedMaxPrice = Number(Number(item === null || item === void 0 ? void 0 : item.Price).toFixed(2));
                                            }
                                        }
                                        else {
                                            UpdatedMaxPrice = item.MaxLimit;
                                        }
                                    }
                                }
                            }
                            else {
                                UpdatedMaxPrice = null;
                            }
                        }
                        else {
                            UpdatedMaxPrice = null;
                        }
                        UpdatedMaxPrice = UpdatedMaxPrice ? Number(UpdatedMaxPrice.toFixed(2)) : null;
                        if (!item.isExpanded) {
                            var _documentDetailsGetBy50;
                            savedAdditionalJob.push({
                                Quantity: Number(item.Quantity),
                                SystemName: (item === null || item === void 0 ? void 0 : item.jobType) === "Labour" ? "Labour" : "Product",
                                ChildId: item.ChildId,
                                ChildName: (item === null || item === void 0 ? void 0 : item.Name) || item.ChildName,
                                ChildCode: (item === null || item === void 0 ? void 0 : item.SkuCode) || (item === null || item === void 0 ? void 0 : item.PartCode) || (item === null || item === void 0 ? void 0 : item.LabourCode) || (item === null || item === void 0 ? void 0 : item.Code) || "",
                                OrganizationId: selectedBranch.OrganizationId,
                                VinNo: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy50 = documentDetailsGetById.data) === null || _documentDetailsGetBy50 === void 0 ? void 0 : _documentDetailsGetBy50.VinNo,
                                OriginalPrice: item.OriginalPrice || item.OriginalPrice === 0 ? item.OriginalPrice : item.OldPrice || item.OldPrice === 0 ? item.OldPrice : null,
                                IsPriceUpdate: item.IsPriceUpdateUI,
                                MaxPrice: UpdatedMaxPrice,
                                ServiceTypeId: item.ServiceTypeId,
                                HSNCode: item.HSNCode,
                                UnitOfMeasurementId: item.UnitOfMeasurementId,
                                DecimalPrecision: item.DecimalPrecision,
                                Price: item === null || item === void 0 ? void 0 : item.SelectedPriceDetails,
                                AutofillType: item === null || item === void 0 ? void 0 : item.AutofillType,
                                IsAutoFill: item === null || item === void 0 ? void 0 : item.IsAutoFill
                            });
                        }
                    });
                    requestBody = {
                        EstimateId: documentId,
                        AdditionalJobs: savedAdditionalJob,
                        OrganizationId: selectedBranch.OrganizationId,
                        VinNo: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy51 = documentDetailsGetById.data) === null || _documentDetailsGetBy51 === void 0 ? void 0 : _documentDetailsGetBy51.VinNo,
                        RepairTypeId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy52 = documentDetailsGetById.data) === null || _documentDetailsGetBy52 === void 0 ? void 0 : _documentDetailsGetBy52.RepairTypeId
                    };
                    additionalJobData.map(function (item) {
                        if (item.isExpanded) {
                            var _documentDetailsGetBy53;
                            var UpdatedMaxPrice = null;
                            if (item.OriginalPrice && item.OriginalPrice > 0) {
                                if (item.OldPrice && item.OldPrice > 0) {
                                    if (item.MaxPrice && item.MaxPrice !== Infinity) {
                                        UpdatedMaxPrice = item.MaxPrice;
                                    }
                                    else {
                                        if (!item.IsPriceUpdate) {
                                            UpdatedMaxPrice = Number(Number(item.OldPrice).toFixed(2));
                                        }
                                        else {
                                            if (item.IsPriceUpdateUI) {
                                                if (item.OldPrice && item.OldPrice > 0) {
                                                    UpdatedMaxPrice = Number(Number(item.OldPrice).toFixed(2));
                                                }
                                                else {
                                                    UpdatedMaxPrice = Number(Number(item === null || item === void 0 ? void 0 : item.Price).toFixed(2));
                                                }
                                            }
                                            else {
                                                UpdatedMaxPrice = item.MaxLimit;
                                            }
                                        }
                                    }
                                }
                                else {
                                    UpdatedMaxPrice = null;
                                }
                            }
                            else {
                                UpdatedMaxPrice = null;
                            }
                            UpdatedMaxPrice = UpdatedMaxPrice ? Number(UpdatedMaxPrice.toFixed(2)) : null;
                            cancelledAdditionalJobs.push({
                                DeclineDateTime: new Date(),
                                Remarks: item.DeclinedRemarks ? item.DeclinedRemarks : "",
                                DeclinedJobReasonId: item.RejectReasonRemark ? item.RejectReasonRemark : null,
                                ServiceDetailType: 1,
                                ParentSystemName: ESystemName.Estimate,
                                Quantity: Number(item.Quantity),
                                SystemName: (item === null || item === void 0 ? void 0 : item.jobType) === "Labour" ? "Labour" : "Product",
                                ChildId: item.ChildId,
                                ServiceTypeId: item.ServiceTypeId,
                                HSNCode: item.HSNCode,
                                UnitOfMeasurementId: item.UnitOfMeasurementId,
                                Price: item === null || item === void 0 ? void 0 : item.SelectedPriceDetails,
                                ChildName: (item === null || item === void 0 ? void 0 : item.Name) || item.ChildName,
                                ChildCode: (item === null || item === void 0 ? void 0 : item.SkuCode) || (item === null || item === void 0 ? void 0 : item.PartCode) || (item === null || item === void 0 ? void 0 : item.LabourCode) || (item === null || item === void 0 ? void 0 : item.Code) || "",
                                OrganizationId: selectedBranch.OrganizationId,
                                VinNo: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy53 = documentDetailsGetById.data) === null || _documentDetailsGetBy53 === void 0 ? void 0 : _documentDetailsGetBy53.VinNo,
                                MaxPrice: UpdatedMaxPrice,
                                DecimalPrecision: item.DecimalPrecision
                            });
                        }
                    });
                    saveDeclinedJobsPayload = {
                        "InstallBaseId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy54 = documentDetailsGetById.data) === null || _documentDetailsGetBy54 === void 0 ? void 0 : _documentDetailsGetBy54.InstallBaseId,
                        "DeclinedJobs": cancelledAdditionalJobs,
                        "ParentId": documentId,
                        ServiceDetailType: 1
                    };
                    additionalJobData.map(function (item) {
                        if (item.isAutoFillType2Removed) {
                            autoFillType2RemovedJobs.push({
                                ChildId: item.ChildId
                            });
                        }
                    });
                    deleteRemovedAutoFetchPartBody = {
                        PreJobCardDocumentId: documentId,
                        AutofetchParts: autoFillType2RemovedJobs
                    };
                    repeatBody = {
                        ParentId: documentId,
                        "InstallBaseId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy55 = documentDetailsGetById.data) === null || _documentDetailsGetBy55 === void 0 ? void 0 : _documentDetailsGetBy55.InstallBaseId,
                        "CurrentODOMeterReading": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy56 = documentDetailsGetById.data) === null || _documentDetailsGetBy56 === void 0 ? void 0 : _documentDetailsGetBy56.ODOMeterReading,
                        "CurrentJobCardDate": moment().startOf('day'),
                        "CurrentJobCardParentOrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                        "CurrentJobCardOrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        "CurrentJobCardRepairTypeId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy57 = documentDetailsGetById.data) === null || _documentDetailsGetBy57 === void 0 ? void 0 : _documentDetailsGetBy57.RepairTypeId,
                        "CurrentComplaints": [],
                        "CurrentParts": savedAdditionalJob.filter(function (item) { return item.SystemName === "Product"; }).map(function (item) { return item.ChildId; }),
                        "CurrentLabours": savedAdditionalJob.filter(function (item) { return item.SystemName === "Labour"; }).map(function (item) { return item.ChildId; })
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: saveDeclinedPmPartsURl,
                            request: saveDeclinedJobsPayload
                        }))];
                case 1:
                    saveDeclinedAdditionalResponse = _a.sent();
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: deleteAutoFetchPartURL,
                            request: deleteRemovedAutoFetchPartBody
                        }))];
                case 2:
                    saveRemovedAdditionalResponse = _a.sent();
                    return [4 /*yield*/, dispatch(createAPI({
                            url: CheckRepeatUrl,
                            request: repeatBody
                        }))];
                case 3:
                    checkRepeatResponse = _a.sent();
                    if (!(cancelledAdditionalJobs.length > 0 || autoFillType2RemovedJobs.length > 0)) return [3 /*break*/, 5];
                    deleteRepeatPartsBody = {
                        ParentId: documentId,
                        Childs: __spreadArray(__spreadArray([], cancelledAdditionalJobs, true), autoFillType2RemovedJobs, true).map(function (item) {
                            return item.ChildId ? item.ChildId : item.id;
                        })
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            url: deleteRepeatChildsURL,
                            request: deleteRepeatPartsBody
                        }))];
                case 4:
                    deleteRepeatResponse = _a.sent();
                    _a.label = 5;
                case 5: return [4 /*yield*/, dispatch(getListAPI({
                        key: "",
                        url: estimateUpsertPreJobCardAdditionalJobUrl,
                        request: requestBody
                    }))];
                case 6:
                    result = _a.sent();
                    if (!((result === null || result === void 0 || (_result$payload12 = result.payload) === null || _result$payload12 === void 0 || (_result$payload12 = _result$payload12.value) === null || _result$payload12 === void 0 ? void 0 : _result$payload12.statusCode) == 200 || (result === null || result === void 0 || (_result$payload13 = result.payload) === null || _result$payload13 === void 0 || (_result$payload13 = _result$payload13.value) === null || _result$payload13 === void 0 ? void 0 : _result$payload13.statusCode) == 201 || result !== null && result !== void 0 && (_result$payload14 = result.payload) !== null && _result$payload14 !== void 0 && (_result$payload14 = _result$payload14.value) !== null && _result$payload14 !== void 0 && _result$payload14.success)) return [3 /*break*/, 9];
                    setAllSavedJobs(function (allJobs) {
                        return _objectSpread(_objectSpread({}, allJobs), {}, {
                            additionalJobs: additionalJobData
                        });
                    });
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        AdditionalJob: false
                    }));
                    additionalJobDataCallback(additionalJobData, true);
                    dispatch(showNotification({
                        isOpen: true,
                        message: "Additional job saved successfully",
                        type: "success"
                    }));
                    setHasUnsavedChanges(false);
                    return [4 /*yield*/, AutoFillLabourAPICall()];
                case 7:
                    _a.sent();
                    return [4 /*yield*/, getAdditionalJob()];
                case 8:
                    _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [3 /*break*/, 10];
                case 9:
                    setAdditionalJobText("Retry");
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    _a.label = 10;
                case 10: return [2 /*return*/];
            }
        });
    }); };
    var saveDisabled = function (data) {
        var disabledCondition = data.find(function (item) { return item.IsEditable == true; });
        if (disabledCondition) {
            return false;
        }
        else {
            return true;
        }
    };
    var getRejectRemarkList = function () { return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        Get(DeclinedJobReasonListUrl).then(function (response) {
                            if (response.success && response.data) {
                                setRejectReasonRemarkList(response.data);
                            }
                            resolve(response);
                        }).catch(function (getRejectRemarkListError) {
                            reject(getRejectRemarkListError);
                        });
                        return [2 /*return*/];
                    });
                }); })];
        });
    }); };
    var onClickCloseIconAdditonalJob = function (index) {
        var updatedList = __spreadArray([], additionalJobData, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        console.log("{ ...updatedList[index] }", _objectSpread({}, updatedList[index]));
        if (updatedItem.AutofillType === 2 && updatedItem.IsAutoFill) {
            if (updatedItem.PartType && updatedItem.PartType === "OilPart") {
                var updatedRemovedOilParts = __spreadArray([], removedOilParts, true);
                console.log("updatedRemovedOilParts", updatedRemovedOilParts);
                if (updatedItem.isAutoFillType2Removed) {
                    console.log("updatedItem.ChildId", updatedItem.ChildId);
                    updatedRemovedOilParts = updatedRemovedOilParts.filter(function (item) { return item.ChildId !== updatedItem.ChildId; });
                }
                else {
                    console.log("updatedItem", updatedItem);
                    updatedRemovedOilParts.push(updatedItem);
                }
                if (updatedRemovedOilParts.length >= additionalJobsOilParts.length) {
                    console.log("updatedRemovedOilParts.length >= additionalJobsOilParts.length", updatedRemovedOilParts.length >= additionalJobsOilParts.length);
                    GoogleAnlyticsErrorLog(profileData, 'ClientSide', t('FREE_SERVICE_OIL_PART_MANDATORY_MESSAGE'));
                    dispatch(showNotification({
                        isOpen: true,
                        message: t('FREE_SERVICE_OIL_PART_MANDATORY_MESSAGE'),
                        type: "error"
                    }));
                    return;
                }
                else {
                    setRemovedOilParts(updatedRemovedOilParts);
                }
            }
            updatedItem.isAutoFillType2Removed = !updatedItem.isAutoFillType2Removed;
            updatedItem.isExpanded = !updatedItem.isExpanded;
            updatedList[index] = updatedItem;
            updateAdditionalJobs(updatedList);
            setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                AdditionalJob: true
            }));
        }
        else {
            updatedItem.isExpanded = !updatedItem.isExpanded;
            if (!updatedItem.isExpanded) {
                updatedItem.RejectReasonRemark = "";
                updatedItem.DeclinedRemarks = "";
            }
            updatedList[index] = updatedItem;
            updateAdditionalJobs(updatedList);
            setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                AdditionalJob: true
            }));
        }
        setHasUnsavedChanges(function (prev) { return prev ? !prev : true; });
    };
    var onClickCloseIconPmParts = function (index) {
        var updatedList = __spreadArray([], periodicPartData, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        updatedItem.isExpanded = !updatedItem.isExpanded;
        if (!updatedItem.isExpanded) {
            updatedItem.RejectReasonRemark = "";
            updatedItem.DeclinedRemarks = "";
        }
        updatedList[index] = updatedItem;
        updatePeriodicPartData(updatedList);
        setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
            PeriodicPart: true
        }));
        setHasUnsavedChanges(function (prev) { return prev ? !prev : true; });
    };
    var onClickCloseIconStandardJobs = function (index) {
        var updatedList = __spreadArray([], standardJobData, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        updatedItem.isExpanded = !updatedItem.isExpanded;
        if (!updatedItem.isExpanded) {
            updatedItem.RejectReasonRemark = "";
            updatedItem.DeclinedRemarks = "";
        }
        updatedList[index] = updatedItem;
        updateStandardJobData(updatedList);
        setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
            StandardJob: true
        }));
        setHasUnsavedChanges(function (prev) { return prev ? !prev : true; });
    };
    var handleSelectAdditionalJobRejectReason = function (event, index) {
        var _event$target$value, _event$target, _event$target$value2, _event$target2;
        var newValue = (_event$target$value = (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value) !== null && _event$target$value !== void 0 ? _event$target$value : "";
        var updatedList = __spreadArray([], additionalJobData, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        //Set unsaved changes flag only if the value has changed
        if (updatedItem.RejectReasonRemark !== newValue) {
            setHasUnsavedChanges(true);
        }
        updatedItem.RejectReasonRemark = (_event$target$value2 = (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.value) !== null && _event$target$value2 !== void 0 ? _event$target$value2 : "";
        updatedList[index] = updatedItem;
        updateAdditionalJobs(updatedList);
        setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
            AdditionalJob: true
        }));
    };
    var handleSelectPmPartsRejectReason = function (event, index) {
        var _event$target$value3, _event$target3;
        var updatedList = __spreadArray([], periodicPartData, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        updatedItem.RejectReasonRemark = (_event$target$value3 = (_event$target3 = event.target) === null || _event$target3 === void 0 ? void 0 : _event$target3.value) !== null && _event$target$value3 !== void 0 ? _event$target$value3 : "";
        updatedList[index] = updatedItem;
        updatePeriodicPartData(updatedList);
        setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
            PeriodicPart: true
        }));
        setHasUnsavedChanges(function (prev) { return prev ? !prev : true; });
    };
    var handleSelectStandardJobsRejectReason = function (event, index) {
        var _event$target$value4, _event$target4, _event$target$value5, _event$target5;
        var newValue = (_event$target$value4 = (_event$target4 = event.target) === null || _event$target4 === void 0 ? void 0 : _event$target4.value) !== null && _event$target$value4 !== void 0 ? _event$target$value4 : "";
        var updatedList = __spreadArray([], standardJobData, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        // Set unsaved flag only if values changed
        if (updatedItem.RejectReasonRemark !== newValue) {
            setHasUnsavedChanges(true);
        }
        updatedItem.RejectReasonRemark = (_event$target$value5 = (_event$target5 = event.target) === null || _event$target5 === void 0 ? void 0 : _event$target5.value) !== null && _event$target$value5 !== void 0 ? _event$target$value5 : "";
        updatedList[index] = updatedItem;
        updateStandardJobData(updatedList);
        setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
            StandardJob: true
        }));
    };
    var handleChangeRejectRemark = function (event, index) {
        var _event$target$value6, _event$target6, _event$target$value7, _event$target7;
        var newValue = (_event$target$value6 = (_event$target6 = event.target) === null || _event$target6 === void 0 ? void 0 : _event$target6.value) !== null && _event$target$value6 !== void 0 ? _event$target$value6 : "";
        var updatedList = __spreadArray([], additionalJobData, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        //Set unsaved changes flag only if the value has changed
        if (updatedItem.DeclinedRemarks !== newValue) {
            setHasUnsavedChanges(true);
        }
        updatedItem.DeclinedRemarks = (_event$target$value7 = (_event$target7 = event.target) === null || _event$target7 === void 0 ? void 0 : _event$target7.value) !== null && _event$target$value7 !== void 0 ? _event$target$value7 : "";
        updatedList[index] = updatedItem;
        updateAdditionalJobs(updatedList);
        setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
            AdditionalJob: true
        }));
    };
    var handleChangePmPartsRejectRemark = function (event, index) {
        var _event$target$value8, _event$target8;
        var updatedList = __spreadArray([], periodicPartData, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        updatedItem.DeclinedRemarks = (_event$target$value8 = (_event$target8 = event.target) === null || _event$target8 === void 0 ? void 0 : _event$target8.value) !== null && _event$target$value8 !== void 0 ? _event$target$value8 : "";
        updatedList[index] = updatedItem;
        updatePeriodicPartData(updatedList);
        setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
            PeriodicPart: true
        }));
        setHasUnsavedChanges(function (prev) { return prev ? !prev : true; });
    };
    var handleChangeStandardJobsRejectRemark = function (event, index) {
        var _event$target$value9, _event$target9;
        var newValue = (_event$target$value9 = (_event$target9 = event.target) === null || _event$target9 === void 0 ? void 0 : _event$target9.value) !== null && _event$target$value9 !== void 0 ? _event$target$value9 : "";
        var updatedList = __spreadArray([], standardJobData, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        //Only trigger flag if value is truly different
        if (updatedItem.DeclinedRemarks !== newValue) {
            setHasUnsavedChanges(true);
        }
        updatedItem.DeclinedRemarks = newValue;
        updatedList[index] = updatedItem;
        updateStandardJobData(updatedList);
        setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
            StandardJob: true
        }));
    };
    var onClickCloseIconCustomerComplaints = function (index) {
        var updatedList = __spreadArray([], customerComplaintData, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        updatedItem.isExpanded = !updatedItem.isExpanded;
        if (!updatedItem.isExpanded) {
            updatedItem.RejectReasonRemark = "";
            updatedItem.DeclinedRemarks = "";
            updatedItem.isAlreadyDeclined = false;
        }
        updatedList[index] = updatedItem;
        setCustomerComplaintData(updatedList);
        setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
            CustomerComplaint: true
        }));
    };
    var onClickCloseIconRoadTestAndCustomerComplaints = function (index) {
        var updatedList = __spreadArray([], roadTestData, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        updatedItem.isExpanded = !updatedItem.isExpanded;
        if (!updatedItem.isExpanded) {
            updatedItem.RejectReasonRemark = "";
            updatedItem.DeclinedRemarks = "";
            updatedItem.isAlreadyDeclined = false;
        }
        updatedList[index] = updatedItem;
        setRoadTestData(updatedList);
        setAllJobs(function (allJobs) {
            return _objectSpread(_objectSpread({}, allJobs), {}, {
                roadTestData: updatedList
            });
        });
        setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
            RoadTest: true
        }));
    };
    var handleSelectCustomerComplaintrejectReason = function (event, index) {
        var _event$target$value10, _event$target10;
        var updatedList = __spreadArray([], customerComplaintData, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        updatedItem.RejectReasonRemark = (_event$target$value10 = (_event$target10 = event.target) === null || _event$target10 === void 0 ? void 0 : _event$target10.value) !== null && _event$target$value10 !== void 0 ? _event$target$value10 : "";
        updatedList[index] = updatedItem;
        setCustomerComplaintData(updatedList);
        setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
            CustomerComplaint: true
        }));
        calculateJobCost(allJobs, roadTestData);
    };
    var handleSelectRoadTestAndCustomerComplaintrejectReason = function (event, index) {
        var _event$target$value11, _event$target11;
        var updatedList = __spreadArray([], roadTestData, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        updatedItem.RejectReasonRemark = (_event$target$value11 = (_event$target11 = event.target) === null || _event$target11 === void 0 ? void 0 : _event$target11.value) !== null && _event$target$value11 !== void 0 ? _event$target$value11 : "";
        updatedList[index] = updatedItem;
        setRoadTestData(updatedList);
        setAllJobs(function (allJobs) {
            return _objectSpread(_objectSpread({}, allJobs), {}, {
                roadTestData: updatedList
            });
        });
        setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
            RoadTest: true
        }));
        calculateJobCost(allJobs, roadTestData);
    };
    var handleChangeCustomerComplaintRejectRemark = function (event, index) {
        var _event$target$value12, _event$target12;
        var updatedList = __spreadArray([], customerComplaintData, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        updatedItem.DeclinedRemarks = (_event$target$value12 = (_event$target12 = event.target) === null || _event$target12 === void 0 ? void 0 : _event$target12.value) !== null && _event$target$value12 !== void 0 ? _event$target$value12 : "";
        updatedList[index] = updatedItem;
        setCustomerComplaintData(updatedList);
        setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
            CustomerComplaint: true
        }));
        calculateJobCost(allJobs, roadTestData);
    };
    var handleChangeRoadTestAndCustomerComplaintRejectRemark = function (event, index) {
        var _event$target$value13, _event$target13;
        var updatedList = __spreadArray([], roadTestData, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        updatedItem.DeclinedRemarks = (_event$target$value13 = (_event$target13 = event.target) === null || _event$target13 === void 0 ? void 0 : _event$target13.value) !== null && _event$target$value13 !== void 0 ? _event$target$value13 : "";
        updatedList[index] = updatedItem;
        setRoadTestData(updatedList);
        setAllJobs(function (allJobs) {
            return _objectSpread(_objectSpread({}, allJobs), {}, {
                roadTestData: updatedList
            });
        });
        setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
            RoadTest: true
        }));
        calculateJobCost(allJobs, roadTestData);
    };
    var getAdditionalJobSubTotal = function () {
        var approvedItems = additionalJobData.filter(function (item) { return !item.isExpanded && item.AutofillType !== 2; });
        // console.log('item>>', approvedItems);
        var additionalTotalPrice = 0;
        approvedItems.map(function (item) {
            var _item$SelectedPriceDe;
            if (((_item$SelectedPriceDe = item.SelectedPriceDetails) === null || _item$SelectedPriceDe === void 0 ? void 0 : _item$SelectedPriceDe.PriceGroupCategoryKey) === "MRP") {
                var _item$SelectedPriceDe2, _item$SelectedPriceDe3, _item$Price$;
                var amount = (_item$SelectedPriceDe2 = item.SelectedPriceDetails) !== null && _item$SelectedPriceDe2 !== void 0 && _item$SelectedPriceDe2.Amount ? (_item$SelectedPriceDe3 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe3 === void 0 || (_item$SelectedPriceDe3 = _item$SelectedPriceDe3.Amount) === null || _item$SelectedPriceDe3 === void 0 ? void 0 : _item$SelectedPriceDe3.toFixed(2) : (item === null || item === void 0 || (_item$Price$ = item.Price[0]) === null || _item$Price$ === void 0 || (_item$Price$ = _item$Price$.Amount) === null || _item$Price$ === void 0 ? void 0 : _item$Price$.toFixed(2)) || 0;
                additionalTotalPrice += Number(amount);
            }
            else {
                var _item$SelectedPriceDe4, _item$SelectedPriceDe5, _item$Price$2;
                var amount = (_item$SelectedPriceDe4 = item.SelectedPriceDetails) !== null && _item$SelectedPriceDe4 !== void 0 && _item$SelectedPriceDe4.Amount ? (_item$SelectedPriceDe5 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe5 === void 0 || (_item$SelectedPriceDe5 = _item$SelectedPriceDe5.Amount) === null || _item$SelectedPriceDe5 === void 0 ? void 0 : _item$SelectedPriceDe5.toFixed(2) : (item === null || item === void 0 || (_item$Price$2 = item.Price[0]) === null || _item$Price$2 === void 0 || (_item$Price$2 = _item$Price$2.Amount) === null || _item$Price$2 === void 0 ? void 0 : _item$Price$2.toFixed(2)) || 0;
                additionalTotalPrice += Number(amount);
            }
        });
        return additionalTotalPrice.toFixed(2);
    };
    var getPmPartsSubTotal = function () {
        var approvedItems = periodicPartData.filter(function (item) { return !item.isExpanded; });
        var PmTotalPrice = 0;
        approvedItems.map(function (item) {
            var _item$SelectedPriceDe6;
            if (((_item$SelectedPriceDe6 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe6 === void 0 ? void 0 : _item$SelectedPriceDe6.PriceGroupCategoryKey) === "MRP") {
                var _item$SelectedPriceDe7, _item$SelectedPriceDe8, _item$Price$3;
                var amount = (_item$SelectedPriceDe7 = item.SelectedPriceDetails) !== null && _item$SelectedPriceDe7 !== void 0 && _item$SelectedPriceDe7.Amount ? (_item$SelectedPriceDe8 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe8 === void 0 || (_item$SelectedPriceDe8 = _item$SelectedPriceDe8.Amount) === null || _item$SelectedPriceDe8 === void 0 ? void 0 : _item$SelectedPriceDe8.toFixed(2) : (item === null || item === void 0 || (_item$Price$3 = item.Price[0]) === null || _item$Price$3 === void 0 || (_item$Price$3 = _item$Price$3.Amount) === null || _item$Price$3 === void 0 ? void 0 : _item$Price$3.toFixed(2)) || 0;
                PmTotalPrice += Number(amount);
            }
            else {
                var _item$SelectedPriceDe9, _item$SelectedPriceDe10, _item$Price$4;
                var amount = (_item$SelectedPriceDe9 = item.SelectedPriceDetails) !== null && _item$SelectedPriceDe9 !== void 0 && _item$SelectedPriceDe9.Amount ? (_item$SelectedPriceDe10 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe10 === void 0 || (_item$SelectedPriceDe10 = _item$SelectedPriceDe10.Amount) === null || _item$SelectedPriceDe10 === void 0 ? void 0 : _item$SelectedPriceDe10.toFixed(2) : (item === null || item === void 0 || (_item$Price$4 = item.Price[0]) === null || _item$Price$4 === void 0 || (_item$Price$4 = _item$Price$4.Amount) === null || _item$Price$4 === void 0 ? void 0 : _item$Price$4.toFixed(2)) || 0;
                PmTotalPrice += Number(amount);
            }
        });
        return PmTotalPrice.toFixed(2);
    };
    var getStandardJobsPartsSubTotal = function () {
        var approvedItems = standardJobData.filter(function (item) { return !item.isExpanded; });
        return approvedItems === null || approvedItems === void 0 ? void 0 : approvedItems.reduce(function (total, el) {
            var _el$PartPrice;
            return Number((_el$PartPrice = el.PartPrice) !== null && _el$PartPrice !== void 0 ? _el$PartPrice : 0) + Number(total);
        }, 0).toFixed(2);
    };
    var getStandardJobsLabourSubTotal = function () {
        var approvedItems = standardJobData.filter(function (item) { return !item.isExpanded; });
        return approvedItems === null || approvedItems === void 0 ? void 0 : approvedItems.reduce(function (total, el) {
            var _el$LabourPrice;
            return Number((_el$LabourPrice = el.LabourPrice) !== null && _el$LabourPrice !== void 0 ? _el$LabourPrice : 0) + Number(total);
        }, 0).toFixed(2);
    };
    var getStandardJobsTotal = function () {
        var totalPrice = 0;
        var approvedItems = standardJobData.filter(function (item) { return !item.isExpanded; });
        approvedItems.forEach(function (option) {
            totalPrice += getStandardJobGroupTotal(option);
        });
        return totalPrice.toFixed(2);
        // return (approvedItems.reduce((total: any, el: any) => Number(el.Part?.SelectedPriceDetails?.Amount ?? 0) + Number(total), 0) + approvedItems?.reduce((total: any, el: any) => Number(el.Labour?.SelectedPriceDetails?.Amount ?? 0) + Number(total), 0)).toFixed(2)
    };
    var getCustomerComplaintsTotal = function () {
        var approvedItems = roadTestData.filter(function (item) { return !item.isExpanded; });
        return ((approvedItems === null || approvedItems === void 0 ? void 0 : approvedItems.reduce(function (total, el) {
            var _el$PartPrice2;
            return Number((_el$PartPrice2 = el.PartPrice) !== null && _el$PartPrice2 !== void 0 ? _el$PartPrice2 : 0) + Number(total);
        }, 0)) + (approvedItems === null || approvedItems === void 0 ? void 0 : approvedItems.reduce(function (total, el) {
            var _el$LabourPrice2;
            return Number((_el$LabourPrice2 = el.LabourPrice) !== null && _el$LabourPrice2 !== void 0 ? _el$LabourPrice2 : 0) + Number(total);
        }, 0))).toFixed(2);
    };
    var getCustomerComplaintsPartsSubTotal = function () {
        var approvedItems = roadTestData.filter(function (item) { return !item.isExpanded; });
        return approvedItems.reduce(function (total, el) {
            var _el$PartPrice3;
            return Number((_el$PartPrice3 = el.PartPrice) !== null && _el$PartPrice3 !== void 0 ? _el$PartPrice3 : 0) + Number(total);
        }, 0).toFixed(2);
    };
    var getCustomerComplaintsLaboursSubTotal = function () {
        var approvedItems = roadTestData.filter(function (item) { return !item.isExpanded; });
        return approvedItems.reduce(function (total, el) {
            var _el$LabourPrice3;
            return Number((_el$LabourPrice3 = el.LabourPrice) !== null && _el$LabourPrice3 !== void 0 ? _el$LabourPrice3 : 0) + Number(total);
        }, 0).toFixed(2);
    };
    var getRoadTestTotal = function () {
        var approvedItems = roadTestData.filter(function (item) { return !item.isExpanded; });
        return ((approvedItems === null || approvedItems === void 0 ? void 0 : approvedItems.reduce(function (total, el) {
            var _el$PartPrice4;
            return Number((_el$PartPrice4 = el.PartPrice) !== null && _el$PartPrice4 !== void 0 ? _el$PartPrice4 : 0) + Number(total);
        }, 0)) + (approvedItems === null || approvedItems === void 0 ? void 0 : approvedItems.reduce(function (total, el) {
            var _el$LabourPrice4;
            return Number((_el$LabourPrice4 = el.LabourPrice) !== null && _el$LabourPrice4 !== void 0 ? _el$LabourPrice4 : 0) + Number(total);
        }, 0))).toFixed(2);
    };
    var getRoadTestPartsSubTotal = function () {
        var approvedItems = roadTestData.filter(function (item) { return !item.isExpanded; });
        return approvedItems.reduce(function (total, el) {
            var _el$PartPrice5;
            return Number((_el$PartPrice5 = el.PartPrice) !== null && _el$PartPrice5 !== void 0 ? _el$PartPrice5 : 0) + Number(total);
        }, 0).toFixed(2);
    };
    var getRoadTestLaboursSubTotal = function () {
        var approvedItems = roadTestData.filter(function (item) { return !item.isExpanded; });
        return approvedItems.reduce(function (total, el) {
            var _el$LabourPrice5;
            return Number((_el$LabourPrice5 = el.LabourPrice) !== null && _el$LabourPrice5 !== void 0 ? _el$LabourPrice5 : 0) + Number(total);
        }, 0).toFixed(2);
    };
    var onClickCloseIconRoadTest = function (index) {
        var updatedList = __spreadArray([], roadTestData, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        updatedItem.isExpanded = !updatedItem.isExpanded;
        if (!updatedItem.isExpanded) {
            updatedItem.RejectReasonRemark = "";
            updatedItem.DeclinedRemarks = "";
            updatedItem.isAlreadyDeclined = false;
        }
        updatedList[index] = updatedItem;
        setRoadTestData(updatedList);
        setAllJobs(function (allJobs) {
            return _objectSpread(_objectSpread({}, allJobs), {}, {
                roadTestData: updatedList
            });
        });
        setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
            RoadTest: true
        }));
    };
    var handleSelectRoadTestRejectReason = function (event, index) {
        var _event$target$value14, _event$target14;
        var updatedList = __spreadArray([], roadTestData, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        updatedItem.RejectReasonRemark = (_event$target$value14 = (_event$target14 = event.target) === null || _event$target14 === void 0 ? void 0 : _event$target14.value) !== null && _event$target$value14 !== void 0 ? _event$target$value14 : "";
        updatedList[index] = updatedItem;
        setRoadTestData(updatedList);
        setAllJobs(function (allJobs) {
            return _objectSpread(_objectSpread({}, allJobs), {}, {
                roadTestData: updatedList
            });
        });
        setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
            RoadTest: true
        }));
        calculateJobCost(allJobs, roadTestData);
    };
    var handleChangeRoadTestRejectRemark = function (event, index) {
        var _event$target$value15, _event$target15;
        var updatedList = __spreadArray([], roadTestData, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        updatedItem.DeclinedRemarks = (_event$target$value15 = (_event$target15 = event.target) === null || _event$target15 === void 0 ? void 0 : _event$target15.value) !== null && _event$target$value15 !== void 0 ? _event$target$value15 : "";
        updatedList[index] = updatedItem;
        setRoadTestData(updatedList);
        setAllJobs(function (allJobs) {
            return _objectSpread(_objectSpread({}, allJobs), {}, {
                roadTestData: updatedList
            });
        });
        setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
            RoadTest: true
        }));
        calculateJobCost(allJobs, roadTestData);
    };
    var handleRoadTestToggle = function (ComplaintId) {
        setIsOpenRoadTest(!isOpenRoadTest);
        var _roadTestData = roadTestData.map(function (it) {
            if ((it === null || it === void 0 ? void 0 : it.ComplaintId) === ComplaintId) {
                var obj = _objectSpread(_objectSpread({}, it), {}, {
                    isOpenRoadTest: it !== null && it !== void 0 && it.isOpenRoadTest ? false : true
                });
                return obj;
            }
            else {
                var obj = _objectSpread(_objectSpread({}, it), {}, {
                    isOpenRoadTest: (it === null || it === void 0 ? void 0 : it.isOpenRoadTest) || false
                });
                return obj;
            }
        });
        setRoadTestData(_roadTestData);
        setAllJobs(function (allJobs) {
            return _objectSpread(_objectSpread({}, allJobs), {}, {
                roadTestData: _roadTestData
            });
        });
    };
    var handleCustomerComplaintToggle = function (ComplaintId) {
        setIsOpenCustomerComplaint(!isOpenCustomerComplaint);
        var _customerComplaintData = customerComplaintData.map(function (it) {
            if ((it === null || it === void 0 ? void 0 : it.ComplaintId) === ComplaintId) {
                var obj = _objectSpread(_objectSpread({}, it), {}, {
                    isOpenCustomerComplaint: it !== null && it !== void 0 && it.isOpenCustomerComplaint ? false : true
                });
                return obj;
            }
            else {
                var obj = _objectSpread(_objectSpread({}, it), {}, {
                    isOpenCustomerComplaint: (it === null || it === void 0 ? void 0 : it.isOpenCustomerComplaint) || false
                });
                return obj;
            }
        });
        setCustomerComplaintData(_customerComplaintData);
    };
    var handleCountLabourPrice = function (array) {
        var count = 0;
        for (var i = 0; i < array.length; i++) {
            count += array[i].Price || 0;
        }
        return count;
    };
    var handleUpdateLabourAndPartChange = function (Element, Item, value, type) {
        var _customerComplaintData = customerComplaintData.map(function (it) {
            if ((it === null || it === void 0 ? void 0 : it.ComplaintId) === (Element === null || Element === void 0 ? void 0 : Element.ComplaintId)) {
                if (type === 'Labour') {
                    var _it$ComplaintAssociat;
                    var _labour = it === null || it === void 0 || (_it$ComplaintAssociat = it.ComplaintAssociations) === null || _it$ComplaintAssociat === void 0 || (_it$ComplaintAssociat = _it$ComplaintAssociat.Labour) === null || _it$ComplaintAssociat === void 0 ? void 0 : _it$ComplaintAssociat.map(function (el) {
                        if ((el === null || el === void 0 ? void 0 : el.ChildId) === (Item === null || Item === void 0 ? void 0 : Item.ChildId)) {
                            var _el = _objectSpread(_objectSpread({}, el), {}, {
                                Price: Number(value)
                            });
                            return _el;
                        }
                        else {
                            return el;
                        }
                    });
                    var obj = _objectSpread(_objectSpread({}, it), {}, {
                        LabourPrice: handleCountLabourPrice(_labour),
                        ComplaintAssociations: _objectSpread(_objectSpread({}, it === null || it === void 0 ? void 0 : it.ComplaintAssociations), {}, {
                            Labour: _labour
                        })
                    });
                    return obj;
                }
                else {
                    var _it$ComplaintAssociat2;
                    var _part = it === null || it === void 0 || (_it$ComplaintAssociat2 = it.ComplaintAssociations) === null || _it$ComplaintAssociat2 === void 0 || (_it$ComplaintAssociat2 = _it$ComplaintAssociat2.Part) === null || _it$ComplaintAssociat2 === void 0 ? void 0 : _it$ComplaintAssociat2.map(function (el) {
                        if ((el === null || el === void 0 ? void 0 : el.ChildId) === (Item === null || Item === void 0 ? void 0 : Item.ChildId)) {
                            var _el = _objectSpread(_objectSpread({}, el), {}, {
                                Price: Number(value)
                            });
                            return _el;
                        }
                        else {
                            return el;
                        }
                    });
                    var obj = _objectSpread(_objectSpread({}, it), {}, {
                        PartPrice: handleCountLabourPrice(_part),
                        ComplaintAssociations: _objectSpread(_objectSpread({}, it === null || it === void 0 ? void 0 : it.ComplaintAssociations), {}, {
                            Part: _part
                        })
                    });
                    return obj;
                }
            }
            else {
                return it;
            }
        });
        return _customerComplaintData;
    };
    var handlePartLabourPriceChange = function (event, Item, Element, type, parentType) {
        var value = event.target.value;
        value = value.replace(/^0+(?!\.)/, '');
        if (regex.test(value) || value == '') {
            // let _customerComplaintData = customerComplaintData.map((it: any) => {
            //   if (it?.ComplaintId === Element?.ComplaintId) {
            //     if (type === 'Labour') {
            //       let _labour = it?.ComplaintAssociations?.Labour?.map((el: any) => {
            //         if (el?.ChildId === Item?.ChildId) {
            //           let _el = {
            //             ...el,
            //             Price: Number(value)
            //           }
            //           return _el
            //         } else {
            //           return el
            //         }
            //       })
            //       let obj = {
            //         ...it,
            //         LabourPrice: handleCountLabourPrice(_labour),
            //         ComplaintAssociations: { ...it?.ComplaintAssociations, Labour: _labour }
            //       }
            //       return obj
            //     } else {
            //       let _part = it?.ComplaintAssociations?.Part?.map((el: any) => {
            //         if (el?.ChildId === Item?.ChildId) {
            //           let _el = {
            //             ...el,
            //             Price: Number(value)
            //           }
            //           return _el
            //         } else {
            //           return el
            //         }
            //       })
            //       let obj = {
            //         ...it,
            //         PartPrice: handleCountLabourPrice(_part),
            //         ComplaintAssociations: { ...it?.ComplaintAssociations, Part: _part }
            //       }
            //       return obj
            //     }
            //   } else {
            //     return it
            //   }
            // })
            switch (parentType) {
                case EModuleSection.CustomerVoice:
                    var _customerComplaintData = handleUpdateLabourAndPartChange(Element, Item, value, type);
                    setCustomerComplaintData(_customerComplaintData);
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        CustomerComplaint: true
                    }));
                    break;
                case EModuleSection.RoadTest:
                    var _roadTestData_1 = handleUpdateLabourAndPartChange(Element, Item, value, type);
                    setRoadTestData(_roadTestData_1);
                    setAllJobs(function (allJobs) {
                        return _objectSpread(_objectSpread({}, allJobs), {}, {
                            roadTestData: _roadTestData_1
                        });
                    });
                    setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                        RoadTest: true
                    }));
                    break;
                default:
                    break;
            }
        }
    };
    var handlePartLabourAccordion = function (data) {
        var type = data.type, Name = data.Name, Code = data.Code, Price = data.Price, Quantity = data.Quantity, ServiceType = data.ServiceType, Item = data.Item, Element = data.Element, parentType = data.parentType;
        return /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 12,
            md: 12,
            my: "5px",
            sx: {
                border: '1px solid #DEE4EB',
                backgroundColor: '#F4F7FA',
                borderRadius: 1,
                padding: "12px 16px !important"
            }
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 8,
            sm: 8,
            md: 8
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            gap: isXs ? "10px" : "0px"
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 6,
            md: 6,
            display: 'flex',
            justifyContent: 'space-between',
            pr: '10px'
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {
                flexDirection: 'column'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h5"
        }, Name), /*#__PURE__*/ React.createElement(Typography, {
            variant: "subtitle2"
        }, "#".concat(Code))), /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {
                border: '1px solid #AFD5FF',
                borderRadius: '11px',
                height: '22px',
                width: '24px',
                justifyContent: 'center',
                placeItems: 'center',
                backgroundColor: "#EEF6FF"
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "subtitle2",
            color: "#3697FF"
        }, type === 'Labour' ? 'L' : 'P'))), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 6,
            md: 6
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "subtitle1",
            color: gray
        }, 'Service type'), /*#__PURE__*/ React.createElement(Typography, {
            variant: "h6",
            color: mobilenoblack
        }, ServiceType)))), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 4,
            sm: 4,
            md: 4
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            gap: isXs ? "10px" : "0px",
            direction: isXs ? 'column-reverse' : 'row'
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 4,
            md: 4
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "subtitle1",
            color: gray
        }, type === 'Labour' ? 'Unit:' : 'Qty:'), /*#__PURE__*/ React.createElement(Typography, {
            variant: "h6",
            color: mobilenoblack
        }, Quantity)), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 8,
            md: 8
        }, /*#__PURE__*/ React.createElement(InputBox
        // disabled={!option?.IsEditable || isDisabled}
        // name={option?.CustomerComplaint}
        , {
            value: Price || '0',
            onChange: function (event) { return handlePartLabourPriceChange(event, Item, Element, type, parentType); },
            size: "small",
            inputProps: {
                inputMode: 'decimal',
                pattern: '[0-9]*[.,]?[0-9]*'
            },
            sx: {
                backgroundColor: "#FFFFFF",
                border: "1px solid #DEE4EB",
                borderRadius: "8px",
                ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input": {
                    padding: "8.5px 5px"
                },
                ".css-km5qz1-MuiInputBase-root-MuiOutlinedInput-root": {
                    fontSize: '14px'
                }
            }
        }))))));
    };
    var toggleSection = function (index) {
        setOpenSections(function (prevSections) {
            var _a;
            return _objectSpread(_objectSpread({}, prevSections), {}, (_a = {},
                _a[index] = !prevSections[index],
                _a));
        });
    };
    var checkReasonRemarkValidate = function (items) {
        var expandedItems = items.filter(function (item) { return item.isExpanded; });
        if (expandedItems.length > 0) {
            var isAllReasonMandatoryValidated = Object.values(expandedItems).every(function (item) { return item.RejectReasonRemark; });
            var isRemarkMandatoryValidated = Object.values(expandedItems).every(function (item) { return item.DeclinedRemarks; });
            if (declinedJobsConfiguration !== null && declinedJobsConfiguration !== void 0 && declinedJobsConfiguration.IsReasonsMandatory && declinedJobsConfiguration !== null && declinedJobsConfiguration !== void 0 && declinedJobsConfiguration.IsRemarksMandatory) {
                return !(isAllReasonMandatoryValidated && isRemarkMandatoryValidated);
            }
            else if (declinedJobsConfiguration !== null && declinedJobsConfiguration !== void 0 && declinedJobsConfiguration.IsReasonsMandatory) {
                return !isAllReasonMandatoryValidated;
            }
            else if (declinedJobsConfiguration !== null && declinedJobsConfiguration !== void 0 && declinedJobsConfiguration.IsRemarksMandatory) {
                return !isRemarkMandatoryValidated;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    var getCustomerVoiceSubTotal = function () {
        var approvedItems = customerComplaintData.filter(function (item) { return !item.isExpanded; });
        return ((approvedItems === null || approvedItems === void 0 ? void 0 : approvedItems.reduce(function (total, el) {
            var _el$PartPrice6;
            return Number((_el$PartPrice6 = el.PartPrice) !== null && _el$PartPrice6 !== void 0 ? _el$PartPrice6 : 0) + Number(total);
        }, 0)) + (approvedItems === null || approvedItems === void 0 ? void 0 : approvedItems.reduce(function (total, el) {
            var _el$LabourPrice6;
            return Number((_el$LabourPrice6 = el.LabourPrice) !== null && _el$LabourPrice6 !== void 0 ? _el$LabourPrice6 : 0) + Number(total);
        }, 0))).toFixed(2);
    };
    var getCustomerVoiceSubTotalPart = function () {
        var approvedItems = customerComplaintData.filter(function (item) { return !item.isExpanded; });
        return approvedItems === null || approvedItems === void 0 ? void 0 : approvedItems.reduce(function (total, el) {
            var _el$PartPrice7;
            return Number((_el$PartPrice7 = el.PartPrice) !== null && _el$PartPrice7 !== void 0 ? _el$PartPrice7 : 0) + Number(total);
        }, 0).toFixed(2);
    };
    var getCustomerVoiceSubTotalLabour = function () {
        var approvedItems = customerComplaintData.filter(function (item) { return !item.isExpanded; });
        return approvedItems === null || approvedItems === void 0 ? void 0 : approvedItems.reduce(function (total, el) {
            var _el$LabourPrice7;
            return Number((_el$LabourPrice7 = el.LabourPrice) !== null && _el$LabourPrice7 !== void 0 ? _el$LabourPrice7 : 0) + Number(total);
        }, 0).toFixed(2);
    };
    var getStandardJobsSaveDisable = function () {
        var expandedItems = standardJobData.filter(function (item) { return item.isExpanded; });
        if (expandedItems.length > 0) {
            var isAllExpandedValuesFilled = Object.values(expandedItems).every(function (item) { return item.RejectReasonRemark; });
            return !isAllExpandedValuesFilled;
        }
        else {
            return false;
        }
    };
    var getAdditionalJobsSaveDisable = function () {
        var expandedItems = additionalJobData.filter(function (item) { return item.isExpanded; });
        if (expandedItems.length > 0) {
            var isAllExpandedValuesFilled = Object.values(expandedItems).every(function (item) { return item.RejectReasonRemark; });
            return !isAllExpandedValuesFilled;
        }
        else {
            return false;
        }
    };
    var getCustomerComplaintsSaveDisable = function () {
        var expandedItems = roadTestData.filter(function (item) { return item.isExpanded; });
        if (expandedItems.length > 0) {
            var isAllExpandedValuesFilled = Object.values(expandedItems).every(function (item) { return item.RejectReasonRemark; });
            return !isAllExpandedValuesFilled;
        }
        else {
            return false;
        }
    };
    var showCrossButtonConditionAdditionalJobs = function (item) {
        // Logic for remove autofill parts 
        if (item.jobType === "Labour") {
            return !item.IsAutoFill; // cant remove autofill labours
        }
        else if (item.jobType === "Part") {
            if (item.IsAutoFill) {
                if (item.AutofillType === 2 && item.PartType && item.PartType === "OilPart") {
                    return true; // can remove only autofillType 2 and part is oil part
                }
                else {
                    return false;
                }
            }
            else {
                return true; // can remove non autofill parts
            }
        }
        return false;
    };
    var validateAndGetTax = function (updatedItem, Qty) { return __awaiter(_this, void 0, void 0, function () {
        var _documentDetailsGetBy58, _updatedItem$Selected, _updatedItem$Selected2, _documentDetailsGetBy59, _updatedItem$Selected3, _documentDetailsGetBy60, _documentDetailsGetBy61, _installbaseDetailsBy, _Response$payload, _Response$payload2, requestBody, Response, _Response$payload3, data, success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        "ProductId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy58 = documentDetailsGetById.data) === null || _documentDetailsGetBy58 === void 0 ? void 0 : _documentDetailsGetBy58.ProductId,
                        "ChildId": updatedItem === null || updatedItem === void 0 ? void 0 : updatedItem.ChildId,
                        MRP: updatedItem === null || updatedItem === void 0 || (_updatedItem$Selected = updatedItem.SelectedPriceDetails) === null || _updatedItem$Selected === void 0 ? void 0 : _updatedItem$Selected.MRP,
                        Quantity: Qty,
                        "Rate": updatedItem === null || updatedItem === void 0 || (_updatedItem$Selected2 = updatedItem.SelectedPriceDetails) === null || _updatedItem$Selected2 === void 0 ? void 0 : _updatedItem$Selected2.Rate,
                        DocumentDate: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy59 = documentDetailsGetById.data) === null || _documentDetailsGetBy59 === void 0 ? void 0 : _documentDetailsGetBy59.CreatedOn,
                        "Entity": ESystemName.Estimate,
                        "ServiceTypeId": updatedItem === null || updatedItem === void 0 ? void 0 : updatedItem.ServiceTypeId,
                        "UnitOfMeasurementId": updatedItem === null || updatedItem === void 0 ? void 0 : updatedItem.UnitOfMeasurementId,
                        "PriceMethod": (updatedItem === null || updatedItem === void 0 || (_updatedItem$Selected3 = updatedItem.SelectedPriceDetails) === null || _updatedItem$Selected3 === void 0 ? void 0 : _updatedItem$Selected3.PriceGroupCategoryKey) || "MRP",
                        OrganizationStateCode: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy60 = documentDetailsGetById.data) === null || _documentDetailsGetBy60 === void 0 ? void 0 : _documentDetailsGetBy60.OrganizationStateCode,
                        CustomerStateCode: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy61 = documentDetailsGetById.data) === null || _documentDetailsGetBy61 === void 0 ? void 0 : _documentDetailsGetBy61.CustomerStateCode,
                        IsTaxExempted: updatedItem.IsTaxExempted,
                        HSNSACCode: updatedItem.SelectedPriceDetails.HSNSACCode,
                        CDMSHSNSACCode: updatedItem.SelectedPriceDetails.CDMSHSNSACCode,
                        ChildSystemName: updatedItem.jobType === "Part" ? "Part" : "Labour",
                        DateOfMfg: installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy = installbaseDetailsById.data) === null || _installbaseDetailsBy === void 0 ? void 0 : _installbaseDetailsBy.DateOfMfg
                    };
                    // if (updatedItem.jobType === "Part") {
                    //   requestBody.HSNCode = updatedItem?.HSNCode
                    // } else {
                    //   requestBody.SACCode = updatedItem?.SACCode
                    // }
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    // if (updatedItem.jobType === "Part") {
                    //   requestBody.HSNCode = updatedItem?.HSNCode
                    // } else {
                    //   requestBody.SACCode = updatedItem?.SACCode
                    // }
                    _a.sent();
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: getValidateQuantityAndGetTaxesUrl,
                            request: requestBody
                        }))];
                case 2:
                    Response = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    if (Response !== null && Response !== void 0 && (_Response$payload = Response.payload) !== null && _Response$payload !== void 0 && (_Response$payload = _Response$payload.value) !== null && _Response$payload !== void 0 && _Response$payload.success && Response !== null && Response !== void 0 && (_Response$payload2 = Response.payload) !== null && _Response$payload2 !== void 0 && (_Response$payload2 = _Response$payload2.value) !== null && _Response$payload2 !== void 0 && _Response$payload2.data) {
                        data = Response === null || Response === void 0 || (_Response$payload3 = Response.payload) === null || _Response$payload3 === void 0 || (_Response$payload3 = _Response$payload3.value) === null || _Response$payload3 === void 0 ? void 0 : _Response$payload3.data;
                        success = true;
                        return [2 /*return*/, {
                                data: data,
                                success: success
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                data: null,
                                success: false
                            }];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var debouncedTaxCalculation = useCallback(debounce(function (updatedQuantity, updataedItem, index) { return __awaiter(_this, void 0, void 0, function () {
        var TaxesBasedOnQuantity, _a, Amount_1, MRP_1, Rate_1, TaxableAmount_1, Taxes_1, BaseAmount_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, validateAndGetTax(updataedItem, updatedQuantity)];
                case 1:
                    TaxesBasedOnQuantity = _b.sent();
                    if (TaxesBasedOnQuantity.success && TaxesBasedOnQuantity !== null && TaxesBasedOnQuantity !== void 0 && TaxesBasedOnQuantity.data) {
                        _a = TaxesBasedOnQuantity.data, Amount_1 = _a.Amount, MRP_1 = _a.MRP, Rate_1 = _a.Rate, TaxableAmount_1 = _a.TaxableAmount, Taxes_1 = _a.Taxes, BaseAmount_1 = _a.BaseAmount;
                        setAdditionalJobData(function (prev) {
                            var updatedJobsList = __spreadArray([], prev, true);
                            var updatedItem = _objectSpread({}, prev[index]);
                            updatedItem.SelectedPriceDetails = _objectSpread(_objectSpread({}, updataedItem.SelectedPriceDetails), {}, {
                                error: false,
                                errorMessage: "",
                                Amount: Amount_1,
                                MRP: MRP_1,
                                Rate: Rate_1,
                                TaxableAmount: TaxableAmount_1,
                                Taxes: Taxes_1,
                                BaseAmount: BaseAmount_1,
                                OriginalRate: Rate_1
                            });
                            updatedItem.OriginalQuantity = updatedQuantity;
                            updatedJobsList[index] = updatedItem;
                            return updatedJobsList;
                        });
                        setDisabledSave(function (prevValues) {
                            return _objectSpread(_objectSpread({}, prevValues), {}, {
                                AdditionalJob: true
                            });
                        });
                    }
                    else {
                        setAdditionalJobData(function (prev) {
                            var updatedJobsList = __spreadArray([], prev, true);
                            var updatedItem = _objectSpread({}, prev[index]);
                            updatedItem.Quantity = updatedItem.OriginalQuantity;
                            updatedJobsList[index] = updatedItem;
                            return updatedJobsList;
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); }, 500), []);
    var handleQuantityDecrement = function (index) {
        var updatedJobsList = __spreadArray([], additionalJobData, true);
        var updatedItem = updatedJobsList[index];
        if (Number((Number(updatedItem.Quantity) - 1).toFixed(2)) > 999999.99) {
            updatedItem.Quantity = Number((Number(updatedItem.Quantity) - 1).toFixed(2));
            updatedItem.error = true;
            updatedItem.errorMessage = 'Quantity cannot be greater than 999999.99';
            updatedJobsList[index] = updatedItem;
            setAdditionalJobData(updatedJobsList);
            return;
        }
        setAdditionalJobData(function (prev) {
            var updatedJobsList = __spreadArray([], prev, true);
            var updatedItem = _objectSpread({}, prev[index]);
            var newQuantity = Number((Number(updatedItem.Quantity) - 1).toFixed(2));
            if (newQuantity < 1)
                return prev;
            debouncedTaxCalculation(newQuantity, updatedItem, index);
            updatedItem.Quantity = newQuantity;
            updatedItem.error = false;
            updatedItem.errorMessage = "";
            updatedJobsList[index] = updatedItem;
            return updatedJobsList;
        });
    };
    var handleQuantityIncrement = function (index) {
        var updatedJobsList = __spreadArray([], additionalJobData, true);
        var updatedItem = updatedJobsList[index];
        if (Number((Number(updatedItem.Quantity) + 1).toFixed(2)) > 999999.99) {
            updatedItem.Quantity = Number((Number(updatedItem.Quantity) + 1).toFixed(2));
            updatedItem.error = true;
            updatedItem.errorMessage = 'Quantity cannot be greater than 999999.99';
            updatedJobsList[index] = updatedItem;
            setAdditionalJobData(updatedJobsList);
            return;
        }
        setAdditionalJobData(function (prev) {
            var updatedJobsList = __spreadArray([], prev, true);
            var updatedItem = _objectSpread({}, prev[index]);
            var newQuantity = Number((Number(updatedItem.Quantity) + 1).toFixed(2));
            debouncedTaxCalculation(newQuantity, updatedItem, index);
            updatedItem.Quantity = newQuantity;
            updatedJobsList[index] = updatedItem;
            return updatedJobsList;
        });
    };
    var handleQuantityChange = function (event, index) { return __awaiter(_this, void 0, void 0, function () {
        var value, updatedJobsList, updatedItem, DecimalPrecision, validationRules;
        return __generator(this, function (_a) {
            value = event.target.value;
            updatedJobsList = __spreadArray([], additionalJobData, true);
            updatedItem = _objectSpread({}, updatedJobsList[index]);
            if (!value) {
                updatedItem.Quantity = "";
                updatedItem.error = false;
                updatedItem.errorMessage = "";
            }
            else {
                if (!/^\d*\.?\d*$/.test(value))
                    return [2 /*return*/];
                if (+value <= 0) {
                    updatedItem.error = true;
                    updatedItem.errorMessage = "Quantity should be greater than 0";
                }
                else {
                    DecimalPrecision = updatedItem.DecimalPrecision;
                    validationRules = {
                        0: REG.validateInteger,
                        1: REG.validateDecimalUptoOneDigit,
                        2: REG.validateDecimalAndNonNumeric
                    };
                    if (DecimalPrecision !== undefined && validationRules[DecimalPrecision]) {
                        if (!validationRules[DecimalPrecision].test(value)) {
                            updatedItem.error = true;
                            updatedItem.errorMessage = "Up to ".concat(DecimalPrecision, " decimal precision is allowed");
                            if (DecimalPrecision === 0) {
                                updatedItem.errorMessage = "Enter Qty in multiple of 1";
                            }
                        }
                        else {
                            updatedItem.Quantity = value;
                            updatedItem.error = false;
                            updatedItem.errorMessage = "";
                        }
                    }
                }
            }
            updatedJobsList[index] = updatedItem;
            updateAdditionalJobs(updatedJobsList);
            setHasUnsavedChanges(function (prev) { return prev ? !prev : true; });
            return [2 /*return*/];
        });
    }); };
    var handleOnBlurQuantityChange = function (index) { return __awaiter(_this, void 0, void 0, function () {
        var updatedJobsList, updatedItem, newQuantity, TaxesBasedOnQuantity, tempUpdatedItem, _TaxesBasedOnQuantity, _TaxesBasedOnQuantity2, _TaxesBasedOnQuantity3, _TaxesBasedOnQuantity4, _TaxesBasedOnQuantity5, _TaxesBasedOnQuantity6, _TaxesBasedOnQuantity7, _TaxesBasedOnQuantity8, updatedSelectedPrice;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updatedJobsList = __spreadArray([], additionalJobData, true);
                    updatedItem = _objectSpread({}, updatedJobsList[index]);
                    if (!updatedItem.Quantity) {
                        updatedItem.error = true;
                        updatedItem.errorMessage = 'Quantity should be greater than 0';
                        updatedJobsList[index] = updatedItem;
                        updateAdditionalJobs(updatedJobsList);
                        return [2 /*return*/];
                    }
                    else if (Number(Number(updatedItem.Quantity).toFixed(2)) > 999999.99) {
                        updatedItem.error = true;
                        updatedItem.errorMessage = 'Quantity cannot be greater than 999999.99';
                        updatedJobsList[index] = updatedItem;
                        updateAdditionalJobs(updatedJobsList);
                        return [2 /*return*/];
                    }
                    else {
                        updatedItem.error = false;
                        updatedItem.errorMessage = '';
                    }
                    if (!!updatedItem.error) return [3 /*break*/, 2];
                    newQuantity = Number(Number(updatedItem.Quantity).toFixed(2));
                    return [4 /*yield*/, validateAndGetTax(updatedItem, newQuantity)];
                case 1:
                    TaxesBasedOnQuantity = _a.sent();
                    tempUpdatedItem = _objectSpread({}, updatedItem);
                    if (TaxesBasedOnQuantity.success && TaxesBasedOnQuantity !== null && TaxesBasedOnQuantity !== void 0 && TaxesBasedOnQuantity.data) {
                        tempUpdatedItem.Quantity = newQuantity;
                        tempUpdatedItem.OriginalQuantity = newQuantity;
                        updatedSelectedPrice = _objectSpread({}, updatedItem.SelectedPriceDetails);
                        updatedSelectedPrice.Amount = TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity === void 0 ? void 0 : _TaxesBasedOnQuantity.Amount;
                        updatedSelectedPrice.Quantity = TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity2 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity2 === void 0 ? void 0 : _TaxesBasedOnQuantity2.Quantity;
                        updatedSelectedPrice.BaseAmount = TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity3 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity3 === void 0 ? void 0 : _TaxesBasedOnQuantity3.BaseAmount;
                        updatedSelectedPrice.MRP = TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity4 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity4 === void 0 ? void 0 : _TaxesBasedOnQuantity4.MRP;
                        updatedSelectedPrice.Rate = TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity5 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity5 === void 0 ? void 0 : _TaxesBasedOnQuantity5.Rate;
                        updatedSelectedPrice.OriginalRate = TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity6 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity6 === void 0 ? void 0 : _TaxesBasedOnQuantity6.Rate;
                        updatedSelectedPrice.TaxableAmount = TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity7 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity7 === void 0 ? void 0 : _TaxesBasedOnQuantity7.TaxableAmount;
                        updatedSelectedPrice.Taxes = TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity8 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity8 === void 0 ? void 0 : _TaxesBasedOnQuantity8.Taxes;
                        updatedItem.SelectedPriceDetails = updatedSelectedPrice;
                        updatedItem.error = false;
                        updatedItem.errorMessage = "";
                        updatedJobsList[index] = updatedItem;
                        updateAdditionalJobs(updatedJobsList);
                        setDisabledSave(function (prevValues) {
                            return _objectSpread(_objectSpread({}, prevValues), {}, {
                                AdditionalJob: true
                            });
                        });
                    }
                    else {
                        console.warn('No data or error in tax response');
                        tempUpdatedItem.Quantity = tempUpdatedItem.OriginalQuantity;
                        tempUpdatedItem.SelectedPriceDetails = _objectSpread({}, tempUpdatedItem.SelectedPriceDetails);
                        updatedJobsList[index] = tempUpdatedItem;
                        updateAdditionalJobs(updatedJobsList);
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var ReCallBatch = function (_ref2) {
        var option = _ref2.option, index = _ref2.index;
        return /*#__PURE__*/ React.createElement(MuiStack, {
            alignItems: 'center',
            sx: {
                mt: 0
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: (option === null || option === void 0 ? void 0 : option.jobType) === 'Labour' ? "labour-code-".concat(index) : "part-code-".concat(index),
            sx: {
                fontSize: '12px',
                fontWeight: '400'
            },
            variant: "h4",
            color: '#6A7682'
        }, (option === null || option === void 0 ? void 0 : option.jobType) == "Labour" ? option !== null && option !== void 0 && option.LabourCode ? "#".concat(option === null || option === void 0 ? void 0 : option.LabourCode) : '-' : option !== null && option !== void 0 && option.PartCode ? "#".concat(option === null || option === void 0 ? void 0 : option.PartCode) : '-'));
    };
    // console.log("standardJobs", standardJobData)
    var openJobDetailsDrawer = function (item, jobItemType) {
        setIsOpenJobItemDetailsDrawer(true);
        setSelectedJobItemDetails(item);
        setModuleSection(jobItemType);
        setSelectedJobItemType(jobItemType);
    };
    var handleCloseStandardJobsDrawer = function (updatedList) {
        var tempStandardJobs = __spreadArray([], standardJobData, true);
        var labourJobs = updatedList.filter(function (item) { return item.jobType === 'Labour'; });
        var partJobs = updatedList.filter(function (item) { return item.jobType === 'Part'; });
        var StandardParts = {
            Labour: labourJobs,
            Part: partJobs
        };
        tempStandardJobs[drawerGroupIndex] = _objectSpread(_objectSpread({}, tempStandardJobs[drawerGroupIndex]), {}, {
            StandardParts: StandardParts
        });
        updateStandardJobData(tempStandardJobs);
        setIsOpenStandardJobDetailsDrawer(false);
        setDrawerGroupIndex(-1);
    };
    var openStandardJobDetailsDrawer = function (item, index) {
        var _item$StandardParts3, _item$StandardParts4, _item$StandardParts5, _item$StandardParts6;
        var tempJobItemDetails = _objectSpread(_objectSpread({}, item), {}, {
            PartsLaboursList: __spreadArray(__spreadArray([], (item === null || item === void 0 || (_item$StandardParts3 = item.StandardParts) === null || _item$StandardParts3 === void 0 || (_item$StandardParts3 = _item$StandardParts3.Labour) === null || _item$StandardParts3 === void 0 ? void 0 : _item$StandardParts3.map(function (labour) { return _objectSpread(_objectSpread({}, labour), {}, {
                jobType: 'Labour'
            }); })), true), (item === null || item === void 0 || (_item$StandardParts4 = item.StandardParts) === null || _item$StandardParts4 === void 0 || (_item$StandardParts4 = _item$StandardParts4.Part) === null || _item$StandardParts4 === void 0 ? void 0 : _item$StandardParts4.map(function (part) { return _objectSpread(_objectSpread({}, part), {}, {
                jobType: 'Part'
            }); })), true),
            LabourCount: item === null || item === void 0 || (_item$StandardParts5 = item.StandardParts) === null || _item$StandardParts5 === void 0 || (_item$StandardParts5 = _item$StandardParts5.Labour) === null || _item$StandardParts5 === void 0 ? void 0 : _item$StandardParts5.length,
            PartsCount: item === null || item === void 0 || (_item$StandardParts6 = item.StandardParts) === null || _item$StandardParts6 === void 0 || (_item$StandardParts6 = _item$StandardParts6.Part) === null || _item$StandardParts6 === void 0 ? void 0 : _item$StandardParts6.length
        });
        tempJobItemDetails === null || tempJobItemDetails === void 0 || delete tempJobItemDetails.StandardParts;
        setIsOpenStandardJobDetailsDrawer(true);
        setDrawerGroupIndex(index);
        setSelectedStandardJobItemDetails(tempJobItemDetails);
    };
    // const openStandardJobPartLabourDrawer = (item: IDeclinedJobs) => {
    //   if (item?.StandardParts) {
    //     const tempJobItemDetails: IStandardJobsGroup = {
    //       ...item,
    //       PartsLaboursList: [...item?.StandardParts?.Labour, ...item?.StandardParts?.Part],
    //       LabourCount: item?.StandardParts?.Labour?.length,
    //       PartsCount: item?.StandardParts?.Part?.length
    //     }
    //     delete tempJobItemDetails?.StandardParts
    //     setSelectedJobItemDetails(tempJobItemDetails)
    //     setIsOpenJobItemDetailsDrawer(true)
    //   }
    // }
    var showPmsPrice = function (item) {
        var _item$SelectedPriceDe11;
        if (((_item$SelectedPriceDe11 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe11 === void 0 ? void 0 : _item$SelectedPriceDe11.PriceGroupCategoryKey) === "MRP") {
            var _item$SelectedPriceDe12, _item$SelectedPriceDe13, _item$Price$5;
            return (_item$SelectedPriceDe12 = item.SelectedPriceDetails) !== null && _item$SelectedPriceDe12 !== void 0 && _item$SelectedPriceDe12.Amount ? (_item$SelectedPriceDe13 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe13 === void 0 ? void 0 : _item$SelectedPriceDe13.Amount : (item === null || item === void 0 || (_item$Price$5 = item.Price[0]) === null || _item$Price$5 === void 0 ? void 0 : _item$Price$5.Amount) || 0;
        }
        else {
            var _item$SelectedPriceDe14, _item$SelectedPriceDe15, _item$Price$6;
            return (_item$SelectedPriceDe14 = item.SelectedPriceDetails) !== null && _item$SelectedPriceDe14 !== void 0 && _item$SelectedPriceDe14.Amount ? (_item$SelectedPriceDe15 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe15 === void 0 ? void 0 : _item$SelectedPriceDe15.Amount : (item === null || item === void 0 || (_item$Price$6 = item.Price[0]) === null || _item$Price$6 === void 0 ? void 0 : _item$Price$6.Amount) || 0;
        }
    };
    var showAdditionalPrice = function (item) {
        if (item.AutofillType === 2) {
            return 0;
        }
        else {
            var _item$SelectedPriceDe16;
            if (((_item$SelectedPriceDe16 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe16 === void 0 ? void 0 : _item$SelectedPriceDe16.PriceGroupCategoryKey) === "MRP") {
                var _item$SelectedPriceDe17, _item$SelectedPriceDe18, _item$Price$7;
                return (_item$SelectedPriceDe17 = item.SelectedPriceDetails) !== null && _item$SelectedPriceDe17 !== void 0 && _item$SelectedPriceDe17.Amount ? (_item$SelectedPriceDe18 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe18 === void 0 ? void 0 : _item$SelectedPriceDe18.Amount : (item === null || item === void 0 || (_item$Price$7 = item.Price[0]) === null || _item$Price$7 === void 0 ? void 0 : _item$Price$7.Amount) || 0;
            }
            else {
                var _item$SelectedPriceDe19, _item$SelectedPriceDe20, _item$Price$8;
                return (_item$SelectedPriceDe19 = item.SelectedPriceDetails) !== null && _item$SelectedPriceDe19 !== void 0 && _item$SelectedPriceDe19.Amount ? (_item$SelectedPriceDe20 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe20 === void 0 ? void 0 : _item$SelectedPriceDe20.Amount : (item === null || item === void 0 || (_item$Price$8 = item.Price[0]) === null || _item$Price$8 === void 0 ? void 0 : _item$Price$8.Amount) || 0;
            }
        }
    };
    var AccordianActionsPms = function (option, index) {
        var _showPmsPrice, _option$Quantity;
        return /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: IS_DESKTOP ? 1 : 0,
            direction: IS_DESKTOP ? 'row-reverse' : 'row',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingX: 2,
            paddingRight: IS_DESKTOP ? 0 : 2,
            paddingY: 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: IS_DESKTOP ? 1 : 0,
            direction: IS_DESKTOP ? 'row-reverse' : 'row',
            alignItems: 'center'
        }, (declinedJobsConfiguration === null || declinedJobsConfiguration === void 0 ? void 0 : declinedJobsConfiguration.IsAbleToDeclined) && /*#__PURE__*/ React.createElement(MuiStack, null, option.isExpanded ? /*#__PURE__*/ React.createElement(MuiButton, {
            onClick: function () { return onClickCloseIconPmParts(index); },
            variant: "text",
            endIcon: /*#__PURE__*/ React.createElement(ReverseActionIcon, null),
            name: "Add again",
            size: "small",
            sx: {
                backgroundColor: 'transparent',
                opacity: isDisabled ? 0.5 : 1
            },
            id: "add-again",
            disabled: isDisabled
        }) : /*#__PURE__*/ React.createElement(MuiIconButton, {
            disabled: isDisabled,
            onClick: function () { return onClickCloseIconPmParts(index); },
            sx: {
                opacity: isDisabled ? 0.5 : 1,
                paddingLeft: IS_DESKTOP ? 1 : 0
            }
        }, /*#__PURE__*/ React.createElement(RoundClearIcon, {
            id: "delete-btn-icon-pms"
        }))), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3",
            color: '#1B1D21',
            sx: {
                whiteSpace: 'nowrap',
                width: '10ch',
                display: 'flex',
                justifyContent: {
                    xs: 'start',
                    md: 'end'
                }
            }
        }, "\u20B9 ".concat((_showPmsPrice = showPmsPrice(option)) === null || _showPmsPrice === void 0 ? void 0 : _showPmsPrice.toFixed(2))))), /*#__PURE__*/ React.createElement(MuiStack, null, option.isExpanded ? /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 1,
            alignItems: 'center',
            width: '100%'
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h4",
            color: '#8593A3'
        }, option.jobType === "Part" ? 'Qty:' : "Unit:"), /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3",
            color: '#1B1D21'
        }, (_option$Quantity = option === null || option === void 0 ? void 0 : option.Quantity) !== null && _option$Quantity !== void 0 ? _option$Quantity : '-')) : /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiStack, {
            height: '28px',
            width: '28px',
            justifyContent: 'center',
            sx: {
                border: "1px solid ".concat(systemColor.grey),
                borderRadius: 0,
                backgroundColor: '#F4F7FA',
                borderColor: 'secondary.200',
                borderTopLeftRadius: '4px',
                borderBottomLeftRadius: '4px'
            }
        }, /*#__PURE__*/ React.createElement(IconButton, {
            id: "PMS-job-item-".concat(option === null || option === void 0 ? void 0 : option.jobType, "-qty-minus-").concat(index),
            size: "small",
            disabled: true
        }, /*#__PURE__*/ React.createElement(GridRemoveIcon, {
            sx: {
                color: "secondary.200"
            }
        }))), /*#__PURE__*/ React.createElement(TextField, {
            value: option.Quantity,
            variant: "outlined",
            size: "small",
            inputProps: {
                style: {
                    textAlign: 'center'
                },
                inputMode: 'decimal',
                pattern: '[0-9]*[.,]?[0-9]*'
            }
            // sx={{
            //   backgroundColor: 'white',
            //   borderTop: '1px solid #E0E0E0',
            //   borderBottom: '1px solid #E0E0E0',
            //   '& fieldset': { border: 'none' },
            //   '& .MuiOutlinedInput-root': {
            //     borderRadius: 0,
            //   },
            //   '& .MuiInputBase-root': { height: '25px', width: '50px' }
            //   // padding:0
            // }}
            ,
            InputProps: {
                sx: {
                    background: '#e6f2ff'
                }
            },
            sx: {
                borderTop: "1px solid",
                borderBottom: "1px solid",
                borderColor: 'secondary.200',
                '& fieldset': {
                    border: 'none'
                },
                '& .MuiOutlinedInput-root': {
                    borderRadius: 0
                },
                '& .MuiInputBase-root': {
                    height: '25px',
                    width: '10ch'
                }
            }
            // onChange={(event) =>
            //   handleQuantityChange(
            //     event,
            //     index,
            //     item
            //   )
            // }
            ,
            error: option.error
            // disabled={isDisabled}
            ,
            disabled: true,
            type: "number"
        }), /*#__PURE__*/ React.createElement(MuiStack, {
            height: '28px',
            width: '28px',
            justifyContent: 'center',
            sx: {
                border: "1px solid ".concat(systemColor.grey),
                borderRadius: 0,
                backgroundColor: '#F4F7FA',
                borderColor: 'secondary.200',
                borderTopRightRadius: '4px',
                borderBottomRightRadius: '4px'
            }
        }, /*#__PURE__*/ React.createElement(IconButton
        // onClick={() => handleIncrement(index)}
        , {
            size: "small"
            // disabled={isDisabled}
            ,
            disabled: true
        }, /*#__PURE__*/ React.createElement(GridAddIcon, {
            sx: {
                color: "secondary.200"
            }
        }))))));
    };
    var AdditionalAccordianActions = function (option, index) {
        var _showAdditionalPrice, _option$Quantity2, _option$Quantity3;
        return /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: IS_DESKTOP ? 1 : 0,
            direction: IS_DESKTOP ? 'row-reverse' : 'row',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingX: 2,
            paddingRight: IS_DESKTOP ? 0 : 2,
            paddingY: 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: IS_DESKTOP ? 1 : 0,
            direction: IS_DESKTOP ? 'row-reverse' : 'row',
            alignItems: 'center'
        }, showCrossButtonConditionAdditionalJobs(option) && (declinedJobsConfiguration === null || declinedJobsConfiguration === void 0 ? void 0 : declinedJobsConfiguration.IsAbleToDeclined) && /*#__PURE__*/ React.createElement(MuiStack, null, option.isExpanded ? /*#__PURE__*/ React.createElement(MuiButton, {
            onClick: function () { return onClickCloseIconAdditonalJob(index); },
            variant: "text",
            endIcon: /*#__PURE__*/ React.createElement(ReverseActionIcon, null),
            name: "Add again",
            size: "small",
            sx: {
                backgroundColor: 'transparent',
                opacity: isDisabled ? 0.5 : 1
            },
            id: "add-again",
            disabled: isDisabled
        }) : /*#__PURE__*/ React.createElement(MuiIconButton, {
            id: "additional-job-item-".concat(option === null || option === void 0 ? void 0 : option.jobType, "-delete-icon-").concat(index),
            disabled: isDisabled,
            onClick: function () { return onClickCloseIconAdditonalJob(index); },
            sx: {
                opacity: isDisabled ? 0.5 : 1,
                paddingLeft: IS_DESKTOP ? 1 : 0
            }
        }, /*#__PURE__*/ React.createElement(RoundClearIcon, {
            id: "delete-btn-icon-additional"
        }))), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3",
            id: "additional-job-item-".concat(option === null || option === void 0 ? void 0 : option.jobType, "-price-").concat(index),
            color: '#1B1D21',
            sx: {
                whiteSpace: 'nowrap',
                width: '10ch',
                display: 'flex',
                justifyContent: {
                    xs: 'start',
                    md: 'end'
                }
            }
        }, "\u20B9 ".concat((_showAdditionalPrice = showAdditionalPrice(option)) === null || _showAdditionalPrice === void 0 ? void 0 : _showAdditionalPrice.toFixed(2))))), /*#__PURE__*/ React.createElement(MuiStack, null, option.isExpanded ? /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 1,
            alignItems: 'center',
            width: '100%'
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h4",
            color: '#8593A3'
        }, option.jobType === "Part" ? 'Qty:' : "Unit:"), /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3",
            color: '#1B1D21'
        }, (_option$Quantity2 = option === null || option === void 0 ? void 0 : option.Quantity) !== null && _option$Quantity2 !== void 0 ? _option$Quantity2 : '-')) : /*#__PURE__*/ React.createElement(React.Fragment, null, !option.IsAutoFill && option.jobType === "Part" ? /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiStack, {
            height: '28px',
            width: '28px',
            justifyContent: 'center',
            sx: {
                border: "1px solid ".concat(systemColor.grey),
                borderRadius: 0,
                backgroundColor: '#F4F7FA',
                borderColor: isDisabled ? 'secondary.200' : 'info.500',
                borderTopLeftRadius: '4px',
                borderBottomLeftRadius: '4px'
            }
        }, /*#__PURE__*/ React.createElement(IconButton, {
            id: "additional-job-item-".concat(option === null || option === void 0 ? void 0 : option.jobType, "-qty-minus-").concat(index),
            onClick: function () { return handleQuantityDecrement(index); },
            size: "small",
            disabled: isDisabled || option.IsAutoFill
        }, /*#__PURE__*/ React.createElement(GridRemoveIcon, {
            sx: {
                color: isDisabled ? "secondary.200" : 'primary.500'
            }
        }))), /*#__PURE__*/ React.createElement(TextField, {
            id: "additional-job-item-".concat(option === null || option === void 0 ? void 0 : option.jobType, "-qty-").concat(index),
            value: option.Quantity,
            variant: "outlined",
            size: "small",
            inputProps: {
                style: {
                    textAlign: 'center',
                    height: '25px',
                    padding: 0
                },
                inputMode: 'decimal',
                pattern: '[0-9]*[.,]?[0-9]*'
            },
            InputProps: {
                sx: {
                    background: '#e6f2ff'
                }
            },
            sx: {
                borderTop: "1px solid",
                borderBottom: "1px solid",
                borderColor: isDisabled ? 'secondary.200' : 'info.500',
                '& fieldset': {
                    border: 'none'
                },
                '& .MuiOutlinedInput-root': {
                    borderRadius: 0
                },
                '& .MuiInputBase-root': {
                    height: '25px',
                    width: '10ch'
                }
            },
            onChange: function (event) {
                var newValue = event.target.value;
                if (String(newValue) !== String(option.Quantity)) {
                    setHasUnsavedChanges(true);
                }
                handleQuantityChange(event, index);
            },
            onBlur: function () {
                handleOnBlurQuantityChange(index);
            },
            error: option.error,
            disabled: isDisabled || option.IsAutoFill,
            type: "number"
        }), /*#__PURE__*/ React.createElement(MuiStack, {
            height: '28px',
            width: '28px',
            justifyContent: 'center',
            sx: {
                border: "1px solid",
                borderRadius: 0,
                backgroundColor: '#F4F7FA',
                borderTopRightRadius: '4px',
                borderBottomRightRadius: '4px',
                borderColor: isDisabled ? 'secondary.200' : 'info.500'
            }
        }, /*#__PURE__*/ React.createElement(IconButton, {
            id: "additional-job-item-".concat(option === null || option === void 0 ? void 0 : option.jobType, "-qty-plus-").concat(index),
            onClick: function () { return handleQuantityIncrement(index); },
            size: "small",
            disabled: isDisabled || option.IsAutoFill
        }, /*#__PURE__*/ React.createElement(GridAddIcon, {
            sx: {
                color: isDisabled ? "secondary.200" : 'primary.500'
            }
        })))) : /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 1,
            justifyContent: 'center'
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h4",
            color: '#8593A3'
        }, option.jobType === "Part" ? 'Qty:' : "Unit:"), /*#__PURE__*/ React.createElement(Typography, {
            variant: "h4"
        }, (_option$Quantity3 = option === null || option === void 0 ? void 0 : option.Quantity) !== null && _option$Quantity3 !== void 0 ? _option$Quantity3 : 0)))));
    };
    var StandardJobCardAccordianActions = function (option, index) {
        var _option$StandardParts, _option$StandardParts2, _option$StandardParts3, _option$StandardParts4;
        return /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: IS_DESKTOP ? 1 : 0,
            direction: IS_DESKTOP ? 'row-reverse' : 'row',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingX: 2,
            paddingY: 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: IS_DESKTOP ? 1 : 0,
            direction: IS_DESKTOP ? 'row-reverse' : 'row',
            alignItems: 'center'
        }, /*#__PURE__*/ React.createElement(MuiStack, null, option.isExpanded ? /*#__PURE__*/ React.createElement(MuiButton, {
            onClick: function () { return onClickCloseIconStandardJobs(index); },
            variant: "text",
            endIcon: /*#__PURE__*/ React.createElement(ReverseActionIcon, null),
            name: "Add again",
            size: "small",
            sx: {
                backgroundColor: 'transparent',
                opacity: isDisabled ? 0.5 : 1
            },
            id: "add-again",
            disabled: isDisabled
        }) : /*#__PURE__*/ React.createElement(MuiStack, {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            alignItems: 'center'
        }, /*#__PURE__*/ React.createElement(MuiIconButton, {
            onClick: function () { return onClickCloseIconStandardJobs(index); },
            disabled: isDisabled,
            sx: {
                opacity: isDisabled ? 0.5 : 1
            }
        }, /*#__PURE__*/ React.createElement(RoundClearIcon, {
            id: "delete-btn-icon-standard-jobs"
        })), IS_DESKTOP ? null : /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 1
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontWeight: '400',
            color: "secondary.500"
        }, "Part-"), /*#__PURE__*/ React.createElement(Typography, null, (_option$StandardParts = option.StandardParts) !== null && _option$StandardParts !== void 0 && _option$StandardParts.Part ? option.StandardParts.Part.length.toString().padStart(2, '0') : '00')), /*#__PURE__*/ React.createElement(Divider, {
            orientation: "vertical",
            flexItem: true
        }), /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 1
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontWeight: '400',
            color: "secondary.500"
        }, "Labour-"), /*#__PURE__*/ React.createElement(Typography, null, (_option$StandardParts2 = option.StandardParts) !== null && _option$StandardParts2 !== void 0 && _option$StandardParts2.Labour ? option.StandardParts.Labour.length.toString().padStart(2, '0') : '00'))))))), /*#__PURE__*/ React.createElement(MuiStack, null, IS_DESKTOP ? null : /*#__PURE__*/ React.createElement(MuiStack, {
            width: "100%"
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3",
            fontWeight: 500,
            sx: {
                mr: 1,
                width: '80px'
            }
        }, "\u20B9", ' ', option !== null && option !== void 0 && option.StandardParts ? (((_option$StandardParts3 = option.StandardParts.Part) === null || _option$StandardParts3 === void 0 ? void 0 : _option$StandardParts3.reduce(function (sum, part) {
            var _part$SelectedPriceDe, _part$SelectedPriceDe2;
            return sum + ((_part$SelectedPriceDe = part === null || part === void 0 || (_part$SelectedPriceDe2 = part.SelectedPriceDetails) === null || _part$SelectedPriceDe2 === void 0 ? void 0 : _part$SelectedPriceDe2.Amount) !== null && _part$SelectedPriceDe !== void 0 ? _part$SelectedPriceDe : 0);
        }, 0)) + ((_option$StandardParts4 = option.StandardParts.Labour) === null || _option$StandardParts4 === void 0 ? void 0 : _option$StandardParts4.reduce(function (sum, labour) {
            var _labour$SelectedPrice, _labour$SelectedPrice2;
            return sum + ((_labour$SelectedPrice = labour === null || labour === void 0 || (_labour$SelectedPrice2 = labour.SelectedPriceDetails) === null || _labour$SelectedPrice2 === void 0 ? void 0 : _labour$SelectedPrice2.Amount) !== null && _labour$SelectedPrice !== void 0 ? _labour$SelectedPrice : 0);
        }, 0))).toLocaleString('en-IN', {
            minimumFractionDigits: 2
        }) : '0.00'))));
    };
    var RoadTestCustomerComplaintAccordianActions = function (option, index) {
        return /*#__PURE__*/ React.createElement(MuiStack, {
            bgcolor: 'aqua',
            spacing: IS_DESKTOP ? 1 : 0,
            direction: IS_DESKTOP ? 'row-reverse' : 'row',
            width: IS_DESKTOP ? 'auto' : '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingX: 1,
            paddingY: 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: IS_DESKTOP ? 1 : 0,
            direction: IS_DESKTOP ? 'row-reverse' : 'row',
            alignItems: 'center'
        }, /*#__PURE__*/ React.createElement(MuiStack, null, option.isExpanded ? /*#__PURE__*/ React.createElement(MuiButton, {
            onClick: function () { return onClickCloseIconRoadTestAndCustomerComplaints(index); },
            variant: "text",
            endIcon: /*#__PURE__*/ React.createElement(ReverseActionIcon, null),
            name: "Add again",
            size: "small",
            sx: {
                backgroundColor: 'transparent',
                opacity: isDisabled ? 0.5 : 1
            },
            id: "add-again",
            disabled: isDisabled
        }) : /*#__PURE__*/ React.createElement(MuiStack, {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            alignItems: 'center'
        }, /*#__PURE__*/ React.createElement(MuiIconButton, {
            id: "job-item-delete-".concat(index),
            disabled: isDisabled,
            onClick: function () { return onClickCloseIconRoadTestAndCustomerComplaints(index); },
            sx: {
                opacity: isDisabled ? 0.5 : 1
            }
        }, /*#__PURE__*/ React.createElement(RoundClearIcon, {
            id: "delete-btn-icon-customer-complaint"
        })))))));
    };
    var getPmsCount = function () {
        var approvedPartItems = periodicPartData.filter(function (item) { return !item.isExpanded && item.jobType == 'Part'; });
        var approvedLaboursItems = periodicPartData.filter(function (item) { return !item.isExpanded && item.jobType == 'Labour'; });
        return {
            parts: approvedPartItems.length,
            labours: approvedLaboursItems.length
        };
    };
    var getAdditionalCount = function () {
        var approvedPartItems = additionalJobData.filter(function (item) { return !item.isExpanded && item.jobType == 'Part'; });
        var approvedLaboursItems = additionalJobData.filter(function (item) { return !item.isExpanded && item.jobType == 'Labour'; });
        return {
            parts: approvedPartItems.length,
            labours: approvedLaboursItems.length
        };
    };
    var handleClose = function (updatedItem) {
        var updatedList = [];
        if (selectedJobItemType === "PM_PARTS") {
            updatedList = __spreadArray([], periodicPartData, true);
        }
        else if (selectedJobItemType === "STANDARD_JOBS") {
            updatedList = __spreadArray([], standardJobData, true);
        }
        else if (selectedJobItemType === "ADDITIONAL_JOBS") {
            updatedList = __spreadArray([], additionalJobData, true);
        }
        updatedList = updatedList.map(function (item) { return item.ChildId === updatedItem.ChildId ? updatedItem : item; });
        if (selectedJobItemType === "PM_PARTS") {
            updatePeriodicPartData(updatedList);
            setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                PeriodicPart: true
            }));
        }
        else if (selectedJobItemType === "STANDARD_JOBS") {
            updateStandardJobData(updatedList);
            setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                StandardJob: true
            }));
        }
        else if (selectedJobItemType === "ADDITIONAL_JOBS") {
            setDisabledSave(_objectSpread(_objectSpread({}, disabledSave), {}, {
                AdditionalJob: true
            }));
            updateAdditionalJobs(updatedList);
        }
        setIsOpenJobItemDetailsDrawer(false);
    };
    var getStandardJobGroupTotal = function (option) {
        var _option$StandardParts5, _option$StandardParts6;
        var partsTotalPrice = (_option$StandardParts5 = option.StandardParts) === null || _option$StandardParts5 === void 0 || (_option$StandardParts5 = _option$StandardParts5.Part) === null || _option$StandardParts5 === void 0 ? void 0 : _option$StandardParts5.reduce(function (sum, part) {
            var _part$SelectedPriceDe3, _part$SelectedPriceDe4;
            return sum + ((_part$SelectedPriceDe3 = part === null || part === void 0 || (_part$SelectedPriceDe4 = part.SelectedPriceDetails) === null || _part$SelectedPriceDe4 === void 0 ? void 0 : _part$SelectedPriceDe4.Amount) !== null && _part$SelectedPriceDe3 !== void 0 ? _part$SelectedPriceDe3 : 0);
        }, 0);
        var laboursTotalPrice = (_option$StandardParts6 = option.StandardParts) === null || _option$StandardParts6 === void 0 || (_option$StandardParts6 = _option$StandardParts6.Labour) === null || _option$StandardParts6 === void 0 ? void 0 : _option$StandardParts6.reduce(function (sum, labour) {
            var _labour$SelectedPrice3, _labour$SelectedPrice4;
            return sum + ((_labour$SelectedPrice3 = labour === null || labour === void 0 || (_labour$SelectedPrice4 = labour.SelectedPriceDetails) === null || _labour$SelectedPrice4 === void 0 ? void 0 : _labour$SelectedPrice4.Amount) !== null && _labour$SelectedPrice3 !== void 0 ? _labour$SelectedPrice3 : 0);
        }, 0);
        return Number(((partsTotalPrice || 0) + (laboursTotalPrice || 0)).toFixed(2));
    };
    return /*#__PURE__*/ React.createElement(Grid, {
        xs: 12,
        spacing: 0
    }, (updatedModuleSectionByChannel === null || updatedModuleSectionByChannel === void 0 ? void 0 : updatedModuleSectionByChannel.length) > 0 ? updatedModuleSectionByChannel === null || updatedModuleSectionByChannel === void 0 ? void 0 : updatedModuleSectionByChannel.map(function (item, index) {
        var _item$SectionAttribut12, _item$SectionAttribut13, _item$SectionAttribut14, _item$SectionAttribut15, _item$SectionAttribut16, _item$SectionAttribut17;
        return (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.PeriodicMaintenance && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut12 = item.SectionAttributes[0]) !== null && _item$SectionAttribut12 !== void 0 && _item$SectionAttribut12.HIDE) ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12
        }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Accordion, {
            style: {
                width: "100%",
                borderBottom: "1px solid #DEE4EB",
                boxShadow: "none",
                borderRadius: 0
            }
        }, /*#__PURE__*/ React.createElement(AccordionSummary, {
            expandIcon: /*#__PURE__*/ React.createElement(ExpandMoreIcon, {
                sx: {
                    height: '25px',
                    width: '25px'
                }
            }),
            "aria-controls": "panel1a-content",
            id: "".concat(item === null || item === void 0 ? void 0 : item.Key),
            sx: {
                paddingX: '7px'
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: "space-between",
            width: "100%",
            px: 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: IS_DESKTOP ? '20px' : 0,
            direction: IS_DESKTOP ? 'row' : 'column'
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontWeight: '500',
            color: "secondary.600"
        }, item === null || item === void 0 ? void 0 : item.DisplayName), /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 1
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontWeight: '400',
            color: "secondary.500"
        }, "Part-"), /*#__PURE__*/ React.createElement(Typography, {
            id: "pm-part-part-count"
        }, getPmsCount().parts)), /*#__PURE__*/ React.createElement(Divider, {
            orientation: "vertical",
            flexItem: true
        }), /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 1
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontWeight: '400',
            color: "secondary.500"
        }, "Labour-"), /*#__PURE__*/ React.createElement(Typography, {
            id: "pm-part-labour-count"
        }, getPmsCount().labours)))), /*#__PURE__*/ React.createElement(MuiStack, null, periodicSkeleton ? /*#__PURE__*/ React.createElement("span", {
            style: {
                width: '50px',
                height: '20px'
            }
        }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)) : /*#__PURE__*/ React.createElement(Typography, {
            id: "pm-part-amt",
            variant: "h3",
            sx: {
                whiteSpace: 'nowrap'
            }
        }, "\u20B9 ", getPmPartsSubTotal())))), /*#__PURE__*/ React.createElement(AccordionDetails, {
            sx: {
                paddingX: '0px'
            }
        }, /*#__PURE__*/ React.createElement(Divider, null), /*#__PURE__*/ React.createElement(MuiStack, {
            direction: "column",
            paddingX: '12px',
            paddingY: '16px',
            bgcolor: systemColor.backgroundColor
        }, periodicPartData.length > 0 ? /*#__PURE__*/ React.createElement(Grid, {
            spacing: 2,
            container: true
        }, periodicPartData.map(function (option, index) {
            var _option$jobType, _option$RejectReasonR, _option$DeclinedRemar;
            return (
            /*#__PURE__*/
            // <Grid
            //   paddingX={1}
            //   container
            //   item
            //   key={option.label}
            //   alignItems="center"
            //   rowSpacing={1}
            //   sx={{ paddingTop: option.isExpanded ? 1 : 0, backgroundColor: option.isExpanded ? "#EFF2F5" : 'transparent', borderRadius: '8px' }}
            // >
            //   <MuiStack width={'100%'} justifyContent={'space-between'} height={'100%'} flexDirection={'row'} spacing={7} sx={{ padding: "3px 8px" }}>
            //     <MuiStack width={'90%'} alignItems={'center'} >
            //       <Typography variant="h3">
            //         {" "}
            //         {option?.jobType === "Labour"
            //           ? option?.LabourName
            //           : option?.PartName}
            //       </Typography>
            //     </MuiStack>
            //     <MuiStack spacing={1} alignItems='center'>
            //       <MuiStack sx={{ backgroundColor: "#EEF6FF", padding: "3px 8px", borderRadius: "50%", height: '24px', width: '24px', border: '1px solid #AFD5FF', justifyContent: 'center' }}>
            //         <Typography sx={{ color: systemColor.primary }} variant='h5'>
            //           {option.jobType?.substring(0, 1)}
            //         </Typography>
            //       </MuiStack>
            //       {declinedJobsConfiguration?.IsAbleToDeclined ? <IconButton disabled={disableRejectItem} onClick={() => onClickCloseIconPmParts(index)}>
            //         <img alt='cross'
            //           src={option.isExpanded ? CrossCircleRed : CloseCircleBlackNew}
            //           style={{ opacity: disableRejectItem ? 0.5 : 1 }}
            //         />
            //       </IconButton> : <></>}
            //     </MuiStack>
            //   </MuiStack>
            //   <Typography variant='h4' color={'#8593A3'} paddingX={1}>{`#${option?.PartCode ? option?.PartCode : option?.LabourCode}`}</Typography>
            //   <MuiStack width={'100%'} justifyContent={'space-between'} marginTop='10px' paddingX={1}>
            //     <MuiStack alignItems={'center'} width={'100%'}>
            //       <Typography variant='h4' color={'#8593A3'}>{t('Qty. ')}</Typography>
            //       <Typography variant='h3' color={'#1B1D21'}>{option?.Quantity ?? '-'}</Typography>
            //     </MuiStack>
            //     <MuiStack width={'89%'} justifyContent={'end'} sx={{ marginRight: '5px' }}>
            //       <Typography variant='h4' color={'#8593A3'}>{t('Amt. ')}</Typography>
            //       <Typography variant='h3' color={'#1B1D21'}>{`₹ ${(option?.Price)?.toFixed(2) ?? '-'}`}</Typography>
            //     </MuiStack>
            //   </MuiStack>
            //   {
            //     option.isExpanded &&
            //     <Grid item xs={12} paddingY={1}>
            //       <Grid container gap={1} p={'12px 0px'}>
            //         <Grid item xs={12} sm={5.8}>
            //           <MuiSelectComponent
            //             id='reject-reason-dropdown'
            //             margin={0}
            //             fullWidth
            //             options={rejectReasonRemarkList || []}
            //             caption={"cancellation reason"}
            //             displayExpr="DisplayName"
            //             valueExpr="id"
            //             name="rejectReason"
            //             value={option.RejectReasonRemark ?? ""}
            //             onChange={(event: any) => handleSelectPmPartsRejectReason(event, index)}
            //             disabled={isDisabled}
            //             isMandatory={declinedJobsConfiguration?.IsRemarksMandatory}
            //           />
            //         </Grid>
            //         <Grid item xs={12} sm={6} bgcolor={'white'} borderRadius={'8px'}>
            //           <InputBox
            //             multiline={isXs ? true : false}
            //             rows={isXs ? 2 : 1}
            //             id="remark-input"
            //             placeholder={`${t("ENTER_REMARKS_PLACEHOLDER")} ${declinedJobsConfiguration?.IsRemarksMandatory ? "*" : ""}`}
            //             onChange={(event: any) => handleChangePmPartsRejectRemark(event, index)}
            //             fullWidth
            //             size="small"
            //             value={option.DeclinedRemarks ?? ""}
            //             disabled={isDisabled}
            //           />
            //         </Grid>
            //       </Grid>
            //     </Grid>
            //   }
            //   {periodicPartData.length - 1 !== index ?
            //     <Grid item xs={12}>
            //       <Divider sx={{ ml: -1, mr: -1 }} />
            //     </Grid> : ""}
            // </Grid>
            React.createElement(Grid, {
                alignItems: "center",
                key: option.label
                // paddingX={1}
                ,
                item: true,
                xs: 12,
                sm: 6,
                md: 12
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                direction: 'column',
                key: index,
                sx: {
                    "& .Mui-expanded": {
                        transform: "none",
                        backgroundColor: 'error.50',
                        borderRadius: '8px'
                    },
                    "& .MuiAccordionSummary-expandIconWrapper": {
                        height: '20px',
                        marginBottom: '50px'
                    }
                },
                border: option.isExpanded ? "1px solid ".concat(Colors.error[500]) : 'none',
                bgcolor: option.isExpanded ? Colors.error[50] : 'white',
                borderRadius: '8px',
                boxShadow: '0px 0px 16px -4px rgba(16, 24, 40, 0.08)'
            }, /*#__PURE__*/ React.createElement(Grid, {
                container: true
            }, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                md: 12
            }, /*#__PURE__*/ React.createElement(Accordion
            // variant='outlined'
            , {
                expanded: option.isExpanded,
                id: "pmParts-accordian-".concat(index),
                style: {
                    width: '100%',
                    boxShadow: 'none',
                    borderRadius: '8px'
                }
            }, /*#__PURE__*/ React.createElement(AccordionSummary, {
                expandIcon: /*#__PURE__*/ React.createElement(MuiStack, {
                    paddingTop: 3,
                    alignItems: 'center',
                    width: '100%'
                }, /*#__PURE__*/ React.createElement(MuiStack, {
                    width: '22px',
                    height: '22px',
                    sx: {
                        backgroundColor: "#EEF6FF",
                        padding: '5px',
                        borderRadius: "50%",
                        border: '1px solid #AFD5FF',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }
                }, /*#__PURE__*/ React.createElement(Typography, {
                    sx: {
                        color: systemColor.primary
                    },
                    variant: "h5"
                }, (_option$jobType = option.jobType) === null || _option$jobType === void 0 ? void 0 : _option$jobType.substring(0, 1))), IS_DESKTOP && AccordianActionsPms(option, index), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiIconButton, {
                    onClick: function () { return openJobDetailsDrawer(option, EJobItemType.PeriodicMaintenance); },
                    sx: {
                        paddingRight: 0
                    }
                }, /*#__PURE__*/ React.createElement(ChevronRightIcon, {
                    sx: {
                        color: systemColor.primary,
                        height: '20px',
                        width: '20px'
                    }
                })))),
                "aria-controls": "panel".concat(index, "a-content"),
                id: "panel".concat(index, "a-header")
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                direction: 'column',
                justifyContent: 'space-between',
                width: "100%",
                paddingRight: 1
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                alignItems: 'center',
                width: '100%'
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                width: '100%',
                spacing: 1.25,
                alignItems: 'center',
                justifyContent: 'space-between'
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                direction: 'column'
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                justifyContent: 'flex-start',
                alignItems: "flex-start"
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h5",
                sx: {
                    textTransform: 'capitalize'
                }
            }, " ", (option === null || option === void 0 ? void 0 : option.jobType) === "Labour" ? option === null || option === void 0 ? void 0 : option.LabourName : option === null || option === void 0 ? void 0 : option.PartName))))), /*#__PURE__*/ React.createElement(Typography, {
                variant: "h4",
                color: '#8593A3'
            }, option !== null && option !== void 0 && option.PartCode ? "#".concat(option === null || option === void 0 ? void 0 : option.PartCode) : "#".concat(option === null || option === void 0 ? void 0 : option.LabourCode)))), /*#__PURE__*/ React.createElement(AccordionDetails, null, /*#__PURE__*/ React.createElement(MuiStack, {
                width: '100%',
                spacing: 2,
                direction: IS_DESKTOP ? 'row' : 'column'
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                width: '100%',
                borderRadius: '8px'
            }, /*#__PURE__*/ React.createElement(MuiSelectComponent, {
                id: "reject-reason-dropdown",
                margin: 0,
                fullWidth: true,
                options: rejectReasonRemarkList || [],
                caption: "reason for rejection",
                displayExpr: "DisplayName",
                valueExpr: "id",
                name: "rejectReason",
                value: (_option$RejectReasonR = option.RejectReasonRemark) !== null && _option$RejectReasonR !== void 0 ? _option$RejectReasonR : "",
                onChange: function (event) { return handleSelectPmPartsRejectReason(event, index); },
                disabled: isDisabled,
                isMandatory: declinedJobsConfiguration === null || declinedJobsConfiguration === void 0 ? void 0 : declinedJobsConfiguration.IsReasonsMandatory
            })), /*#__PURE__*/ React.createElement(MuiStack, {
                width: '100%',
                borderRadius: '8px'
            }, /*#__PURE__*/ React.createElement(InputBox
            // sx={{ height: '44px' }}
            , {
                id: "remark-input",
                placeholder: "".concat(t("ENTER_REMARKS_PLACEHOLDER"), " ").concat(declinedJobsConfiguration !== null && declinedJobsConfiguration !== void 0 && declinedJobsConfiguration.IsRemarksMandatory ? "*" : ""),
                onChange: function (event) { return handleChangePmPartsRejectRemark(event, index); },
                fullWidth: true,
                size: "small",
                value: (_option$DeclinedRemar = option.DeclinedRemarks) !== null && _option$DeclinedRemar !== void 0 ? _option$DeclinedRemar : "",
                disabled: isDisabled
            })))))), !IS_DESKTOP && /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                paddingX: 2
            }, /*#__PURE__*/ React.createElement(Divider, {
                style: {
                    width: '100%'
                }
            }))), !IS_DESKTOP && AccordianActionsPms(option, index)))));
        }), /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            justifyContent: 'space-between'
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12
        }, /*#__PURE__*/ React.createElement(Divider, null)), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 6,
            paddingTop: 2,
            paddingX: 2
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3"
        }, t("Sub total"))), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 2
        }), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 4,
            paddingTop: 2,
            paddingX: 2,
            display: 'flex',
            justifyContent: 'flex-end'
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "PM-Sub-Total",
            variant: "h3",
            sx: {
                whiteSpace: 'nowrap'
            }
        }, "\u20B9 ", getPmPartsSubTotal()))), !isDisabled && /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            item: true,
            justifyContent: "flex-end",
            alignItems: "center"
        }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
            loading: loader.isLoaderOpen,
            variant: "outlined",
            size: "small",
            color: "primary",
            style: {
                width: "60px"
            },
            name: periodicPartText,
            onClick: savePeriodicMaintaince,
            id: "savePeriodicMaintainceEstimate",
            disabled: checkReasonRemarkValidate(periodicPartData) || !disabledSave.PeriodicPart
        }))) : /*#__PURE__*/ React.createElement(React.Fragment, null, !periodicSkeleton && /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: "center",
            alignItems: "center"
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3"
        }, " ", t("No data found"))))), periodicSkeleton && /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column',
            style: {
                height: '50px'
            }
        }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)))))) : (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.CustomerVoice && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut13 = item.SectionAttributes[0]) !== null && _item$SectionAttribut13 !== void 0 && _item$SectionAttribut13.HIDE) && Module === isModuleConfig.Product ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12
        }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Accordion, {
            style: {
                width: "100%",
                borderBottom: "1px solid #DEE4EB",
                boxShadow: "none",
                borderRadius: 0
            }
        }, /*#__PURE__*/ React.createElement(AccordionSummary, {
            expandIcon: /*#__PURE__*/ React.createElement(ExpandMoreIcon, {
                sx: {
                    height: '25px',
                    width: '25px'
                }
            }),
            "aria-controls": "panel1a-content",
            id: "".concat(item === null || item === void 0 ? void 0 : item.Key),
            sx: {
                paddingX: '7px'
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: "space-between",
            width: "100%",
            px: 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: IS_DESKTOP ? '20px' : 0,
            direction: IS_DESKTOP ? 'row' : 'column'
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontWeight: '500',
            color: "secondary.600"
        }, item === null || item === void 0 ? void 0 : item.DisplayName), /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 1
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontWeight: '400',
            color: "secondary.500"
        }, "Jobs-"), /*#__PURE__*/ React.createElement(Typography, {
            id: "standard-job-price"
        }, customerComplaintData !== null && customerComplaintData !== void 0 && customerComplaintData.length ? customerComplaintData === null || customerComplaintData === void 0 ? void 0 : customerComplaintData.length : 0))), /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3",
            sx: {
                whiteSpace: 'nowrap'
            }
        }, "\u20B9 ", getCustomerVoiceSubTotal()))), /*#__PURE__*/ React.createElement(AccordionDetails, {
            sx: {
                paddingX: '7px'
            }
        }, /*#__PURE__*/ React.createElement(Divider, {
            sx: {
                mb: 1
            }
        }), /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {},
            padding: 0.8
        }, (customerComplaintData === null || customerComplaintData === void 0 ? void 0 : customerComplaintData.length) > 0 ? /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column',
            width: '100%'
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            justifyContent: "space-between",
            alignItems: "center",
            padding: 1
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 3,
            sm: 6,
            md: 7
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "subtitle1"
        })), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 4,
            sm: 2.5,
            md: 2
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h4",
            align: "center",
            color: gray
        }, t("Parts (₹)"))), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 3.5,
            sm: 2.5,
            md: 2
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h4",
            align: "center",
            color: gray
        }, t("Labours (₹)"))), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 0.2,
            sm: 1,
            md: 1
        })), customerComplaintData.map(function (option, index) {
            var _option$ComplaintAsso, _option$ComplaintAsso2, _option$PartPrice, _option$ComplaintAsso3, _option$ComplaintAsso4, _option$LabourPrice, _option$ComplaintAsso5, _option$ComplaintAsso6, _option$ComplaintAsso7, _option$ComplaintAsso8, _option$RejectReasonR2, _option$DeclinedRemar2;
            return /*#__PURE__*/ React.createElement(Grid, {
                container: true,
                item: true,
                key: option === null || option === void 0 ? void 0 : option.ComplaintName,
                alignItems: "center",
                spacing: 0.4,
                sx: {
                    marginTop: 2,
                    paddingTop: 2,
                    backgroundColor: white
                },
                p: '12px'
            }, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 4,
                sm: 6,
                md: 7,
                sx: {
                    display: 'flex',
                    placeItems: 'center'
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h3",
                id: "customer-complaint"
            }, option === null || option === void 0 ? void 0 : option.ComplaintName), /*#__PURE__*/ React.createElement(MuiIconButton, {
                onClick: function () { return handleCustomerComplaintToggle(option === null || option === void 0 ? void 0 : option.ComplaintId); }
            }, option !== null && option !== void 0 && option.isOpenCustomerComplaint ? /*#__PURE__*/ React.createElement(ChevronUpIcon, null) : /*#__PURE__*/ React.createElement(ChevronDownIcon, null))), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 4,
                sm: 2.5,
                md: 2
            }, /*#__PURE__*/ React.createElement(InputBox, {
                disabled: (option === null || option === void 0 || (_option$ComplaintAsso = option.ComplaintAssociations) === null || _option$ComplaintAsso === void 0 || (_option$ComplaintAsso = _option$ComplaintAsso.Part) === null || _option$ComplaintAsso === void 0 ? void 0 : _option$ComplaintAsso.length) > 0 || (option === null || option === void 0 || (_option$ComplaintAsso2 = option.ComplaintAssociations) === null || _option$ComplaintAsso2 === void 0 || (_option$ComplaintAsso2 = _option$ComplaintAsso2.Labour) === null || _option$ComplaintAsso2 === void 0 ? void 0 : _option$ComplaintAsso2.length) > 0 || !(option !== null && option !== void 0 && option.IsEditable) || isDisabled,
                name: option === null || option === void 0 ? void 0 : option.ComplaintName,
                value: (_option$PartPrice = option === null || option === void 0 ? void 0 : option.PartPrice) !== null && _option$PartPrice !== void 0 ? _option$PartPrice : '',
                onChange: function (event) { return handleInputPartPriceChange(event, index, option, "PartPrice"); }
                // onBlur={calculateAmount}
                ,
                size: "small",
                inputProps: {
                    inputMode: 'decimal',
                    pattern: '[0-9]*[.,]?[0-9]*'
                },
                sx: {
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #DEE4EB",
                    borderRadius: "8px",
                    ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input": {
                        padding: "8.5px 5px"
                    },
                    ".css-km5qz1-MuiInputBase-root-MuiOutlinedInput-root": {
                        fontSize: '14px'
                    }
                }
                // id={option.id}
                // InputProps={{
                //   startAdornment: (
                //     <>
                //       <Typography sx={{ marginRight: "1px" }}>
                //         ₹
                //       </Typography>
                //     </>
                //   ),
                // }}
            })), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 3.5,
                sm: 2.5,
                md: 2
            }, /*#__PURE__*/ React.createElement(InputBox, {
                disabled: (option === null || option === void 0 || (_option$ComplaintAsso3 = option.ComplaintAssociations) === null || _option$ComplaintAsso3 === void 0 || (_option$ComplaintAsso3 = _option$ComplaintAsso3.Part) === null || _option$ComplaintAsso3 === void 0 ? void 0 : _option$ComplaintAsso3.length) > 0 || (option === null || option === void 0 || (_option$ComplaintAsso4 = option.ComplaintAssociations) === null || _option$ComplaintAsso4 === void 0 || (_option$ComplaintAsso4 = _option$ComplaintAsso4.Labour) === null || _option$ComplaintAsso4 === void 0 ? void 0 : _option$ComplaintAsso4.length) > 0 || !(option !== null && option !== void 0 && option.IsEditable) || isDisabled,
                name: option === null || option === void 0 ? void 0 : option.CustomerComplaint,
                value: (_option$LabourPrice = option === null || option === void 0 ? void 0 : option.LabourPrice) !== null && _option$LabourPrice !== void 0 ? _option$LabourPrice : '',
                onChange: function (event) { return handleInputPartPriceChange(event, index, option, "LabourPrice"); }
                // onBlur={calculateAmount}
                ,
                size: "small",
                inputProps: {
                    inputMode: 'decimal',
                    pattern: '[0-9]*[.,]?[0-9]*'
                },
                sx: {
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #DEE4EB",
                    borderRadius: "8px",
                    ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input": {
                        padding: "8.5px 5px"
                    },
                    ".css-km5qz1-MuiInputBase-root-MuiOutlinedInput-root": {
                        fontSize: '14px'
                    }
                }
                // id={option.id}
                // InputProps={{
                //   startAdornment: (
                //     <>
                //       <Typography sx={{ marginRight: "1px" }}>
                //         ₹
                //       </Typography>
                //     </>
                //   ),
                // }}
            })), /*#__PURE__*/ React.createElement(Grid, {
                marginLeft: -1,
                item: true,
                xs: 0.2,
                sm: 1,
                md: 1,
                justifyContent: 'center'
            }, declinedJobsConfiguration !== null && declinedJobsConfiguration !== void 0 && declinedJobsConfiguration.IsAbleToDeclined ? /*#__PURE__*/ React.createElement(IconButton, {
                disabled: disableRejectItem,
                onClick: function () { return onClickCloseIconCustomerComplaints(index); }
            }, /*#__PURE__*/ React.createElement("img", {
                alt: "cross",
                src: option.isExpanded ? CrossCircleRed : CloseCircleBlackNew,
                style: {
                    opacity: disableRejectItem ? 0.5 : 1
                }
            })) : /*#__PURE__*/ React.createElement(React.Fragment, null)), (option === null || option === void 0 ? void 0 : option.isOpenCustomerComplaint) && /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sm: 12,
                md: 12,
                sx: {
                    margin: '10px 0px'
                }
            }, /*#__PURE__*/ React.createElement(Divider, null)), (option === null || option === void 0 ? void 0 : option.isOpenCustomerComplaint) && (option === null || option === void 0 || (_option$ComplaintAsso5 = option.ComplaintAssociations) === null || _option$ComplaintAsso5 === void 0 || (_option$ComplaintAsso5 = _option$ComplaintAsso5.Labour) === null || _option$ComplaintAsso5 === void 0 ? void 0 : _option$ComplaintAsso5.length) > 0 && (option === null || option === void 0 || (_option$ComplaintAsso6 = option.ComplaintAssociations) === null || _option$ComplaintAsso6 === void 0 || (_option$ComplaintAsso6 = _option$ComplaintAsso6.Labour) === null || _option$ComplaintAsso6 === void 0 ? void 0 : _option$ComplaintAsso6.map(function (it) { return handlePartLabourAccordion({
                type: 'Labour',
                Name: it === null || it === void 0 ? void 0 : it.LabourName,
                Code: it === null || it === void 0 ? void 0 : it.LabourCode,
                Price: it === null || it === void 0 ? void 0 : it.Price,
                Quantity: it === null || it === void 0 ? void 0 : it.Quantity,
                ServiceType: it === null || it === void 0 ? void 0 : it.ServiceType,
                Item: it,
                Element: option,
                parentType: EModuleSection.CustomerVoice
            }); })), (option === null || option === void 0 ? void 0 : option.isOpenCustomerComplaint) && (option === null || option === void 0 || (_option$ComplaintAsso7 = option.ComplaintAssociations) === null || _option$ComplaintAsso7 === void 0 || (_option$ComplaintAsso7 = _option$ComplaintAsso7.Part) === null || _option$ComplaintAsso7 === void 0 ? void 0 : _option$ComplaintAsso7.length) > 0 && (option === null || option === void 0 || (_option$ComplaintAsso8 = option.ComplaintAssociations) === null || _option$ComplaintAsso8 === void 0 || (_option$ComplaintAsso8 = _option$ComplaintAsso8.Part) === null || _option$ComplaintAsso8 === void 0 ? void 0 : _option$ComplaintAsso8.map(function (it) { return handlePartLabourAccordion({
                type: 'Part',
                Name: it === null || it === void 0 ? void 0 : it.PartName,
                Code: it === null || it === void 0 ? void 0 : it.PartCode,
                Price: it === null || it === void 0 ? void 0 : it.Price,
                Quantity: it === null || it === void 0 ? void 0 : it.Quantity,
                ServiceType: it === null || it === void 0 ? void 0 : it.ServiceType,
                Item: it,
                Element: option,
                parentType: EModuleSection.CustomerVoice
            }); })), option.isExpanded && /*#__PURE__*/ React.createElement(Grid, {
                container: true,
                gap: 1,
                p: '12px 0px'
            }, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sm: 5.8
            }, /*#__PURE__*/ React.createElement(MuiSelectComponent, {
                id: "reject-reason-dropdown",
                margin: 0,
                fullWidth: true,
                options: rejectReasonRemarkList || [],
                caption: "cancellation reason",
                displayExpr: "DisplayName",
                valueExpr: "id",
                name: "rejectReason",
                value: (_option$RejectReasonR2 = option.RejectReasonRemark) !== null && _option$RejectReasonR2 !== void 0 ? _option$RejectReasonR2 : "",
                onChange: function (event) { return handleSelectCustomerComplaintrejectReason(event, index); },
                disabled: isDisabled,
                isMandatory: declinedJobsConfiguration === null || declinedJobsConfiguration === void 0 ? void 0 : declinedJobsConfiguration.IsReasonsMandatory
            })), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sm: 6
            }, /*#__PURE__*/ React.createElement(InputBox, {
                multiline: isXs ? true : false,
                rows: isXs ? 2 : 1
                // sx={{ height: '44px' }}
                ,
                id: "remark-input",
                placeholder: "".concat(t("ENTER_REMARKS_PLACEHOLDER"), " ").concat(declinedJobsConfiguration !== null && declinedJobsConfiguration !== void 0 && declinedJobsConfiguration.IsRemarksMandatory ? "*" : ""),
                onChange: function (event) { return handleChangeCustomerComplaintRejectRemark(event, index); },
                fullWidth: true,
                size: "small",
                value: (_option$DeclinedRemar2 = option.DeclinedRemarks) !== null && _option$DeclinedRemar2 !== void 0 ? _option$DeclinedRemar2 : "",
                disabled: isDisabled
            }))));
        }), /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            padding: 1,
            alignItems: "center",
            spacing: 1
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12
        }, /*#__PURE__*/ React.createElement(Divider, null)), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 6,
            paddingTop: 2
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3"
        }, t("Sub total"))), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 3,
            paddingTop: 2
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3",
            sx: {
                whiteSpace: 'nowrap'
            }
        }, "\u20B9 ", getCustomerVoiceSubTotalPart())), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 3,
            paddingTop: 2
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3",
            sx: {
                whiteSpace: 'nowrap'
            }
        }, "\u20B9 ", getCustomerVoiceSubTotalLabour()))), !isDisabled && /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            item: true,
            justifyContent: "flex-end",
            alignItems: "center",
            padding: 1
        }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
            variant: "outlined",
            size: "small",
            color: "primary",
            style: {
                width: "60px"
            },
            name: customerComplainText,
            onClick: saveCustomerComplaint,
            id: "saveCustomerComplaintEstimate",
            disabled: checkReasonRemarkValidate(customerComplaintData) || !disabledSave.CustomerComplaint,
            loading: loader.isLoaderOpen
        }))) : /*#__PURE__*/ React.createElement(React.Fragment, null, !complaintSkeleton && /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: "center",
            alignItems: "center",
            width: "100%"
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3"
        }, " ", t("No data found"))))), complaintSkeleton && /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column',
            style: {
                height: '50px'
            }
        }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)))))) : (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.StandardJobs && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut14 = item.SectionAttributes[0]) !== null && _item$SectionAttribut14 !== void 0 && _item$SectionAttribut14.HIDE) ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12
        }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Accordion, {
            style: {
                width: "100%",
                borderBottom: "1px solid #DEE4EB",
                boxShadow: "none",
                borderRadius: 0
            }
        }, /*#__PURE__*/ React.createElement(AccordionSummary, {
            expandIcon: /*#__PURE__*/ React.createElement(ExpandMoreIcon, {
                sx: {
                    height: '25px',
                    width: '25px'
                }
            }),
            id: "".concat(item === null || item === void 0 ? void 0 : item.Key),
            "aria-controls": "panel1a-content",
            sx: {
                paddingX: '7px'
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: "space-between",
            width: "100%",
            px: 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: IS_DESKTOP ? '20px' : 0,
            direction: IS_DESKTOP ? 'row' : 'column'
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontWeight: '500',
            color: "secondary.600"
        }, item === null || item === void 0 ? void 0 : item.DisplayName), /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 1
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontWeight: '400',
            color: "secondary.500"
        }, "Jobs-"), /*#__PURE__*/ React.createElement(Typography, {
            id: "standard-job-price"
        }, standardJobData !== null && standardJobData !== void 0 && standardJobData.length ? standardJobData === null || standardJobData === void 0 ? void 0 : standardJobData.length : 0)))), /*#__PURE__*/ React.createElement(MuiStack, null, standardJobSkeleton ? /*#__PURE__*/ React.createElement("span", {
            style: {
                width: '50px',
                height: '20px'
            }
        }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)) : /*#__PURE__*/ React.createElement(Typography, {
            id: "standard-job-price",
            variant: "h3",
            sx: {
                whiteSpace: 'nowrap'
            }
        }, "\u20B9 ", getStandardJobsTotal())))), /*#__PURE__*/ React.createElement(AccordionDetails, {
            sx: {
                paddingX: '7px',
                backgroundColor: '#F4F7FA'
            }
        }, /*#__PURE__*/ React.createElement(Divider, {
            sx: {}
        }), /*#__PURE__*/ React.createElement(MuiStack, {
            padding: 0.8
        }, (standardJobData === null || standardJobData === void 0 ? void 0 : standardJobData.length) > 0 ? /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column',
            width: '100%'
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            spacing: 1,
            p: 1,
            key: index,
            sx: {
                backgroundColor: '#F4F7FA'
            }
            // p={'12px 16px'}
        }, standardJobData === null || standardJobData === void 0 ? void 0 : standardJobData.map(function (option, index) {
            var _option$StandardParts7, _option$StandardParts8, _option$RejectReasonR3, _option$DeclinedRemar3;
            return /*#__PURE__*/ React.createElement(Grid, {
                alignItems: "center",
                key: option.label,
                item: true,
                xs: 12,
                sm: 6,
                p: 0.5,
                md: 12
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                direction: 'column',
                key: index,
                sx: {
                    "& .Mui-expanded": {
                        transform: "none",
                        backgroundColor: 'error.50',
                        borderRadius: '8px'
                    },
                    "& .MuiAccordionSummary-expandIconWrapper": {
                        height: '20px',
                        marginBottom: '50px'
                    }
                },
                border: option.isExpanded ? "1px solid ".concat(Colors.error[500]) : 'none',
                bgcolor: option.isExpanded ? Colors.error[50] : 'white',
                borderRadius: '8px',
                boxShadow: '0px 0px 16px #00000014'
            }, /*#__PURE__*/ React.createElement(Grid, {
                container: true
            }, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                md: 12
            }, /*#__PURE__*/ React.createElement(Accordion, {
                expanded: option.isExpanded,
                id: "additionalJobs-accordian-".concat(index),
                style: {
                    width: '100%',
                    boxShadow: 'none',
                    borderRadius: '8px'
                }
            }, /*#__PURE__*/ React.createElement(AccordionSummary, {
                expandIcon: /*#__PURE__*/ React.createElement(MuiStack, {
                    paddingTop: 3,
                    alignItems: 'center',
                    width: '100%'
                }, IS_DESKTOP ? /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "h3",
                    fontWeight: 500,
                    sx: {
                        mr: 1,
                        width: '80px',
                        color: "#1B1D21"
                    }
                }, "\u20B9", ' ', getStandardJobGroupTotal(option))) : null, IS_DESKTOP && StandardJobCardAccordianActions(option, index), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiIconButton, {
                    onClick: function () { return openStandardJobDetailsDrawer(option, index); },
                    sx: {
                        paddingRight: 0
                    }
                }, /*#__PURE__*/ React.createElement(ChevronRightIcon, {
                    sx: {
                        color: systemColor.primary,
                        height: '20px',
                        width: '20px'
                    }
                })))),
                "aria-controls": "panel".concat(index, "a-content"),
                id: "panel".concat(index, "a-header")
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                direction: 'column',
                justifyContent: 'space-between',
                width: "100%",
                paddingRight: 1
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                alignItems: 'center',
                width: '100%'
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                width: '100%',
                spacing: 1.25,
                alignItems: 'center',
                justifyContent: 'space-between'
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                direction: 'column'
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                justifyContent: 'flex-start',
                alignItems: "center"
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h3",
                sx: {
                    textTransform: 'capitalize'
                }
            }, option === null || option === void 0 ? void 0 : option.StandardServiceGroupName, " ")), IS_DESKTOP ? /*#__PURE__*/ React.createElement(MuiStack, {
                spacing: 1
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                spacing: 1
            }, /*#__PURE__*/ React.createElement(Typography, {
                fontWeight: '400',
                color: "secondary.500"
            }, "Part-"), /*#__PURE__*/ React.createElement(Typography, null, (_option$StandardParts7 = option.StandardParts) !== null && _option$StandardParts7 !== void 0 && _option$StandardParts7.Part ? option.StandardParts.Part.length.toString().padStart(2, '0') : '00')), /*#__PURE__*/ React.createElement(Divider, {
                orientation: "vertical",
                flexItem: true
            }), /*#__PURE__*/ React.createElement(MuiStack, {
                spacing: 1
            }, /*#__PURE__*/ React.createElement(Typography, {
                fontWeight: '400',
                color: "secondary.500"
            }, "Labour-"), /*#__PURE__*/ React.createElement(Typography, null, (_option$StandardParts8 = option.StandardParts) !== null && _option$StandardParts8 !== void 0 && _option$StandardParts8.Labour ? option.StandardParts.Labour.length.toString().padStart(2, '0') : '00'))) : null))))), /*#__PURE__*/ React.createElement(AccordionDetails, null, /*#__PURE__*/ React.createElement(MuiStack, {
                width: '100%',
                spacing: 2,
                direction: IS_DESKTOP ? 'row' : 'column'
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                width: '100%',
                borderRadius: '8px'
            }, /*#__PURE__*/ React.createElement(MuiSelectComponent, {
                id: "reject-reason-dropdown",
                margin: 0,
                fullWidth: true,
                options: rejectReasonRemarkList || [],
                caption: "cancellation reason ".concat(declinedJobsConfiguration !== null && declinedJobsConfiguration !== void 0 && declinedJobsConfiguration.IsRemarksMandatory ? "*" : ""),
                displayExpr: "DisplayName",
                valueExpr: "id",
                name: "rejectReason",
                value: (_option$RejectReasonR3 = option.RejectReasonRemark) !== null && _option$RejectReasonR3 !== void 0 ? _option$RejectReasonR3 : "",
                onChange: function (event) { return handleSelectStandardJobsRejectReason(event, index); },
                disabled: isDisabled
            })), /*#__PURE__*/ React.createElement(MuiStack, {
                width: '100%',
                borderRadius: '8px'
            }, /*#__PURE__*/ React.createElement(InputBox, {
                multiline: isXs ? true : false,
                rows: isXs ? 2 : 1,
                id: "remark-input",
                placeholder: "".concat(t("ENTER_REMARKS_PLACEHOLDER"), " ").concat(declinedJobsConfiguration !== null && declinedJobsConfiguration !== void 0 && declinedJobsConfiguration.IsRemarksMandatory ? "*" : ""),
                onChange: function (event) { return handleChangeStandardJobsRejectRemark(event, index); },
                fullWidth: true,
                size: "small",
                value: (_option$DeclinedRemar3 = option.DeclinedRemarks) !== null && _option$DeclinedRemar3 !== void 0 ? _option$DeclinedRemar3 : "",
                disabled: isDisabled
            })))))), !IS_DESKTOP && /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                paddingX: 2
            }, /*#__PURE__*/ React.createElement(Divider, {
                style: {
                    width: '100%'
                }
            }))), !IS_DESKTOP && StandardJobCardAccordianActions(option, index), option.errorMessage && /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                paddingX: 2,
                pb: 1
            }, /*#__PURE__*/ React.createElement(FormHelperText, {
                sx: {
                    color: 'red'
                }
            }, option.errorMessage)))));
        })), /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            item: true,
            justifyContent: "flex-end",
            alignItems: "center",
            padding: 1
        }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
            variant: "outlined",
            size: "small",
            color: "primary",
            style: {
                width: "60px"
            },
            name: standardJobText,
            onClick: saveStandardJobs,
            id: "saveStandardJobsEstimate",
            disabled: checkReasonRemarkValidate(standardJobData) || !disabledSave.StandardJob,
            loading: loader.isLoaderOpen
        }))) : /*#__PURE__*/ React.createElement(React.Fragment, null, !standardJobSkeleton && /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: "center",
            alignItems: "center",
            width: "100%"
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3"
        }, " ", t("No data found"))))), standardJobSkeleton && /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column',
            style: {
                height: '50px'
            }
        }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)))))) : (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.RoadTest && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut15 = item.SectionAttributes[0]) !== null && _item$SectionAttribut15 !== void 0 && _item$SectionAttribut15.HIDE) && Module === isModuleConfig.Product ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12
        }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Accordion, {
            style: {
                width: "100%",
                borderBottom: "1px solid #DEE4EB",
                boxShadow: "none",
                borderRadius: 0
            }
        }, /*#__PURE__*/ React.createElement(AccordionSummary, {
            expandIcon: /*#__PURE__*/ React.createElement(ExpandMoreIcon, {
                sx: {
                    height: '25px',
                    width: '25px'
                }
            }),
            "aria-controls": "panel1a-content",
            id: "".concat(item === null || item === void 0 ? void 0 : item.Key),
            sx: {
                paddingX: '7px'
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: "space-between",
            width: "100%",
            px: 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: IS_DESKTOP ? '20px' : 0,
            direction: IS_DESKTOP ? 'row' : 'column'
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontWeight: '500',
            color: "secondary.600"
        }, item === null || item === void 0 ? void 0 : item.DisplayName), /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 1
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontWeight: '400',
            color: "secondary.500"
        }, "Jobs-"), /*#__PURE__*/ React.createElement(Typography, {
            id: "standard-job-price"
        }, roadTestData !== null && roadTestData !== void 0 && roadTestData.length ? roadTestData === null || roadTestData === void 0 ? void 0 : roadTestData.length : 0))), /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3",
            sx: {
                whiteSpace: 'nowrap'
            }
        }, "\u20B9 ", getRoadTestTotal()))), /*#__PURE__*/ React.createElement(AccordionDetails, {
            sx: {
                paddingX: '7px'
            }
        }, /*#__PURE__*/ React.createElement(Divider, {
            sx: {
                mb: 1
            }
        }), /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {},
            direction: "column",
            spacing: 0.4,
            padding: 0.5
        }, (roadTestData === null || roadTestData === void 0 ? void 0 : roadTestData.length) > 0 ? /*#__PURE__*/ React.createElement(MuiForm, null, /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            justifyContent: "space-between",
            alignItems: "center",
            padding: 1
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 3,
            sm: 6,
            md: 7
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "subtitle1"
        })), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 4,
            sm: 2.5,
            md: 2
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h4",
            align: "center",
            color: gray
        }, t("Parts (₹)"))), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 3.5,
            sm: 2.5,
            md: 2
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h4",
            align: "center",
            color: gray
        }, t("Labours (₹)"))), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 0.2,
            sm: 1,
            md: 1
        })), roadTestData.map(function (option, index) {
            var _option$PartPrice2, _option$LabourPrice2, _option$ComplaintAsso9, _option$ComplaintAsso10, _option$ComplaintAsso11, _option$ComplaintAsso12, _option$RejectReasonR4, _option$DeclinedRemar4;
            return /*#__PURE__*/ React.createElement(Grid, {
                container: true,
                item: true,
                key: option === null || option === void 0 ? void 0 : option.ComplaintName,
                alignItems: "center",
                spacing: 0.4,
                sx: {
                    marginTop: 2,
                    paddingTop: 2,
                    backgroundColor: white
                },
                p: '12px'
            }, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 4,
                sm: 6,
                md: 7,
                sx: {
                    display: 'flex',
                    placeItems: 'center'
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h3"
            }, option === null || option === void 0 ? void 0 : option.ComplaintName), /*#__PURE__*/ React.createElement(MuiIconButton, {
                onClick: function () { return handleRoadTestToggle(option === null || option === void 0 ? void 0 : option.ComplaintId); }
            }, option !== null && option !== void 0 && option.isOpenRoadTest ? /*#__PURE__*/ React.createElement(ChevronUpIcon, null) : /*#__PURE__*/ React.createElement(ChevronDownIcon, null))), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 4,
                sm: 2.5,
                md: 2
            }, /*#__PURE__*/ React.createElement(InputBox, {
                disabled: !(option !== null && option !== void 0 && option.IsEditable) || isDisabled,
                name: option === null || option === void 0 ? void 0 : option.ComplaintName,
                value: (_option$PartPrice2 = option === null || option === void 0 ? void 0 : option.PartPrice) !== null && _option$PartPrice2 !== void 0 ? _option$PartPrice2 : '',
                onChange: function (event) { return handleInputRoadTestPartPriceChange(event, index, option, "PartPrice"); }
                // onBlur={calculateAmount}
                ,
                size: "small"
                // type='number'
                ,
                inputProps: {
                    inputMode: 'decimal',
                    pattern: '[0-9]*[.,]?[0-9]*'
                },
                sx: {
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #DEE4EB",
                    borderRadius: "8px",
                    ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input": {
                        padding: "8.5px 5px"
                    },
                    ".css-km5qz1-MuiInputBase-root-MuiOutlinedInput-root": {
                        fontSize: '14px'
                    }
                }
                // id={option.id}
                // InputProps={{
                //   startAdornment: (
                //     <>
                //       <Typography sx={{ marginRight: "1px" }}>
                //         ₹
                //       </Typography>
                //     </>
                //   ),
                // }}
            })), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 3.5,
                sm: 2.5,
                md: 2
            }, /*#__PURE__*/ React.createElement(InputBox, {
                disabled: !(option !== null && option !== void 0 && option.IsEditable) || isDisabled,
                name: option === null || option === void 0 ? void 0 : option.CustomerComplaint,
                value: (_option$LabourPrice2 = option === null || option === void 0 ? void 0 : option.LabourPrice) !== null && _option$LabourPrice2 !== void 0 ? _option$LabourPrice2 : '',
                onChange: function (event) { return handleInputRoadTestPartPriceChange(event, index, option, "LabourPrice"); }
                // onBlur={calculateAmount}
                ,
                size: "small",
                inputProps: {
                    inputMode: 'decimal',
                    pattern: '[0-9]*[.,]?[0-9]*'
                },
                sx: {
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #DEE4EB",
                    borderRadius: "8px",
                    ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input": {
                        padding: "8.5px 5px"
                    },
                    ".css-km5qz1-MuiInputBase-root-MuiOutlinedInput-root": {
                        fontSize: '14px'
                    }
                }
                // id={option.id}
                // InputProps={{
                //   startAdornment: (
                //     <>
                //       <Typography sx={{ marginRight: "1px" }}>
                //         ₹
                //       </Typography>
                //     </>
                //   ),
                // }}
            })), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 0.2,
                sm: 1,
                md: 1,
                justifyContent: 'center'
            }, declinedJobsConfiguration !== null && declinedJobsConfiguration !== void 0 && declinedJobsConfiguration.IsAbleToDeclined ? /*#__PURE__*/ React.createElement(IconButton, {
                disabled: disableRejectItem,
                onClick: function () { return onClickCloseIconRoadTest(index); }
            }, /*#__PURE__*/ React.createElement("img", {
                alt: "cross",
                src: option.isExpanded ? CrossCircleRed : CloseCircleBlackNew,
                style: {
                    opacity: disableRejectItem ? 0.5 : 1
                }
            })) : /*#__PURE__*/ React.createElement(React.Fragment, null)), (option === null || option === void 0 ? void 0 : option.isOpenRoadTest) && /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sm: 12,
                md: 12,
                sx: {
                    margin: '10px 0px'
                }
            }, /*#__PURE__*/ React.createElement(Divider, null)), (option === null || option === void 0 ? void 0 : option.isOpenRoadTest) && (option === null || option === void 0 || (_option$ComplaintAsso9 = option.ComplaintAssociations) === null || _option$ComplaintAsso9 === void 0 || (_option$ComplaintAsso9 = _option$ComplaintAsso9.Labour) === null || _option$ComplaintAsso9 === void 0 ? void 0 : _option$ComplaintAsso9.length) > 0 && (option === null || option === void 0 || (_option$ComplaintAsso10 = option.ComplaintAssociations) === null || _option$ComplaintAsso10 === void 0 || (_option$ComplaintAsso10 = _option$ComplaintAsso10.Labour) === null || _option$ComplaintAsso10 === void 0 ? void 0 : _option$ComplaintAsso10.map(function (it) { return handlePartLabourAccordion({
                type: 'Labour',
                Name: it === null || it === void 0 ? void 0 : it.LabourName,
                Code: it === null || it === void 0 ? void 0 : it.LabourCode,
                Price: it === null || it === void 0 ? void 0 : it.Price,
                Quantity: it === null || it === void 0 ? void 0 : it.Quantity,
                ServiceType: it === null || it === void 0 ? void 0 : it.ServiceType,
                Item: it,
                Element: option,
                parentType: EModuleSection.RoadTest
            }); })), (option === null || option === void 0 ? void 0 : option.isOpenRoadTest) && (option === null || option === void 0 || (_option$ComplaintAsso11 = option.ComplaintAssociations) === null || _option$ComplaintAsso11 === void 0 || (_option$ComplaintAsso11 = _option$ComplaintAsso11.Part) === null || _option$ComplaintAsso11 === void 0 ? void 0 : _option$ComplaintAsso11.length) > 0 && (option === null || option === void 0 || (_option$ComplaintAsso12 = option.ComplaintAssociations) === null || _option$ComplaintAsso12 === void 0 || (_option$ComplaintAsso12 = _option$ComplaintAsso12.Part) === null || _option$ComplaintAsso12 === void 0 ? void 0 : _option$ComplaintAsso12.map(function (it) { return handlePartLabourAccordion({
                type: 'Part',
                Name: it === null || it === void 0 ? void 0 : it.PartName,
                Code: it === null || it === void 0 ? void 0 : it.PartCode,
                Price: it === null || it === void 0 ? void 0 : it.Price,
                Quantity: it === null || it === void 0 ? void 0 : it.Quantity,
                ServiceType: it === null || it === void 0 ? void 0 : it.ServiceType,
                Item: it,
                Element: option,
                parentType: EModuleSection.RoadTest
            }); })), option.isExpanded && /*#__PURE__*/ React.createElement(Grid, {
                container: true,
                gap: 1,
                p: '12px 0px'
            }, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sm: 5.8
            }, /*#__PURE__*/ React.createElement(MuiSelectComponent, {
                id: "reject-reason-dropdown",
                margin: 0,
                fullWidth: true,
                options: rejectReasonRemarkList || [],
                caption: "cancellation reason",
                displayExpr: "DisplayName",
                valueExpr: "id",
                name: "rejectReason",
                value: (_option$RejectReasonR4 = option.RejectReasonRemark) !== null && _option$RejectReasonR4 !== void 0 ? _option$RejectReasonR4 : "",
                onChange: function (event) { return handleSelectRoadTestRejectReason(event, index); },
                disabled: isDisabled,
                isMandatory: declinedJobsConfiguration === null || declinedJobsConfiguration === void 0 ? void 0 : declinedJobsConfiguration.IsReasonsMandatory
            })), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sm: 6
            }, /*#__PURE__*/ React.createElement(InputBox, {
                sx: {
                    backgroundColor: 'white'
                },
                multiline: isXs ? true : false,
                rows: isXs ? 2 : 1
                // sx={{ height: '44px' }}
                ,
                id: "remark-input",
                placeholder: "".concat(t("ENTER_REMARKS_PLACEHOLDER"), " ").concat(declinedJobsConfiguration !== null && declinedJobsConfiguration !== void 0 && declinedJobsConfiguration.IsRemarksMandatory ? "*" : ""),
                onChange: function (event) { return handleChangeRoadTestRejectRemark(event, index); },
                fullWidth: true,
                size: "small",
                value: (_option$DeclinedRemar4 = option.DeclinedRemarks) !== null && _option$DeclinedRemar4 !== void 0 ? _option$DeclinedRemar4 : "",
                disabled: isDisabled
            }))));
        }), /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            padding: 1,
            alignItems: "center",
            spacing: 1
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12
        }, /*#__PURE__*/ React.createElement(Divider, null)), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 6,
            paddingTop: 2
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3"
        }, t("Sub total"))), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 3,
            paddingTop: 2
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "roadTestPart",
            variant: "h3",
            sx: {
                whiteSpace: 'nowrap'
            }
        }, "\u20B9 ", getRoadTestPartsSubTotal())), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 3,
            paddingTop: 2
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "roadTestLabour",
            variant: "h3",
            sx: {
                whiteSpace: 'nowrap'
            }
        }, "\u20B9 ", getRoadTestLaboursSubTotal()))), !isDisabled && /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            item: true,
            justifyContent: "flex-end",
            alignItems: "center",
            padding: 1
        }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
            variant: "outlined",
            size: "small",
            color: "primary",
            style: {
                width: "60px"
            },
            name: roadTestText,
            onClick: saveRoadTest,
            id: "saveRoadTestEstimate",
            disabled: checkReasonRemarkValidate(roadTestData) || !disabledSave.RoadTest,
            loading: loader.isLoaderOpen
        }))) : /*#__PURE__*/ React.createElement(React.Fragment, null, !roadTestSkeleton && /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: "center",
            alignItems: "center"
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3"
        }, " ", t("No data found"))))), roadTestSkeleton && /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column',
            style: {
                height: '50px'
            }
        }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)))))) : (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.AdditionalJobs && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut16 = item.SectionAttributes[0]) !== null && _item$SectionAttribut16 !== void 0 && _item$SectionAttribut16.HIDE) ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12
        }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Accordion, {
            style: {
                width: "100%",
                // border: index == 0 ? "" : "1px solid #DEE4EB",
                borderBottom: "1px solid #DEE4EB",
                boxShadow: "none",
                borderRadius: 0
            }
        }, /*#__PURE__*/ React.createElement(AccordionSummary, {
            expandIcon: /*#__PURE__*/ React.createElement(ExpandMoreIcon, {
                sx: {
                    height: '25px',
                    width: '25px'
                }
            }),
            "aria-controls": "panel1a-content",
            id: "".concat(item === null || item === void 0 ? void 0 : item.Key),
            sx: {
                paddingX: '7px'
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: "space-between",
            width: "100%",
            px: 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: IS_DESKTOP ? '20px' : 0,
            direction: IS_DESKTOP ? 'row' : 'column'
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontWeight: '500',
            color: "secondary.600"
        }, item === null || item === void 0 ? void 0 : item.DisplayName), /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 1
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontWeight: '400',
            color: "secondary.500"
        }, "Part-"), /*#__PURE__*/ React.createElement(Typography, {
            id: "additional-job-part-total"
        }, getAdditionalCount().parts)), /*#__PURE__*/ React.createElement(Divider, {
            orientation: "vertical",
            flexItem: true
        }), /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 1
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontWeight: '400',
            color: "secondary.500"
        }, "Labour-"), /*#__PURE__*/ React.createElement(Typography, {
            id: "additional-job-labour-total"
        }, getAdditionalCount().labours)))), additionalSkeleton ? /*#__PURE__*/ React.createElement("span", {
            style: {
                width: '50px',
                height: '20px'
            }
        }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)) : /*#__PURE__*/ React.createElement(Typography, {
            id: "AdditionalJobTotal",
            variant: "h3",
            sx: {
                whiteSpace: 'nowrap'
            }
        }, "\u20B9 ", getAdditionalJobSubTotal()))), /*#__PURE__*/ React.createElement(AccordionDetails, {
            sx: {
                paddingX: '0px',
                paddingBottom: 0
            }
        }, /*#__PURE__*/ React.createElement(Divider, null), /*#__PURE__*/ React.createElement(MuiStack, {
            direction: "column",
            spacing: 1,
            padding: 1,
            bgcolor: systemColor.backgroundColor
        }, additionalJobData.length > 0 ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
            container: true
        }, additionalJobData.map(function (option, index) {
            var _option$jobType2, _option$RejectReasonR5, _option$DeclinedRemar5;
            return /*#__PURE__*/ React.createElement(Grid, {
                alignItems: "center",
                key: option.label,
                item: true,
                xs: 12,
                sm: 6,
                p: 0.5,
                md: 12
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                direction: 'column',
                key: index,
                sx: {
                    "& .Mui-expanded": {
                        transform: "none",
                        backgroundColor: 'error.50',
                        borderRadius: '8px'
                    },
                    "& .MuiAccordionSummary-expandIconWrapper": {
                        height: '20px',
                        marginBottom: '50px'
                    }
                },
                border: option.isExpanded ? "1px solid ".concat(Colors.error[500]) : 'none',
                bgcolor: option.isExpanded ? Colors.error[50] : 'white',
                borderRadius: '8px',
                boxShadow: '0px 0px 16px #00000014'
            }, /*#__PURE__*/ React.createElement(Grid, {
                container: true
            }, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                md: 12
            }, /*#__PURE__*/ React.createElement(Accordion, {
                expanded: option.isExpanded,
                id: "additionalJobs-accordian-".concat(index),
                style: {
                    width: '100%',
                    boxShadow: 'none',
                    borderRadius: '8px'
                }
            }, /*#__PURE__*/ React.createElement(AccordionSummary, {
                expandIcon: /*#__PURE__*/ React.createElement(MuiStack, {
                    paddingTop: 3,
                    alignItems: 'center',
                    width: '100%'
                }, /*#__PURE__*/ React.createElement(MuiStack, {
                    width: '22px',
                    height: '22px',
                    sx: {
                        backgroundColor: "#EEF6FF",
                        padding: '5px',
                        borderRadius: "50%",
                        border: '1px solid #AFD5FF',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }
                }, /*#__PURE__*/ React.createElement(Typography, {
                    id: (option === null || option === void 0 ? void 0 : option.jobType) === 'Labour' ? 'L' : 'P',
                    sx: {
                        color: systemColor.primary
                    },
                    variant: "h5"
                }, (_option$jobType2 = option.jobType) === null || _option$jobType2 === void 0 ? void 0 : _option$jobType2.substring(0, 1))), IS_DESKTOP && AdditionalAccordianActions(option, index), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiIconButton, {
                    onClick: function () { return openJobDetailsDrawer(option, EJobItemType.Additional); },
                    sx: {
                        paddingRight: 0
                    }
                }, /*#__PURE__*/ React.createElement(ChevronRightIcon, {
                    sx: {
                        color: systemColor.primary,
                        height: '20px',
                        width: '20px'
                    }
                })))),
                "aria-controls": "panel".concat(index, "a-content"),
                id: "panel".concat(index, "a-header")
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                direction: 'column',
                justifyContent: 'space-between',
                width: "100%",
                paddingRight: 1
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                alignItems: 'center',
                width: '100%'
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                width: '100%',
                spacing: 1.25,
                alignItems: 'center',
                justifyContent: 'space-between'
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                direction: 'column'
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                justifyContent: 'flex-start',
                alignItems: "flex-start"
            }, /*#__PURE__*/ React.createElement(Typography, {
                id: (option === null || option === void 0 ? void 0 : option.jobType) === 'Labour' ? 'labour-name' : 'part-name',
                variant: "h5",
                sx: {
                    textTransform: 'capitalize'
                }
            }, " ", " ", (option === null || option === void 0 ? void 0 : option.jobType) == "Labour" ? option === null || option === void 0 ? void 0 : option.LabourName : option === null || option === void 0 ? void 0 : option.PartName))))), /*#__PURE__*/ React.createElement(ReCallBatch, {
                option: option,
                index: index
            }))), /*#__PURE__*/ React.createElement(AccordionDetails, null, /*#__PURE__*/ React.createElement(MuiStack, {
                width: '100%',
                spacing: 2,
                direction: IS_DESKTOP ? 'row' : 'column'
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                width: '100%',
                borderRadius: '8px'
            }, /*#__PURE__*/ React.createElement(MuiSelectComponent, {
                id: "reject-reason-dropdown",
                margin: 0,
                fullWidth: true,
                options: rejectReasonRemarkList || [],
                caption: "cancellation reason",
                displayExpr: "DisplayName",
                valueExpr: "id",
                name: "rejectReason",
                value: (_option$RejectReasonR5 = option.RejectReasonRemark) !== null && _option$RejectReasonR5 !== void 0 ? _option$RejectReasonR5 : "",
                onChange: function (event) { return handleSelectAdditionalJobRejectReason(event, index); },
                disabled: isDisabled,
                isMandatory: declinedJobsConfiguration === null || declinedJobsConfiguration === void 0 ? void 0 : declinedJobsConfiguration.IsReasonsMandatory
            })), /*#__PURE__*/ React.createElement(MuiStack, {
                width: '100%',
                borderRadius: '8px'
            }, /*#__PURE__*/ React.createElement(InputBox, {
                id: "remark-input",
                placeholder: "".concat(t("ENTER_REMARKS_PLACEHOLDER"), " ").concat(declinedJobsConfiguration !== null && declinedJobsConfiguration !== void 0 && declinedJobsConfiguration.IsRemarksMandatory ? "*" : ""),
                onChange: function (event) { return handleChangeRejectRemark(event, index); },
                fullWidth: true,
                size: "small",
                value: (_option$DeclinedRemar5 = option.DeclinedRemarks) !== null && _option$DeclinedRemar5 !== void 0 ? _option$DeclinedRemar5 : "",
                disabled: isDisabled
            })))))), !IS_DESKTOP && /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                paddingX: 2
            }, /*#__PURE__*/ React.createElement(Divider, {
                style: {
                    width: '100%'
                }
            }))), !IS_DESKTOP && AdditionalAccordianActions(option, index), option.errorMessage && /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                paddingX: 2,
                pb: 1
            }, /*#__PURE__*/ React.createElement(FormHelperText, {
                sx: {
                    color: 'red'
                }
            }, option.errorMessage)))));
        })), /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            justifyContent: 'space-between'
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            paddingTop: 2,
            paddingX: 2
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3"
        }, t("Sub total"))), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            paddingX: '3px',
            paddingTop: 2
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "AddJobs-SubTotal",
            variant: "h3",
            sx: {
                whiteSpace: 'nowrap'
            }
        }, "\u20B9 ", getAdditionalJobSubTotal()))), !isDisabled && /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            item: true,
            justifyContent: "flex-end",
            alignItems: "center",
            padding: 1
        }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
            loading: loader.isLoaderOpen,
            variant: "outlined",
            size: "small",
            color: "primary",
            style: {
                width: "60px"
            },
            name: additionalJobText,
            onClick: saveAdditionalJob,
            id: "saveAdditionalJobEstimate",
            disabled: checkReasonRemarkValidate(additionalJobData) || !disabledSave.AdditionalJob
        }))) : /*#__PURE__*/ React.createElement(React.Fragment, null, !additionalSkeleton && /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: "center",
            alignItems: "center"
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3"
        }, " ", t("No data found"))))), additionalSkeleton && /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column',
            style: {
                height: '50px'
            }
        }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)))))) : (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.RoadTestAndCustomerComplaint && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut17 = item.SectionAttributes[0]) !== null && _item$SectionAttribut17 !== void 0 && _item$SectionAttribut17.HIDE) && Module === isModuleConfig.Bajaj ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12
        }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Accordion, {
            style: {
                width: "100%",
                borderBottom: "1px solid #DEE4EB",
                boxShadow: "none",
                borderRadius: 0
            }
        }, /*#__PURE__*/ React.createElement(AccordionSummary, {
            expandIcon: /*#__PURE__*/ React.createElement(ExpandMoreIcon, {
                sx: {
                    height: '25px',
                    width: '25px'
                }
            }),
            "aria-controls": "panel1a-content",
            id: "".concat(item === null || item === void 0 ? void 0 : item.Key),
            sx: {
                paddingX: '7px'
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: "space-between",
            width: "100%",
            px: 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: IS_DESKTOP ? '20px' : 0,
            direction: IS_DESKTOP ? 'row' : 'column'
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontWeight: '500',
            color: "secondary.600"
        }, item === null || item === void 0 ? void 0 : item.DisplayName), /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 1
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontWeight: '400',
            color: "secondary.500"
        }, "Jobs-"), /*#__PURE__*/ React.createElement(Typography, {
            id: "standard-job-price"
        }, roadTestData !== null && roadTestData !== void 0 && roadTestData.length ? roadTestData === null || roadTestData === void 0 ? void 0 : roadTestData.length : 0))), roadTestSkeleton ? /*#__PURE__*/ React.createElement("span", {
            style: {
                width: '50px',
                height: '20px'
            }
        }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)) : /*#__PURE__*/ React.createElement(Typography, {
            id: "JobItemAmt",
            variant: "h3",
            sx: {
                whiteSpace: 'nowrap'
            }
        }, "\u20B9 ", getCustomerComplaintsTotal()))), /*#__PURE__*/ React.createElement(AccordionDetails, {
            sx: {
                paddingX: '7px',
                backgroundColor: '#F4F7FA'
            }
        }, (roadTestData === null || roadTestData === void 0 ? void 0 : roadTestData.length) > 0 ? /*#__PURE__*/ React.createElement(MuiForm, null, !isXs && /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            justifyContent: "space-between",
            alignItems: "center",
            padding: 1,
            sx: {
                backgroundColor: "#F4F7FA"
            }
        }), /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            spacing: 1,
            padding: 1,
            sx: {
                backgroundColor: "#F4F7FA"
            }
        }, roadTestData.map(function (option, index) {
            var _option$PartPrice3, _option$LabourPrice3, _option$PartPrice4, _option$LabourPrice4, _option$PartPrice5, _option$LabourPrice5, _option$RejectReasonR6, _option$DeclinedRemar6, _option$PartPrice6, _option$LabourPrice6;
            return (
            /*#__PURE__*/
            // <Grid
            //   container
            //   item
            //   key={option?.ComplaintName}
            //   alignItems="center"
            //   spacing={2}
            //   padding={1}
            // >
            //   {
            //     !isXs && (
            //       <>
            //         {/* <Grid item xs={5} sm={5} md={6}>
            //           <Typography variant="h3">
            //             {option?.ComplaintName}
            //           </Typography>
            //         </Grid> */}
            //         <Grid item xs={3.5} sm={3} md={2.5}>
            //           <InputBox
            //             disabled={!option?.IsEditable || isDisabled || option.isExpanded}
            //             name={option?.ComplaintName}
            //             value={option?.PartPrice ?? ''}
            //             onChange={(event) =>
            //               handleInputRoadTestPartPriceChange(
            //                 event,
            //                 index,
            //                 option,
            //                 "PartPrice"
            //               )
            //             }
            //             // onBlur={calculateAmount}
            //             size="small"
            //             inputProps={{ inputMode: 'decimal', pattern: '[0-9]*[.,]?[0-9]*' }}
            //             sx={{
            //               backgroundColor: "#FFFFFF",
            //               border: "1px solid #DEE4EB",
            //               borderRadius: "8px",
            //               ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input": {
            //                 padding: "8.5px 5px"
            //               },
            //               ".css-km5qz1-MuiInputBase-root-MuiOutlinedInput-root": {
            //                 fontSize: '14px'
            //               }
            //             }}
            //           // id={option.id}
            //           // InputProps={{
            //           //   startAdornment: (
            //           //     <>
            //           //       <Typography sx={{ marginRight: "1px" }}>
            //           //         ₹
            //           //       </Typography>
            //           //     </>
            //           //   ),
            //           // }}
            //           />
            //         </Grid>
            //         <Grid item xs={3.5} sm={3} md={2.5}>
            //           <InputBox
            //             disabled={!option?.IsEditable || isDisabled || option.isExpanded}
            //             name={option?.CustomerComplaint}
            //             value={option?.LabourPrice ?? ''}
            //             onChange={(event) =>
            //               handleInputRoadTestPartPriceChange(
            //                 event,
            //                 index,
            //                 option,
            //                 "LabourPrice"
            //               )
            //             }
            //             // onBlur={calculateAmount}
            //             size="small"
            //             inputProps={{ inputMode: 'decimal', pattern: '[0-9]*[.,]?[0-9]*' }}
            //             sx={{
            //               backgroundColor: "#FFFFFF",
            //               border: "1px solid #DEE4EB",
            //               borderRadius: "8px",
            //               ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input": {
            //                 padding: "8.5px 5px"
            //               },
            //               ".css-km5qz1-MuiInputBase-root-MuiOutlinedInput-root": {
            //                 fontSize: '14px'
            //               }
            //             }}
            //           // id={option.id}
            //           // InputProps={{
            //           //   startAdornment: (
            //           //     <>
            //           //       <Typography sx={{ marginRight: "1px" }}>
            //           //         ₹
            //           //       </Typography>
            //           //     </>
            //           //   ),
            //           // }}
            //           />
            //         </Grid>
            //         <Grid marginLeft={-1} item xs={0.2} sm={1} md={1} justifyContent={'center'}>
            //           <IconButton disabled={disableRejectItem} onClick={() => onClickCloseIconRoadTestAndCustomerComplaints(index)}>
            //             <img alt='cross'
            //               src={option.isExpanded ? CrossCircleRed : CrossCircleGray}
            //               style={{ opacity: disableRejectItem ? 0.5 : 1 }}
            //             />
            //           </IconButton>
            //         </Grid>
            //       </>
            //     )
            //   }
            //   {
            //     isXs && (
            //       <>
            //         <Grid item xs={8}>
            //           <Typography variant="h3">
            //             {option?.ComplaintName}
            //           </Typography>
            //           <Typography variant="h6" color='#8593A3'>
            //             {option?.Code ? `#${option?.Code}` : "-"}
            //           </Typography>
            //         </Grid>
            //         <Grid item xs={4} sx={{ display: 'flex', direction: 'row', placeContent: 'end', placeItems: 'center' }}>
            //           <Typography variant="h3">
            //             {('₹') + ((option?.PartPrice ? Number(option?.PartPrice) : 0) + (option?.LabourPrice ? Number(option?.LabourPrice) : 0))}
            //           </Typography>
            //           <IconButton disabled={disableRejectItem} onClick={() => onClickCloseIconRoadTestAndCustomerComplaints(index)}>
            //             <img alt='cross'
            //               src={option.isExpanded ? CrossCircleRed : CrossCircleGray}
            //               style={{ opacity: disableRejectItem ? 0.5 : 1 }}
            //             />
            //           </IconButton>
            //         </Grid>
            //         <Grid item xs={12}>
            //           <Grid container justifyContent={'space-between'}>
            //             <Grid xs={5}>
            //               <Grid container >
            //                 <Grid xs={4} sx={{ textAlignLast: 'start', placeContent: 'center', justifyContent: 'space-between' }}>
            //                   <Typography variant="h4" align="center" color={gray} whiteSpace={'nowrap'}>
            //                     {t("Part - ")}
            //                   </Typography>
            //                 </Grid>
            //                 <Grid xs={8}>
            //                   <InputBox
            //                     disabled={!option?.IsEditable || isDisabled || option.isExpanded}
            //                     name={option?.ComplaintName}
            //                     value={option?.PartPrice ?? ''}
            //                     onChange={(event) =>
            //                       handleInputRoadTestPartPriceChange(
            //                         event,
            //                         index,
            //                         option,
            //                         "PartPrice"
            //                       )
            //                     }
            //                     // onBlur={calculateAmount}
            //                     size="small"
            //                     inputProps={{ inputMode: 'decimal', pattern: '[0-9]*[.,]?[0-9]*' }}
            //                     sx={{
            //                       backgroundColor: "#FFFFFF",
            //                       border: "1px solid #DEE4EB",
            //                       borderRadius: "8px",
            //                       ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input": {
            //                         padding: "8.5px 5px"
            //                       },
            //                       ".css-km5qz1-MuiInputBase-root-MuiOutlinedInput-root": {
            //                         fontSize: '14px'
            //                       }
            //                     }}
            //                   />
            //                 </Grid>
            //               </Grid>
            //             </Grid>
            //             <Grid xs={6.9}>
            //               <Grid container>
            //                 <Grid xs={4} sx={{ textAlignLast: 'start', placeContent: 'center', justifyContent: 'space-between' }}>
            //                   <Typography variant="h4" align="center" color={gray} whiteSpace={'nowrap'}>
            //                     {t("Labour - ")}
            //                   </Typography>
            //                 </Grid>
            //                 <Grid xs={8}>
            //                   <InputBox
            //                     disabled={!option?.IsEditable || isDisabled || option.isExpanded}
            //                     name={option?.CustomerComplaint}
            //                     value={option?.LabourPrice ?? ''}
            //                     onChange={(event) =>
            //                       handleInputRoadTestPartPriceChange(
            //                         event,
            //                         index,
            //                         option,
            //                         "LabourPrice"
            //                       )
            //                     }
            //                     // onBlur={calculateAmount}
            //                     size="small"
            //                     inputProps={{ inputMode: 'decimal', pattern: '[0-9]*[.,]?[0-9]*' }}
            //                     sx={{
            //                       backgroundColor: "#FFFFFF",
            //                       border: "1px solid #DEE4EB",
            //                       borderRadius: "8px",
            //                       ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input": {
            //                         padding: "8.5px 5px"
            //                       },
            //                       ".css-km5qz1-MuiInputBase-root-MuiOutlinedInput-root": {
            //                         fontSize: '14px'
            //                       }
            //                     }}
            //                   />
            //                 </Grid>
            //               </Grid>
            //             </Grid>
            //           </Grid>
            //         </Grid>
            //       </>
            //     )
            //   }
            //   {
            //     option.isExpanded &&
            //     <Grid item xs={12} paddingY={1}>
            //       <MuiStack spacing={2} direction={'column'} >
            //         <MuiStack bgcolor={'white'} borderRadius={'8px'}>
            //           <MuiSelectComponent
            //             id='reject-reason-dropdown'
            //             margin={0}
            //             fullWidth
            //             options={rejectReasonRemarkList || []}
            //             caption={"cancellation reason"}
            //             displayExpr="DisplayName"
            //             valueExpr="id"
            //             name="rejectReason"
            //             value={option.RejectReasonRemark ?? ""}
            //             onChange={(event: any) => handleSelectRoadTestAndCustomerComplaintrejectReason(event, index)}
            //             disabled={isDisabled}
            //             isMandatory={true}
            //           />
            //         </MuiStack>
            //         <MuiStack bgcolor={'white'} borderRadius={'8px'}>
            //           <InputBox
            //             multiline
            //             rows={2}
            //             // sx={{ height: '44px' }}
            //             id="remark-input"
            //             placeholder={t("Enter remarks")}
            //             onChange={(event: any) => handleChangeRoadTestAndCustomerComplaintRejectRemark(event, index)}
            //             fullWidth
            //             size="small"
            //             value={option.DeclinedRemarks ?? ""}
            //             disabled={isDisabled}
            //           />
            //         </MuiStack>
            //       </MuiStack>
            //     </Grid>
            //   }
            //   {/* <Grid item xs={12}>
            //     <Divider sx={{ marginLeft: -1.5, marginRight: -1.5 }} />
            //   </Grid> */}
            // </Grid>
            React.createElement(Grid, {
                alignItems: "center",
                key: option.label,
                item: true,
                xs: 12,
                sm: 6,
                p: 0.5,
                md: 12
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                direction: 'column',
                key: index,
                sx: {
                    "& .Mui-expanded": {
                        transform: "none",
                        backgroundColor: 'error.50',
                        borderRadius: '8px'
                    },
                    "& .MuiAccordionSummary-expandIconWrapper": {
                        height: '20px',
                        marginBottom: '50px'
                    }
                },
                border: option.isExpanded ? "1px solid ".concat(Colors.error[500]) : 'none',
                bgcolor: option.isExpanded ? Colors.error[50] : 'white',
                borderRadius: '8px',
                boxShadow: '0px 0px 16px #00000014'
            }, /*#__PURE__*/ React.createElement(Grid, {
                container: true
            }, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                md: 12
            }, /*#__PURE__*/ React.createElement(Accordion, {
                expanded: option.isExpanded,
                id: "additionalJobs-accordian-".concat(index),
                style: {
                    width: '100%',
                    boxShadow: 'none',
                    borderRadius: '8px'
                }
            }, /*#__PURE__*/ React.createElement(AccordionSummary, {
                "aria-controls": "panel".concat(index, "a-content"),
                id: "panel".concat(index, "a-header")
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                direction: 'column',
                justifyContent: 'space-between',
                width: "100%",
                paddingRight: 1,
                alignItems: 'center'
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                width: '100%'
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                width: '100%',
                spacing: 1.25,
                alignItems: 'center'
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                direction: 'column',
                width: IS_DESKTOP ? "35%" : '100%'
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                justifyContent: 'flex-start',
                alignItems: "center"
            }, /*#__PURE__*/ React.createElement(Typography, {
                id: "job-item-name-".concat(index),
                variant: "h3",
                sx: {
                    textTransform: 'capitalize'
                }
            }, option === null || option === void 0 ? void 0 : option.ComplaintName)), /*#__PURE__*/ React.createElement(MuiStack, null), IS_DESKTOP ? null : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
                container: true,
                spacing: 2,
                width: '100%',
                alignItems: 'center'
            }, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 6,
                sx: {
                    textAlignLast: 'start',
                    placeContent: 'center'
                }
            }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h4",
                align: "center",
                color: gray,
                whiteSpace: 'nowrap'
            }, "Part (\u20B9)")), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(InputBox, {
                id: "job-item-part-price-".concat(index),
                disabled: !(option !== null && option !== void 0 && option.IsEditable) || isDisabled || option.isExpanded,
                name: option === null || option === void 0 ? void 0 : option.ComplaintName,
                value: (_option$PartPrice3 = option === null || option === void 0 ? void 0 : option.PartPrice) !== null && _option$PartPrice3 !== void 0 ? _option$PartPrice3 : '',
                onChange: function (event) { return handleInputRoadTestPartPriceChange(event, index, option, "PartPrice"); }
                // onBlur={calculateAmount}
                ,
                size: "small",
                inputProps: {
                    inputMode: 'decimal',
                    pattern: '[0-9]*[.,]?[0-9]*'
                },
                sx: {
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #DEE4EB",
                    borderRadius: "8px",
                    ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input": {
                        padding: "8.5px 5px"
                    },
                    ".css-km5qz1-MuiInputBase-root-MuiOutlinedInput-root": {
                        fontSize: '14px'
                    }
                }
            }))), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 6,
                sx: {
                    textAlignLast: 'start',
                    placeContent: 'center',
                    justifyContent: 'space-between'
                }
            }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h5",
                align: "center",
                color: gray,
                whiteSpace: 'nowrap'
            }, "Labour (\u20B9)")), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(InputBox, {
                id: "job-item-labour-".concat(index),
                disabled: !(option !== null && option !== void 0 && option.IsEditable) || isDisabled || option.isExpanded,
                name: option === null || option === void 0 ? void 0 : option.CustomerComplaint,
                value: (_option$LabourPrice3 = option === null || option === void 0 ? void 0 : option.LabourPrice) !== null && _option$LabourPrice3 !== void 0 ? _option$LabourPrice3 : '',
                onChange: function (event) { return handleInputRoadTestPartPriceChange(event, index, option, "LabourPrice"); }
                // onBlur={calculateAmount}
                ,
                size: "small",
                inputProps: {
                    inputMode: 'decimal',
                    pattern: '[0-9]*[.,]?[0-9]*'
                },
                sx: {
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #DEE4EB",
                    borderRadius: "8px",
                    ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input": {
                        padding: "8.5px 5px"
                    },
                    ".css-km5qz1-MuiInputBase-root-MuiOutlinedInput-root": {
                        fontSize: '14px'
                    }
                }
            })))))), IS_DESKTOP && /*#__PURE__*/ React.createElement(MuiStack, {
                width: '65%',
                justifyContent: 'space-around'
            }, /*#__PURE__*/ React.createElement(MuiStack, null, IS_DESKTOP ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
                container: true,
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                spacing: 2
            }, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 6,
                sm: 6
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                display: 'block',
                justifyContent: 'space-between',
                alignItems: 'center'
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h4",
                align: "left",
                color: gray,
                sx: {
                    pr: '4px'
                }
            }, "Part (\u20B9)"), /*#__PURE__*/ React.createElement(InputBox, {
                disabled: !(option !== null && option !== void 0 && option.IsEditable) || isDisabled || option.isExpanded,
                name: option === null || option === void 0 ? void 0 : option.ComplaintName,
                value: (_option$PartPrice4 = option === null || option === void 0 ? void 0 : option.PartPrice) !== null && _option$PartPrice4 !== void 0 ? _option$PartPrice4 : '',
                onChange: function (event) { return handleInputRoadTestPartPriceChange(event, index, option, "PartPrice"); }
                // onBlur={calculateAmount}
                ,
                size: "small",
                inputProps: {
                    inputMode: 'decimal',
                    pattern: '[0-9]*[.,]?[0-9]*'
                },
                sx: {
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #DEE4EB",
                    borderRadius: "8px",
                    ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input": {
                        padding: "8.5px 5px"
                    },
                    ".css-km5qz1-MuiInputBase-root-MuiOutlinedInput-root": {
                        fontSize: '14px'
                    }
                }
            }))), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 6,
                sm: 6,
                sx: {
                    textAlignLast: 'start',
                    placeContent: 'center',
                    justifyContent: 'space-between'
                }
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                display: 'block',
                justifyContent: 'space-between',
                alignItems: 'center'
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h5",
                align: "right",
                color: gray,
                whiteSpace: 'nowrap',
                sx: {
                    pr: '4px'
                }
            }, "Labour (\u20B9)"), /*#__PURE__*/ React.createElement(InputBox, {
                disabled: !(option !== null && option !== void 0 && option.IsEditable) || isDisabled || option.isExpanded,
                name: option === null || option === void 0 ? void 0 : option.CustomerComplaint,
                value: (_option$LabourPrice4 = option === null || option === void 0 ? void 0 : option.LabourPrice) !== null && _option$LabourPrice4 !== void 0 ? _option$LabourPrice4 : '',
                onChange: function (event) { return handleInputRoadTestPartPriceChange(event, index, option, "LabourPrice"); }
                // onBlur={calculateAmount}
                ,
                size: "small",
                inputProps: {
                    inputMode: 'decimal',
                    pattern: '[0-9]*[.,]?[0-9]*'
                },
                sx: {
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #DEE4EB",
                    borderRadius: "8px",
                    ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input": {
                        padding: "8.5px 5px"
                    },
                    ".css-km5qz1-MuiInputBase-root-MuiOutlinedInput-root": {
                        fontSize: '14px'
                    }
                }
            }))))) : null), IS_DESKTOP ? /*#__PURE__*/ React.createElement(MuiStack, {
                alignItems: "center"
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h3",
                fontWeight: 500,
                sx: {
                    pl: '10px',
                    pr: '2px',
                    width: '80px',
                    color: "#1B1D21"
                }
            }, "\u20B9", ' ', (Number((_option$PartPrice5 = option === null || option === void 0 ? void 0 : option.PartPrice) !== null && _option$PartPrice5 !== void 0 ? _option$PartPrice5 : 0) + Number((_option$LabourPrice5 = option === null || option === void 0 ? void 0 : option.LabourPrice) !== null && _option$LabourPrice5 !== void 0 ? _option$LabourPrice5 : 0)).toFixed(2))) : null, /*#__PURE__*/ React.createElement(MuiStack, {
                alignItems: 'center'
            }, IS_DESKTOP && RoadTestCustomerComplaintAccordianActions(option, index))))))), /*#__PURE__*/ React.createElement(AccordionDetails, null, /*#__PURE__*/ React.createElement(MuiStack, {
                width: '100%',
                spacing: 2,
                direction: IS_DESKTOP ? 'row' : 'column'
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                width: '100%',
                borderRadius: '8px'
            }, /*#__PURE__*/ React.createElement(MuiSelectComponent, {
                id: "reject-reason-dropdown",
                margin: 0,
                fullWidth: true,
                options: rejectReasonRemarkList || [],
                caption: "cancellation reason",
                displayExpr: "DisplayName",
                valueExpr: "id",
                name: "rejectReason",
                value: (_option$RejectReasonR6 = option.RejectReasonRemark) !== null && _option$RejectReasonR6 !== void 0 ? _option$RejectReasonR6 : "",
                onChange: function (event) { return handleSelectRoadTestAndCustomerComplaintrejectReason(event, index); },
                disabled: isDisabled,
                isMandatory: true
            })), /*#__PURE__*/ React.createElement(MuiStack, {
                width: '100%',
                borderRadius: '8px'
            }, /*#__PURE__*/ React.createElement(InputBox, {
                multiline: true,
                rows: 1
                // sx={{ height: '44px' }}
                ,
                id: "remark-input",
                placeholder: t("Enter remarks"),
                onChange: function (event) { return handleChangeRoadTestAndCustomerComplaintRejectRemark(event, index); },
                fullWidth: true,
                size: "small",
                value: (_option$DeclinedRemar6 = option.DeclinedRemarks) !== null && _option$DeclinedRemar6 !== void 0 ? _option$DeclinedRemar6 : "",
                disabled: isDisabled
            })))))), !IS_DESKTOP && /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                paddingX: 2
            }, /*#__PURE__*/ React.createElement(Divider, {
                style: {
                    width: '100%'
                }
            }))), /*#__PURE__*/ React.createElement(MuiStack, {
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%'
            }, !IS_DESKTOP && RoadTestCustomerComplaintAccordianActions(option, index), !IS_DESKTOP && /*#__PURE__*/ React.createElement(MuiStack, {
                display: 'flex',
                justifyContent: 'end',
                alignItems: 'center',
                px: 2
            }, /*#__PURE__*/ React.createElement(Typography, {
                id: "job-item-total-price-".concat(index),
                variant: "h3",
                fontWeight: 500,
                sx: {
                    pl: '5px',
                    width: '80px',
                    color: "#1B1D21"
                }
            }, "\u20B9", ' ', (Number((_option$PartPrice6 = option === null || option === void 0 ? void 0 : option.PartPrice) !== null && _option$PartPrice6 !== void 0 ? _option$PartPrice6 : 0) + Number((_option$LabourPrice6 = option === null || option === void 0 ? void 0 : option.LabourPrice) !== null && _option$LabourPrice6 !== void 0 ? _option$LabourPrice6 : 0)).toFixed(2)))), option.errorMessage && /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                paddingX: 2,
                pb: 1
            }, /*#__PURE__*/ React.createElement(FormHelperText, {
                sx: {
                    color: 'red'
                }
            }, option.errorMessage))))));
        })), /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            item: true,
            justifyContent: "flex-end",
            alignItems: "center",
            padding: 1
        }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
            loading: loader.isLoaderOpen,
            variant: "outlined",
            size: "small",
            color: "primary",
            style: {
                width: "60px"
            },
            name: roadTestText,
            onClick: saveRoadTest,
            id: "saveRoadTestEstimate",
            disabled: !disabledSave.RoadTest
        }))) : /*#__PURE__*/ React.createElement(React.Fragment, null, !roadTestSkeleton && /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: "center",
            alignItems: "center"
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3"
        }, " ", "No data found"))), roadTestSkeleton && /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column',
            style: {
                height: '50px'
            }
        }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)))))) : null;
    }) : null, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            // border: "1px solid #DEE4EB",
            backgroundColor: "#F4F7FA",
            borderRadius: "0px 0px 12px 12px",
            padding: "16px"
        },
        justifyContent: "space-between",
        padding: 3,
        spacing: 2
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3"
    }, " ", t("Total Estimated Cost")), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        id: "estimated-cost",
        sx: {
            whiteSpace: 'nowrap'
        }
    }, "\u20B9 ", calculateJobCost(allJobs, roadTestData).cost.toFixed(2)))), /*#__PURE__*/ React.createElement(PartLabourDetailsDrawer, {
        jobItemDetails: selectedJobItemDetails,
        open: isOpenJobItemDetailsDrawer,
        onClose: function (updatedItem) {
            handleClose(updatedItem);
        },
        SystemName: ESystemName.Estimate,
        isDisabled: Boolean((selectedJobItemDetails === null || selectedJobItemDetails === void 0 ? void 0 : selectedJobItemDetails.isExpanded) || moduleSection == 'PM_PARTS' || isDisabled),
        jobItemType: moduleSection,
        setHasUnsavedChanges: setHasUnsavedChanges
    }), selectedStandardJobItemDetails && /*#__PURE__*/ React.createElement(StandardJobsPartLabourDetailsDrawer, {
        jobItemDetails: selectedStandardJobItemDetails,
        open: isOpenStandardJobDetailsDrawer,
        onClose: function (updatedList) {
            handleCloseStandardJobsDrawer(updatedList);
        },
        SystemName: ESystemName.Estimate,
        showCheckbox: false,
        isDisabled: true
    }));
}
